export default [ { ID:"2",
    FULL_NAME:"Robert Caldwell",
    EMAIL:"Robert.R.Caldwell@Dartmouth.edu",
    INSTITUTION:"Dartmouth College (Physics & Astronomy)",
    DEPARTMENT:"",
    Q1_FACULTY:"13 male, 5 female",
    Q2_STUDENT:"27 male, 11 female",
    Q3_POLICY:"The Dartmouth Guarini School of Graduate and Advanced Studies' child accommodation policy is designed to assist a graduate student, who is the primary child-care provider, immediately following the birth or adoption of a child. The policy does not intend to replace communication between the student and his or her advisors, but rather serves to establish a uniform and supportive guideline for graduate students. Under the child accommodation policy, a full-time stipend-supported graduate student is eligible for up to twelve weeks of accommodation from his or her graduate program. Under most circumstances, the Guarini School of Graduate and Advanced Studies will provide up to six weeks of support and the student's department will provide up to six weeks of support during this period. If a student is supported by a funding mechanism that is incompatible with this accommodation policy, or if a student's program is unable to provide matching support, the Guarini School of Graduate and Advanced Studies will provide up to twelve weeks of support. In the event that both parents are full-time graduate students, the benefit by this policy can be shared between the parents as they choose, but the total amount of accommodation provided will not exceed twelve weeks. During this period of accommodation, the graduate student will continue to be enrolled and will receive their full level of stipend support and health benefits. In addition, an automatic one-term extension will be granted to complete their degree. The Guarini School of Graduate and Advanced Studies requires the graduate student to discuss his or her plans for accommodation with the Assistant Dean and his or her advisors as soon as possible, but, in any case, in advance of the leave in order to allow adequate planning. https://graduate.dartmouth.edu/policy/child-accommodation-policy",
    Q4_INSURANCE:"Health insurance coverage for dependents beyond the student is available to purchase at a reasonable rate. Health insurance for the student is included as a supplement to the tuition waiver and stipend. https://sites.dartmouth.edu/gsc/healthcare",
    Q5_FRIENDLY:"Foremost, Dartmouth College offers a cutting-edge PhD research program in physics and astronomy. In addition, the environment is definitely welcoming to women scientists and students, who comprise over 25% of tenure/tenure-track faculty, graduate students, and PhD recipients in the last 10 years. Thanks to the small size of our graduate program, all of our students have the opportunity for close faculty interactions and mentoring. Small classes and research groups provide a non-intimidating learning and research environment. Specific programs such as Dartmouth's Women in Science Project and the Physics And Astronomy Women group also offer career guidance and support for women.",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"",
    UPDATED_ON:"Mon Sep 16 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"21",
    TENURE_WOMEN_NUM:"5",
    GRAD_TOTAL_NUM:"46",
    GRAD_WOMEN_NUM:"20",
    POSTDOC_TOTAL_NUM:"10",
    POSTDOC_WOMEN_NUM:"7",
    WOMEN_GROUP:"Yes. Physics And Astronomy Women group, has been meeting once per quarter, for the last five years. Undergraduates through faculty attend.",
    PHYSICS_GSA:"No.",
    OTHER_STUGRP:"Graduate Student Council https://sites.dartmouth.edu/gsc \\\\n Postdoc Association https://sites.dartmouth.edu/dcpda/",
    UNDERGRA_WOMCONF:"No. But we are making plans to do so.",
    SITE_VISIT:"No.",
    CONTACT_INFO:"Kristina Lynch (Kristina.A.Lynch@dartmouth.edu) Robert Caldwell (Robert.R.Caldwell@dartmouth.edu)" },
  { ID:"4",
    FULL_NAME:"Richard Rand",
    EMAIL:"rjr@unm.edu",
    INSTITUTION:"University of New Mexico",
    DEPARTMENT:"",
    Q1_FACULTY:" 29/4",
    Q2_STUDENT:" 110/21",
    Q3_POLICY:"No formal dept policy, cases handled individually",
    Q4_INSURANCE:"Health insurance is included for all grad students. Students may opt to cover spouses and dependents at their own cost.",
    Q5_FRIENDLY:"We have a good fraction of female grad (and undergrad, by the way) students.  We have six female faculty out of 29, rising to at least 7 out of 31 next fall, well above the national average for PhD granting physics institutions. UNM has an NSF ADVANCE 5 year program to promote women and minority STEM faculty.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:" 12/1",
    UPDATED_ON:"Mon Sep 16 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"29",
    TENURE_WOMEN_NUM:"6",
    GRAD_TOTAL_NUM:"97",
    GRAD_WOMEN_NUM:"16",
    POSTDOC_TOTAL_NUM:"7",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"No",
    PHYSICS_GSA:"Yes.  https://physics.unm.edu/pandaweb/graduate/gsa.php",
    OTHER_STUGRP:"SPS.  Sigma Pi Sigma.  Astronomy On Tap.",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"Yes.  1993.",
    CONTACT_INFO:"Richard Rand rjr@unm.edu" },
  { ID:"11",
    FULL_NAME:"Mirtha M Cabello",
    EMAIL:"cabello@bu.edu",
    INSTITUTION:"Boston University",
    DEPARTMENT:"",
    Q1_FACULTY:"Tenured males: 35 Tenured females: 3 Tenured track males: 2 Tenured track females: 1 ",
    Q2_STUDENT:"94/19",
    Q3_POLICY:"There is a graduate student parental leave policy in which a student can take a semester off with no tuition or other charges.  The student health insurance also covers normal pregnancy expenses.  A similar leave policy also extends for male students.",
    Q4_INSURANCE:"Yes and yes (as fringe benefits)",
    Q5_FRIENDLY:"Despite the small percentage of women in our program, the female members of the department are active in the physics community.  The Boston University Women in Physics organization hosts social and educational events open to the entire department, works towards the acceptance of the graduate student parental leave policy, and supports the goals of the Graduate Women in Science and Engineering Organization at Boston University.  The department  supports women's issues including the stated goals of the Women in Physics.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"17 male 2 female",
    UPDATED_ON:"Mon Sep 23 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"38",
    TENURE_WOMEN_NUM:"6",
    GRAD_TOTAL_NUM:"81",
    GRAD_WOMEN_NUM:"11",
    POSTDOC_TOTAL_NUM:"20",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"Yes. http://physics.bu.edu/pages/show/women_in_physics",
    PHYSICS_GSA:"Yes.  GSO. https://www.bu.edu/gso/",
    OTHER_STUGRP:"Graduate Student Council. http://physics.bu.edu/grad/page/gsc",
    UNDERGRA_WOMCONF:"No.",
    SITE_VISIT:"No.",
    CONTACT_INFO:"Mirtha Cabello, cabello@bu.edu" },
  { ID:"14",
    FULL_NAME:"Stephen Zepf",
    EMAIL:"zepf@msu.edu",
    INSTITUTION:"Michigan State University",
    DEPARTMENT:"",
    Q1_FACULTY:"Female: 6; male: 54 In addition, we have 6 female research faculty who are not on tenure-track; so there is a substantial number of female faculty members to interact with students.",
    Q2_STUDENT:"Female: 27; male: 113",
    Q3_POLICY:"Yes. Duties will be waived by department, while stipend continues.  Graduate assistants have a right to return to the same appointment after family/medical leave is over. We also have an emergency service to provide care for sick children at their homes.",
    Q4_INSURANCE:"Yes,  but it is only partially included in stipend.",
    Q5_FRIENDLY:"Over the past 20 years at MSU, either the president or the provost (and sometimes both) have been women. This is the most visible part of as dedicated effort across the board to take diversity, equity, and inclusion seriously at MSU. A notable example specific to the Physics and Astronomy Department is our hosting of a very successful CUWiP in Jan 2019.  Female graduate students have formed WaMPS (Women and Minorities in the Physical Sciences), and the department supports this organization financially and logistically. The department has also introduced a holistic rubric in its graduate admissions, and has seen a rising number of incoming female graduate students each of the past two years this has been used.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"",
    UPDATED_ON:"Tue Oct 08 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"57",
    TENURE_WOMEN_NUM:"9",
    GRAD_TOTAL_NUM:"221",
    GRAD_WOMEN_NUM:"40",
    POSTDOC_TOTAL_NUM:"0",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"Yes, WaMPS. https://msu.edu/~wamps/",
    PHYSICS_GSA:"Yes. https://web.pa.msu.edu/PGO/",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"Yes, Jan 2019",
    SITE_VISIT:"No",
    CONTACT_INFO:"Professor Kirsten Tollefson, associate chair for the graduate program tollefson@pa.msu.edu" },
  { ID:"19",
    FULL_NAME:"Baha  Balantekin",
    EMAIL:"baha@physics.wisc.edu",
    INSTITUTION:"University of Wisconsin, Madison",
    DEPARTMENT:"",
    Q1_FACULTY:"41 tenured faculty, 5 female 36 male (12% female) 5 tenure-track faculty, 2 female 3 male (40% female) ",
    Q2_STUDENT:"178 graduate students, 36 female, 142 male (20% female)",
    Q3_POLICY:"While there is no institutional guarantee of leave, the department is committed to assisting our graduate students during this important time in their lives.",
    Q4_INSURANCE:"Family health insurance is available to graduate students. Typical employee share of the premium is $15 per month but depend on specific plan.  For more information, please visit:  http://www.bussvc.wisc.edu/ecbs/benefits/newemp-stategrouphealth.html",
    Q5_FRIENDLY:"We have excellent research programs in a broad range of areas (see http://physics.wisc.edu), and we strive to be a friendly, open, and supportive department in which all students, staff, and faculty have the opportunity and support to learn effectively and perform exceptional research.  Our efforts to increase diversity and to support underrepresented groups are aided greatly by strong institutional support, including support for outside lecturers and other events from the Provost and from the WISELI (Women in Science and Engineering Leadership Institute) program.  More evidence of the strong institutional support for diversity is that five out of eight chairs of science departments in the College of Letters and Sciences are women.  There is on-campus day care at which students have top priority for spaces.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"54 post doctoral research associates, ",
    UPDATED_ON:"Fri Sep 14 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"44",
    TENURE_WOMEN_NUM:"7",
    GRAD_TOTAL_NUM:"185",
    GRAD_WOMEN_NUM:"30",
    POSTDOC_TOTAL_NUM:"6",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"Yes, no website",
    PHYSICS_GSA:"Yes, no website",
    OTHER_STUGRP:"N/A",
    UNDERGRA_WOMCONF:"Yes, 2018",
    SITE_VISIT:"Yes",
    CONTACT_INFO:"" },
  { ID:"22",
    FULL_NAME:"Paula Perry",
    EMAIL:"paula@physics.wm.edu",
    INSTITUTION:"College of William and Mary",
    DEPARTMENT:"",
    Q1_FACULTY:"26 male/4 female",
    Q2_STUDENT:"46 male/20 female",
    Q3_POLICY:"Yes.  During or after a pregnancy, or after an adoption or the start of foster care, the department will provide up to 6 weeks paid leave at the student's request.  At the student's request, additional unpaid leave up to 14 weeks will be provided.  The student may also request part time status and duties for up to a total of 28 weeks. Requests for leave beyond 28 weeks will be treated on a case by case basis.",
    Q4_INSURANCE:"Yes.  In addition to the stipend, the department pays the premium of the student's health insurance and half the cost of that for a dependent(s)(up to limits based on our coverage available through the university).",
    Q5_FRIENDLY:"Aside from the wide range of research programs available within the department of physics, or in association with our adjunct faculty at the Thomas Jefferson National Accelerator Facility and at the NASA Langley Research Center, women graduate students come to the College of William and Mary because our faculty members work hard to provide a stimulating and nurturing environment.  Proof of this is in the numbers of women here.  From our introductory undergraduate classes (40% of these students are women), to our majors (27% of our graduating majors have been women over the last five years), to our graduate program (31% of our entering Ph. D. students have been women over the last six years), women are a major part of all the physics department's programs.  Partly, this is because we form a welcoming community, as is necessary in a small town. Events hosted by the College, by the department or by the Physics Graduate Students Association can be an important break from research and studies.  Roughly 20% of our graduate students are married, and several have children (some born while their parent was a student here).  But, it is not just the faculty who believe we maintain an outstanding climate.  When the American Physical Society's Committee on the Status of Women in Physics made a site visit to William and Mary, they concluded: Of the 21 departments that have participated in the site visit program to date, this department certainly is in the top 5%.  And even closer to home, when our undergraduate majors decide to return to William and Mary for a Ph.D. degree in physics, returning women outnumber men by a ratio of 3:2.  Women graduate students are no longer unusual here; instead, they are a vital part of our community.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"13 male/0 female",
    UPDATED_ON:"09-JUN-11",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"24",
    FULL_NAME:"Maggie Jensen",
    EMAIL:"mejensen@email.unc.edu",
    INSTITUTION:"University of North Carolina at Chapel Hill",
    DEPARTMENT:"",
    Q1_FACULTY:"25 males, 5 females",
    Q2_STUDENT:"72 males, 20 females",
    Q3_POLICY:"6 weeks of parental leave with full tuition and stipend support, one semester extension of academic deadlines.",
    Q4_INSURANCE:"Family health insurance is available for purchase by the student, it is not included in the stipend.",
    Q5_FRIENDLY:"As a physics & astronomy department we are leaders in women faculty representation, including leadership positions such as associate and department chairs. The wider UNC environment is also showing signs of greater involvement of women in leadership roles, ranging from chairs of STEM departments, to our university chancellor. These changes have coincided with initiatives at our department to provide a more welcoming environment specifically to URM, women, and non-traditional students, such as the overhaul of the doctoral qualifier exams, the modernization of the graduate curriculum, a new faculty mentor program for pre-qual students, and a designation of upper level graduate tutors for incoming graduate students. In addition, the department acquired APS Bridge partnership status in 2016, with the goal of further diversifying the graduate student population. Our department is also family-friendly for faculty, staff, and students, including several women faculty who have had children in recent years. The local environment is an excellent place to start a family, with world-class medical centers (UNC and Duke) and an excellent public school system. UNC sits in the NC triangle formed by Raleigh, Durham, and Chapel Hill, an area with a rapidly growing economy offering job opportunities in biotechnology, academia / education, computer engineering, and a variety of STEM fields; as such, it is an excellent place for dual-career couples looking to relocate.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"",
    UPDATED_ON:"Wed Sep 26 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"31",
    TENURE_WOMEN_NUM:"8",
    GRAD_TOTAL_NUM:"78",
    GRAD_WOMEN_NUM:"16",
    POSTDOC_TOTAL_NUM:"8",
    POSTDOC_WOMEN_NUM:"1",
    WOMEN_GROUP:"Yes, we have an active Women in Physics organization as of 2018.  https://physics.unc.edu/undergraduate-program/student-organizations/women-in-physics/",
    PHYSICS_GSA:"No.",
    OTHER_STUGRP:"UNC has over 600 student groups.  Two groups that may be of particular interest are: \\\\n 1. Graduate and Professional Student Federation (GPSF): Provides money for travel grants, hosts social and volunteer events. \\\\n 2. Student Parent Association: Resources and support for pregnant and parenting students, postdoctoral fellows, and medical residents.",
    UNDERGRA_WOMCONF:"No.",
    SITE_VISIT:"No.",
    CONTACT_INFO:"Amy Oldenburg, Associate Professor and Department Diversity Liaison.  aold@physics.unc.edu" },
  { ID:"25",
    FULL_NAME:"Shane Hutson",
    EMAIL:"shane.hutson@vanderbilt.edu",
    INSTITUTION:"Vanderbilt University",
    DEPARTMENT:"",
    Q1_FACULTY:"25 male, 5 female (includes one joint appointment with EECS)",
    Q2_STUDENT:"55 male, 19 female",
    Q3_POLICY:"Yes.  Students on TAs or university fellowships are guaranteed six weeks paid parental leave following a birth or adoption if they are the primary caregiver.",
    Q4_INSURANCE:"Yes, family health insurance is available, but the additional cost is not included in the stipend.",
    Q5_FRIENDLY:"We have dramatically increased the number of women in our department who are tenured or tenure-track faculty. We have also taken several steps to improve the climate for female students and postdocs in our department. First is the creation of a Climate Committee that serves as a sounding board for graduate student and postdoc concerns. Second, we sponsor a monthly lunch for the graduate students, which I and our Director for Graduate Studies attend.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"20 male, 5 female",
    UPDATED_ON:"Tue Sep 25 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"26",
    TENURE_WOMEN_NUM:"6",
    GRAD_TOTAL_NUM:"63",
    GRAD_WOMEN_NUM:"17",
    POSTDOC_TOTAL_NUM:"29",
    POSTDOC_WOMEN_NUM:"4",
    WOMEN_GROUP:"No",
    PHYSICS_GSA:"No",
    OTHER_STUGRP:"VU-WISE, Vanderbilt University Women In Science and Engineering https://my.vanderbilt.edu/vuwise/",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No",
    CONTACT_INFO:"Shane Hutson shane.hutson@vanderbilt.edu" },
  { ID:"26",
    FULL_NAME:"Suzanne Robblee",
    EMAIL:"su.robblee@neu.edu",
    INSTITUTION:"Northeastern University",
    DEPARTMENT:"",
    Q1_FACULTY:"26 male tenure-track or tenured faculty4 female tenure-track or tenured faculty",
    Q2_STUDENT:"44 Male/9 female",
    Q3_POLICY:"Family leave is required by state law.",
    Q4_INSURANCE:"Graduate students have individual insurance coverage in addition to their stipend.  Family health insurance is under discussion.",
    Q5_FRIENDLY:"The department is very supportive of women at all levels - undergraduate and grad students, postdoctoral fellows, research scientists and faculty.  We frequently send female students to relevant conferences and they have, in turn, made suggestions to improve the climate for gender diversity.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"24 male/3 female",
    UPDATED_ON:"06-AUG-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"27",
    FULL_NAME:"Nils Halverson",
    EMAIL:"Nils.Halverson@colorado.edu",
    INSTITUTION:"University of Colorado (Astrophysical & Planetary Sciences)",
    DEPARTMENT:"",
    Q1_FACULTY:"19 male/3 female",
    Q2_STUDENT:"34 male/14 female",
    Q3_POLICY:"Health benefits for students taking 6 hrs/sem, plus LWOP (time out program) for students taking leave",
    Q4_INSURANCE:"Yes, for qualified TA or RA. Golden Buff Student Health Insurance plan is offered for grad student at $1052/semester (Student Gold plan) plus additional costs for spouse/domestic partner and dependents.  These costs include a considerable (automatic) subsidy paid by the university.  ",
    Q5_FRIENDLY:"The departmental environment at CU Boulder (Dept. of Astrophysical and Planetary Sciences) has gradually come to the point where the numbers of students is one of the highest among physical sciences.  We have probably reached a point where all students are evaluated by their academic credentials and performance, with little self-consciousness about gender-political issues.  This atmosphere permeates our classes, our student-leadership and committees, and professional relationships between grad students, postdocs, and faculty thesis advisors.",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"",
    UPDATED_ON:"19-SEP-18",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"32",
    FULL_NAME:"Viola Bryant",
    EMAIL:"vmbryant@mail.wvu.edu",
    INSTITUTION:"West Virginia University",
    DEPARTMENT:"",
    Q1_FACULTY:"13 male \\\\n 4 female",
    Q2_STUDENT:"65 total \\\\n 54 male, 11 female",
    Q3_POLICY:"Funded graduate students in the Department of Physics and Astronomy may, on occasion, require an alternate workload assignment for the birth/adoption of a child, a personal, serious health condition,or to care for an immediate family member with a serious health condition. In these rare circumstances,every effort should be made to protect the annualized lecturer's or funded graduate student's stipend and appointment. The alternate workload policy applies to full-time, enrolled graduate teaching assistants who are in good academic standing and making  satisfactory progress toward completion of their degree. An eligible funded graduate student granted an alternate workload assignment receives 100 percent of his/her stipend and other benefits associated with the appointment for up to six weeks or until the last day of the appointment, whichever comes first.",
    Q4_INSURANCE:"Yes. It is part of the stipend and families can be added at additional cost.",
    Q5_FRIENDLY:"At West Virginia University, the mentoring of graduate students (female and male) goes beyond the typical faculty-student interaction that occurs at most universities. Because we are a modest sized department, the faculty work closely with the students and take an active role in promoting their careers during and after their graduate research. Our female faculty play critical roles within the department and the respect accorded to them by the rest of the faculty serves as a good model for the student population. We seek the very best faculty and students that we can recruit to WVU, demand outstanding teaching and research from the faculty, and strive to reward faculty and student success independently of gender, ethnic origin, or race.  WVU is an APS Bridge Member Institution and we have applied for Partnership status.  This means we are actively working to improve diversity in the physics community and have committed to providing both peer and faculty mentoring (beyond their research groups) to all students in future years as we strive to foster a supportive environment for all students.  Further, to help increase awareness of diversity issues, and make the department more supportive of under-represented groups, we have an active Diversity, Equity, and Inclusivity Committee that provides training for members of the department, runs a DEI Journal Club, and serves as a resource for all students on these issues.  Students interested in WVU would be best served by looking at our track record in training and then placing graduate students (both male and female) into good, post-graduate positions.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"9 \\\\n 5 male, 4 female",
    UPDATED_ON:"Fri Dec 13 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"26",
    TENURE_WOMEN_NUM:"7",
    GRAD_TOTAL_NUM:"79",
    GRAD_WOMEN_NUM:"15",
    POSTDOC_TOTAL_NUM:"19",
    POSTDOC_WOMEN_NUM:"3",
    WOMEN_GROUP:"Yes. https://www.hsc.wvu.edu/awis/",
    PHYSICS_GSA:"Yes. They do not have a web site.",
    OTHER_STUGRP:"WVU SPS  (Society of Physics Students)",
    UNDERGRA_WOMCONF:"No, but we hosted a conference for undergraduate women in astronomy:  https://sites.google.com/view/cuwia/home.  We applied to host CUWiP in 2021.",
    SITE_VISIT:"No",
    CONTACT_INFO:"Viola Bryant  vmbryant@mail.wvu.edu" },
  { ID:"36",
    FULL_NAME:"KU Phsyics and Astronomy",
    EMAIL:"physics@ku.edu",
    INSTITUTION:"University of Kansas (Physics and Astronomy)",
    DEPARTMENT:"",
    Q1_FACULTY:"23/3",
    Q2_STUDENT:"49/9",
    Q3_POLICY:"Yes. The complete policy can be found at http://policy.ku.edu/kulc-academic-accommodation-new-parents",
    Q4_INSURANCE:"Yes, but it is not included in the stipend.",
    Q5_FRIENDLY:"From its very first graduating class, women have played a key role at the University of Kansas. The Department of Physics and Astronomy offers a stimulating research environment with programs in a wide variety of areas, including astrophysics, biophysics, condensed matter physics, cosmology, high energy experimental physics, high-energy theory, space physics, and nuclear physics. The Department of Physics and Astronomy is among the top in the nation for the number and percentage of women faculty. Presently, the department boasts two University Distinguished Professors who are women. Two of our three teaching professorships are held by women. Two woman graduate students have been awarded the Madison and Lila Self Graduate Fellowship, providing for four years of support during their Ph.D. studies (https://selfgraduate.ku.edu/). Additionally, each semester, the women faculty and staff host a lunch to bring together women postdocs, graduate students and undergraduate students to foster fellowship and networking across the department's many disciplines.This has become even more vital now that our department is housed in two buildings. To further our efforts on behalf of women, the department was honored to host a Conference for Undergraduate Women in Physics (CUWiP) in January, 2018. In addition, our department became a Bridge Program Partner Institution in March, 2019. The work of the department is done on the very attractive KU campus located at the center of Lawrence, Kansas. Lawrence is a progressive town with excellent schools, good health care providers, and a large range of cultural and recreational activities.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"11/2",
    UPDATED_ON:"Tue Oct 13 2020",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"28",
    TENURE_WOMEN_NUM:"6",
    GRAD_TOTAL_NUM:"62",
    GRAD_WOMEN_NUM:"12",
    POSTDOC_TOTAL_NUM:"15",
    POSTDOC_WOMEN_NUM:"5",
    WOMEN_GROUP:"We have a Diversity in Physics Group. Their Facebook page is located at: https://www.facebook.com/groups/kuphysicsdiversity/",
    PHYSICS_GSA:"No",
    OTHER_STUGRP:"No",
    UNDERGRA_WOMCONF:"Yes. We hosted in 2018.",
    SITE_VISIT:"No",
    CONTACT_INFO:"Kristin Rennells - tatekris@ku.edu" },
  { ID:"38",
    FULL_NAME:"William Fornes",
    EMAIL:"wfornes@purdue.edu",
    INSTITUTION:"Purdue University",
    DEPARTMENT:"",
    Q1_FACULTY:"48 male/8 female",
    Q2_STUDENT:"122 male/22 female",
    Q3_POLICY:"Yes. Graduate staff are eligible for three working days per fiscal year paid leave for immediate family illness. Immediate family is defined as spouse, parents, children, grandparents, grandchildren, sisters, brothers, and corresponding in-laws and steprelatives. Family members not included here, but who reside in the employee's home, are considered immediate family.  The Family and Medical Leave Act of 1993 provides provision for time off for an employee’s own serious health condition, to take care of a family member with a serious health condition, to give birth, to adopt, or to place a child in the employee’s home for foster care. In order to be eligible for leave, under the FMLA, graduate staff must have been employed at Purdue for 12 months,  consecutive or nonconsecutive, and have worked at least 1,250 hours in the 12 months preceding the date leave commences. FMLA states that up to 12 work-weeks of leave per year are available. If the leave is taken for an employee’s own serious health condition or a family member’s serious health condition, and the employee has accrued unused paid sick leave and qualifies for paid sick leave, the employee must use the paid sick leave during the FMLA leave.",
    Q4_INSURANCE:"Yes. No.",
    Q5_FRIENDLY:"The Department of Physics and Astronomy at Purdue works hard to provide an environment comfortable for female students within our department and program of study.  First, the department currently has 8 female faculty members (14%) who are very engaged with female students in the department.  Second, through most of the last ten years, the Department has made special efforts to recruit women into its graduate program.  We currently offer a Special Initiative Fellowship for incoming female students each year.  Third, there is an active Women in Physics program in the department to provide a strong mentoring and social component for female students, faculty and staff.  Female graduate students, postdocs, and faculty meet monthly over dinner to discuss current topics ranging from strategies for job seeking and conflicting roles women face between their research and their families to personal safety issues and opening lines of communication between men and women.  Finally, the College of Science at Purdue University maintains a Graduate Mentoring Program through its Women in Science Programs (WISP).  The Graduate Mentoring Program is a series of dinner meetings that feature a speaker in a relevant field, allows busy, dedicated scientists to share their experiences with one another at a convenient time. These meetings are invaluable in that they provide contact with role models, who are successful women in science, to the students in science. In addition, these meetings provide an opportunity to increase informal networking between faculty members and graduate students.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"11 male/1 female",
    UPDATED_ON:"Wed Oct 10 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"56",
    TENURE_WOMEN_NUM:"8",
    GRAD_TOTAL_NUM:"151",
    GRAD_WOMEN_NUM:"22",
    POSTDOC_TOTAL_NUM:"19",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"Yes - http://www.physics.purdue.edu/wip/",
    PHYSICS_GSA:"Yes - http://www.physics.purdue.edu/pgsa/",
    OTHER_STUGRP:"Women in Science Program - https://www.science.purdue.edu/wisp/",
    UNDERGRA_WOMCONF:"Yes - 2015, 2011",
    SITE_VISIT:"",
    CONTACT_INFO:"Bill Fornes, Assistant Head, wfornes@purdue.edu" },
  { ID:"39",
    FULL_NAME:"Sandra Tranquilli",
    EMAIL:"sandra.tranquilli@yale.edu",
    INSTITUTION:"Yale University  (Physics and Applied Physics Departments)",
    DEPARTMENT:"",
    Q1_FACULTY:"Physics:            30 male    5 female Applied Physics:    10 male    1 female",
    Q2_STUDENT:"Physics:            90 male   18 female Applied Physics:    14 male    6 female",
    Q3_POLICY:"Yes.  Graduate students may take a leave of absence for parental responsibility for reasons of pregnancy, maternity care, or paternity care.  For many students, short-term arrangements, rather than a full leave of absence, are possible if desired.  Eligible PhD students can apply for and will receive a Health Award from the Graduate School to cover the cost of the Student Affiliate Coverage Plan for the remainder of the term in which the leave is started.  Additional options are described in the Bulletin of the Graduate School. ",
    Q4_INSURANCE:"Yes.  For single students, standard health insurance is paid by the Graduate School.  For couples and families, 50% of the health insurance cost is paid by the Graduate School.  The other 50% is paid by the student.  Full details about the Yale Health Plan can be found at: http://www.yale.edu/yhp/for_students/student_hb/studenthb.pdf http://www.yale.edu/graduateschool/visitors/healthCare.html",
    Q5_FRIENDLY:"The Yale University departments of Physics and Applied Physics provide a welcoming and collegial atmosphere for all students.   Our faculty take their teaching and research guidance responsibilities seriously and we have a good track record for entering students successfully completing their degrees.  A number of opportunities for both mentoring and being mentored exist within the departments and on campus.  For further information about our graduate programs, please see our web pages http://www.yale.edu/physics/ http://www.eng.yale.edu/aphy/index.html and feel free to contact the Director of Graduate Studies (dgs.physics@yale.edu) who will be happy to answer your questions or put you in touch with some of our women graduate students. Our current Chair of the Physics Department is Meg Urry, who has been very active on the topic of Women in Physics. Women students may be interested to learn more about:  Women In Science At Yale (WISAY) is a group of over two-hundred graduate students and post doctoral fellows who are interested in issues that pertain to women in science. WISAY creates a campus-wide network of scientists across many scientific disciplines and provides the opportunity for Yale scientists to meet with leading women scientists from Yale and around the country. Our goals as an organization include: \\\\n * Networking with premiere women scientists through seminars and discussions \\\\n * Mentoring Yale undergraduates who are interested in science \\\\n * Supporting each other by sharing our own experiences and ideas  http://www.yale.edu/wisay/ ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"Physics:              37 male    9 female",
    UPDATED_ON:"28-AUG-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"42",
    FULL_NAME:"Leo Piilonen",
    EMAIL:"physchr@vt.edu",
    INSTITUTION:"Virginia Tech",
    DEPARTMENT:"",
    Q1_FACULTY:"4 female faculty members (1 full professor, 3 associate professors) out of 30 total.",
    Q2_STUDENT:"13 female and 64 male graduate students (total of 77).",
    Q3_POLICY:"Family leave is provided under the Family and Medical Leave Act. In addition, the  Virginia Tech Graduate School, in collaboration with the college deans and the provost, has established a Work-Life Grant Program to provide temporary financial assistance to departments to enable them to continue support for female graduate students during pregnancy and childbirth. Departments can request financial assistance equivalent to a graduate assistantship stipend for six weeks. The Graduate School will provide one half of the stipend and the college dean will provide the other half. These funds may be used in a variety of ways to ensure that the research effort is not adversely impacted and the graduate student continues to be supported while she is on leave. For more details, see http://www.grads.vt.edu/worklife/ ",
    Q4_INSURANCE:"Family health insurance is available for graduate students; however, it is not included in the stipend. For the graduate student himself/herself, assistantship packages now include a $1,030 medical insurance benefit, covering seventy percent of the university-sponsored health insurance plan (for a single student at the $50,000 coverage level). ",
    Q5_FRIENDLY:"The physics department at Virginia Tech is a close-knit community whose members ¿ faculty, students, and staff ¿ know each other well. This community offers personal connections in a large state university which, in turn, offers a wide range of choices. The department houses several internationally recognized research groups.  Women are quite well represented amongst faculty (4 out of 24; 17%), graduate students (8 out of 49; 16%), and undergraduates (22 out of 139; 16%). Male faculty are fair and respectful towards their female colleagues (I was the only female faculty member for several years here, and never sensed any discomfort, open or hidden biases from my male colleagues). The department is also very diverse with regards to ethnic and national origins. The department chair and most of the senior faculty are aware of the special challenges which women and minorities may face and are willing to step in if problems arise.   Female students and female faculty hold a regular social, called the ¿Ladies of Robeson¿ (named after our building) which is very popular. This informal group helps new female students make contacts more quickly, removes barriers between faculty and students, and has also generated much closer interactions between graduate and undergraduate female students.  The two staff members who coordinate the undergraduate and the graduate program keep an eye on unexpected changes in attendance, homework activity or grades, so that problems can usually be caught before they become critical. They provide student support far beyond their job descriptions: Students with emergencies can count on their help at all hours of the day and night (literally!). The graduate coordinator is foreign-born and has a particular heart for our international students. Finally, we have a very active SPS chapter here which reaches out to all physics students and organizes a variety of events for the whole department.  ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"2 female and 7 male (total of 9).",
    UPDATED_ON:"02-AUG-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"43",
    FULL_NAME:"Richard W. Robinett (on behalf of Jayanth Banavar, Department Chair)",
    EMAIL:"rick@phys.psu.edu",
    INSTITUTION:"Penn State University",
    DEPARTMENT:"",
    Q1_FACULTY:"As of Fall 2011, the Penn State Physics Department has 41 tenured or tenure-track faculty, 7 female and 34 male.",
    Q2_STUDENT:"As of Spring 2011, the Physics Department has 125 grad students, 109 male and 16 female.",
    Q3_POLICY:"Graduate assistants who meet the requirements for parental accommodation will be excused from their regular activities for a period of up to six weeks immediately following the birth or adoption of a child. During this time, individuals will continue to receive the same income and benefits as provided previously by the University. Approval of accommodation will automatically extend deadlines--for any academic or research reports, class or work assignments, dissertation proposals or related work, and other responsibilities--for the duration of the accommodation period. Faculty and other mentors are expected to work with graduate assistants to make fair and appropriate alternative arrangements during the accommodation period. Individuals should be permitted to defer course grades until the following semester, and deadlines for academic milestones, including candidacy, comprehensive examinations, and final defense, will be postponed or extended for one semester. Individual parties are required to work collaboratively to ensure these minimums, but should feel free to negotiate additional accommodations. Indeed, additional accommodations may be necessary, especially in medically critical situations. More information is available at http://forms.gradsch.psu.edu/current/newparentaccomodationguideline.pdf.",
    Q4_INSURANCE:"Graduate Assistants or Fellows are eligible to receive subsidies in the amount of 80% of the annual premium cost for the Graduate Assistant and Graduate Fellow Insurance Plans. The university pays the 80% directly to the insurance companies, and the remaining 20% is paid through monthly payroll deductions. Insurance subsidies for eligible dependents is 70% of the annual premium expense. As with the subsidy for individual insurances, the university pays 70% of the premium expense directly to the insurance companies, and the remaining 30% is paid through monthly payroll deductions. Details of the insurance plan are available at http://www.sa.psu.edu/uhs/basics/insurance.cfm, with complete information on prescription, dental, and vision benefits.",
    Q5_FRIENDLY:"The Physics Department at Penn State University provides graduate students with the opportunity to collaborate with world-class scientists doing cutting-edge research in a wide variety of fields. PSU has active efforts in condensed matter, gravitational physics, atomic, molecular, and optical physics, experimental particle physics and observational particle astrophysics, theoretical particle physics and string theory, and biological physics, including systems biology and computational neuroscience. Female faculty and graduate students play an integral role in essentially all of the research groups in the Physics department. Penn State as a whole has also demonstrated a strong commitment to having women in faculty and administrative positions at all levels, with a number of recent appointments at the faculty, department chair and Dean's level.  All graduate students in the Physics Department benefit from a wide range of support ranging from faculty mentoring, extensive TA training (both at the start of their graduate career and regularly as part of their TA duties), workshops on ethics and sexual harassment issues, and frequent sharing of information (via an active listserve) on issues related to graduate studies, employment opportunities, and departmental activities. Each incoming graduate student is assigned a mentor (outside of their research field) with whom they can consult at all stages of their graduate career. There are two ombudspersons in place (one female, one male) with whom all faculty, staff, and graduate students can consult about any issue. The department administration holds regular 'feedback/input’ meetings with all first year graduate students (twice a year) to hear about any issues which students wish to  share about their graduate experience (coursework, TA duties, facilities). All students are required to take a year-long ‘first year graduate seminar’ which focuses on the transition to graduate life, career opportunities, and scientific ethics and communication skills. There are very active departmental and College-wide `climate' committees, as well as a mentoring program for female physics (and astronomy/astrophysics) students (especially through the very active Physics and Astronomy for Women or PAW group), at both the undergraduate and graduate level, both recommendations made by the Committee on the Status of Women in Physics who visited the PSU Physics in 2001 at our invitation. The PAW group won an Eberly College of Science ‘Climate and Diversity Award’ in 2016 for their work in mentoring other female students (including undergraduate majors).  Physics faculty, postdocs, and graduate students have made use of on-campus day care facilities in recent years.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"The Physics Department has 22 postdocs, 3 of whom are female.",
    UPDATED_ON:"Wed Sep 19 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"50",
    TENURE_WOMEN_NUM:"9",
    GRAD_TOTAL_NUM:"143",
    GRAD_WOMEN_NUM:"27",
    POSTDOC_TOTAL_NUM:"27",
    POSTDOC_WOMEN_NUM:"3",
    WOMEN_GROUP:"The Penn State Physics Department has an active 'Physics and Astronomy for Women' organization with a web site at http://sites.psu.edu/pawwebsite/ where it describes their activities as follows: \\\\\\n PAW is a student club dedicated to advancing the status of women in Physics and Astronomy by providing a network of support and a forum to discuss issues faced by women in these fields.  Anyone is welcome to join us for social events, outreach activities, and more! \\\\n PAW is a relatively young club that has been blooming in recent years. Established in 2011, PAW has organized and been involved in: \\\\n * Professional development workshops focusing on topics such as how to write a resume and how to use business cards effectively \\\\n * Many outreach activities \\\\n * Various social events \\\\n * Lunches with renowned speakers \\\\n * Monthly tea breaks to socialize and keep us sane throughout the year =) \\\\n * CUWiP - a conference for undergraduate women in physics – hosted at Penn State in 2014 \\\\n * much more! \\\\nPAW also has an active presence on Facebook at https://www.facebook.com/groups/pawpsu/ \\\\n The PAW group was honored with the 2016 Eberly College of Science Climate and Diversity Award.",
    PHYSICS_GSA:"The Physics Graduate Student Association (PGSA) focuses more on social activities than professional development issues.",
    OTHER_STUGRP:"There is an active Graduate (and Professional) Student Association (GPSA) which sponsors a number of social and/or professional development activities throughout the year - more information available at https://gpsa.psu.edu/ Graduate students are included on a number of departmental and college level committees. As might be guessed, at a large public institution there are any number of student organizations, groups, clubs to engage students on a wide variety of personal and professional interests. There are over 1000 undergraduate and graduate student organizations with more information available at http://clubs.psu.edu",
    UNDERGRA_WOMCONF:"Penn State hosted one of the 2014 CUWiP (Conference for Undergraduate Women in Physics). More information about that event is still available at http://sites.psu.edu/ncuwip/  A number of the graduate student organizers of the 2014 CUWiP meeting were also responsible for the inaugural Mid-Atlantic APS section meeting held here at PSU in 2014 -- more information about that event is still available at http://sites.psu.edu/midatlanticaps/",
    SITE_VISIT:"The Physics Department hosted an APS 'Climate Site Visit for Women and Minorities in Physics' in 2001.",
    CONTACT_INFO:"Prof. Richard Robinett \\\\n Associate Department Head and Director of Graduate and Undergraduate Studies \\\\n Physics Department - Penn State University \\\\n rq9@psu.edu" },
  { ID:"44",
    FULL_NAME:"Stephen Kevan",
    EMAIL:"kevan@uoregon.edu",
    INSTITUTION:"University of Oregon (Physics)",
    DEPARTMENT:"",
    Q1_FACULTY:"27 male; 1 female",
    Q2_STUDENT:"70 male; 20 female",
    Q3_POLICY:"The latest GFT contract with the University states that a student may take up to 12 weeks of unpaid leave for childbirth and/or care, major illness, or spousal care.  A graduate student can take an unpaid leave of absence for personal reasons. Department head and research supervisors recognize the existence and importance of family responsibilities, work with students to understand and accommodate their needs, and establish and implement flexible and responsive practices whenever possible to accommodate employee needs in ways that remain consistent with the goal of graduate education.",
    Q4_INSURANCE:"Graduate students receive individual health insurance benefits as part of their stipend.  Family members can be included at a subsidized rate. During the 2008-2009 academic year, the value of the health insurance benefit for an individual is approximately $818 per quarter and ranges up to $2047 per quarter for a family. This policy and the rates noted above are subject to a collective bargaining agreement between the University and the Graduate Teaching Fellow Federation. ",
    Q5_FRIENDLY:"We are a moderate-sized physics department at a university with a strong tradition in the liberal arts and sciences.  Our Department includes many highly productive and well-funded research groups.  We provide a high quality physics education with faculty members who are committed to helping students hone their skills in a setting that remains very informal. The natural sciences at the University of Oregon have a strong interdisciplinary flavor.  The departments are in close spatial and intellectual proximity.  The Physics Department has strong connections to several vibrant research institutes and centers (http://physics.uoregon.edu/physics/research.html).  Aside from supporting doctoral research, all these units maintain strong ties to academic, industrial, and government laboratories around the  world. The University supports an active Women in Graduate Sciences Group (http://www.uoregon.edu/~uowgs/) that focuses on helping women within interdisciplinary sciences to develop into successful scientists.  The group sponsors workshops, mentors, and community outreach, and fosters networking and communication skill development. Women in Technology and Science (WITS - http://uoregon.edu/~wits/wits/home/index.php) is a UO initiative that aims to increase the success of women in science, math, and computing. The WITS Fund provides seed funding for student scholarships, research funds, travel grants, and faculty support. WITS will also promote outreach programs designed to increase access to scientific research and discovery among underrepresented groups. Our Department is heavily involved in several K-12 and community outreach activities with a particular emphasis on students from lower socioeconomic backgrounds (http://physics.uoregon.edu/physics/outreach.html).  Interested graduate students are encouraged to participate in these activities.   Our Department has a strong internal committee structure to guide departmental affairs.  Graduate students participate actively in this committee system; their input is strongly encouraged and has lasting impact.   Our Department sponsors several social activities throughout the year.  The quality of life in Eugene is quite high and forms a nice complement to the strong graduate education offered by our Department.  ",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"2 male; 2 female",
    UPDATED_ON:"09-JUN-09",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"46",
    FULL_NAME:"Bridgitt Ayers",
    EMAIL:"bdickey@rice.edu",
    INSTITUTION:"Rice University",
    DEPARTMENT:"",
    Q1_FACULTY:"42/5",
    Q2_STUDENT:"101/20",
    Q3_POLICY:"Yes, please see: http://rgs.rice.edu/GradStudNotebook/pp/med-mat-leave.cfm",
    Q4_INSURANCE:"Yes. No. However, the university provides a subsidy of approximately 75% of the insurance premium.",
    Q5_FRIENDLY:"The undergraduate physics program at Rice University is attractive to female students  because: Female students need to see women active in traditionally male fields such as        physics.  The Physics Department at Rice University currently counts four female professors among the faculty.  Female students see these women as mentors showing you can have a career in science and balance a personal life. In Spring, 2009, the female faculty, post doctoral associates and graduate students formed the Women in Physics group in order to network with other women in the sciences. Every year female students have the opportunity to listen to accomplished women in the field who are invited to present colloquia and seminars to the department.  Beginning physics classes are taught by young instructors, students find them friendly, accessible, and can easily relate to them.  The department encourages an open-door policy that allows all students to come in anytime to discuss classes, plans, or personal matters.  This climate is particularly attractive to female students. ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"10/3",
    UPDATED_ON:"30-SEP-09",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"51",
    FULL_NAME:"Davor Balzar",
    EMAIL:"balzar@du.edu",
    INSTITUTION:"University of Denver (Physics and Astronomy)",
    DEPARTMENT:"",
    Q1_FACULTY:"10 tenure-track or tenured faculty -- 7/3",
    Q2_STUDENT:"27 graduate students -- 17/10",
    Q3_POLICY:"No",
    Q4_INSURANCE:"No family health insurance. Student health insurance is provided for full-time, full-year GTAs/GRAs, paid for by the University.",
    Q5_FRIENDLY:"Recently, our department was named in a report from the American Institute of Physics for our high percentage (30-40%) of female PhD graduates from the years 2013-2017. Our program was also recognized by the APS among US PhD-granting departments for our high percentage (50%) of female graduates: placing second nationally at the undergraduate level and third at the graduate level (APS data for the period 2011-2013).",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"5 post doctoral associates - 4/1",
    UPDATED_ON:"Thu Sep 12 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"12",
    TENURE_WOMEN_NUM:"3",
    GRAD_TOTAL_NUM:"20",
    GRAD_WOMEN_NUM:"6",
    POSTDOC_TOTAL_NUM:"1",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"No.",
    PHYSICS_GSA:"There is a Graduate Student Association at the University level.",
    OTHER_STUGRP:"Society of Physics Students--most members are the undergraduate level.",
    UNDERGRA_WOMCONF:"No.",
    SITE_VISIT:"No.",
    CONTACT_INFO:"Davor.Balzar@du.edu, Chair" },
  { ID:"52",
    FULL_NAME:"Christine Bolang",
    EMAIL:"physics.sso@umich.edu",
    INSTITUTION:"University of Michigan",
    DEPARTMENT:"",
    Q1_FACULTY:"47/12",
    Q2_STUDENT:"89/25",
    Q3_POLICY:"Graduate Student Instructors are eligible for up to three weeks of leave in a 12-month period if they are unable to meet employment obligations because of personal illness, injury, or other disabling medical condition or due to the illness, injury or other disabling medical condition of a family member.  In addition Graduate Student Instructors, upon request, will be granted a Parental Accommodation Period to not exceed six weeks after the birth or adoption of a child.  The University is also in full compliance with the Family Medical Leave Act (FMLA).",
    Q4_INSURANCE:"Health insurance is available free of charge to graduate students with employment fractions at or higher than 25% and most department-sponsored fellowship recipients.  Coverage for family members may be purchased by the graduate student.",
    Q5_FRIENDLY:"The UM Department of Physics is committed to a top-notch graduate education for members of the world community.  We strive to foster an environment of collaboration and high-level scholarly activity between female graduate students, their colleagues, and the entire faculty.  Women are encouraged to participate in a variety of groups on campus formed with the specific needs of women in mind:  WISE (Women in Science and Engineering), AWIS (Association for Women in Science) and SWIP (Society of Women in Physics) are just a few examples.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"",
    UPDATED_ON:"02-JUN-11",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"53",
    FULL_NAME:"Yves Idzerda",
    EMAIL:"Idzerda@physics.montana.edu",
    INSTITUTION:"Montana State University",
    DEPARTMENT:"",
    Q1_FACULTY:"14 male/3 female",
    Q2_STUDENT:"47 male/11 female",
    Q3_POLICY:"Any graduate student may take up to three semesters off without detailed application or appeal. There is no provision for paying students on leave. Our department is an engaged and strong advociate for our students, working to accommodate any special needs or situations that may require special considerations.",
    Q4_INSURANCE:"Family health insurance is available. The Physics Department covers the health insurance costs for the student, but additional expenses for spouse/family coverage must be covered by the student.",
    Q5_FRIENDLY:"Our department is well known for its opportunities to pursue top quality research in an extremely collegial, student-friendly environment. As a relatively small department, we do not have research groups in all conceivable fields of physics, but what we have (astrophysics, relativity, cosmology; solar physics; optics; condensed matter; physics education) we do well. ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"4 male/ 2 female",
    UPDATED_ON:"28-APR-14",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"54",
    FULL_NAME:"Bulbul Chakraborty",
    EMAIL:"bulbul@brandeis.edu",
    INSTITUTION:"Brandeis University",
    DEPARTMENT:"",
    Q1_FACULTY:"15 male and 3 female. ",
    Q2_STUDENT:"35 male and 4 female",
    Q3_POLICY:"No official policy.  Mutual agreement between theses advisors and students has worked well.",
    Q4_INSURANCE:"Student insurance is covered by the university, addition family membership paid by student.  It is not included in the stipend.",
    Q5_FRIENDLY:"There has been a history of female graduate students working with all faculty members in the department. Following is a partial list of female Phd's from different groups in the last few years: \\\\n Condensed Matter Experiment: Kirstin Purdy, now Postdoc at University of Illinois-Urbana-Champagne. \\\\n Condensed Matter theory: Allison Ferguson, now postdoc at U. Toronto, Silke Henkes, now postdoc at Leiden. \\\\n Neuroscience: Caroline Geisler, now Postdoc at Rutgers. \\\\n Astrophysics: Leslie Brown, now Professor and Chair, Connecticut College. \\\\n High Energy Experiment: Dana Partos, now working in industry. \\\\n High Energy Theory: Marci Knutt, Research Associate, McGill University, Montreal, Quebec, Canada. \\\\n Brandeis collaborates with 4-year women's colleges in the area, which promotes interaction with other female faculty and students:  \\\\n Yue Hu (Wellesley) \\\\n Nalini Easwar (Smith) \\\\n Shubha Tiwari (Mount Holyoke) \\\\n Female students have expressed a preference for a small department like ours which encourages discourse between faculty and students.",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"",
    UPDATED_ON:"01-JUN-11",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"55",
    FULL_NAME:"Sarah Garner",
    EMAIL:"sterrs@astro.washington.edu",
    INSTITUTION:"University of Washington",
    DEPARTMENT:"Astronomy",
    Q1_FACULTY:"12 total - 8 male/4 female",
    Q2_STUDENT:"31 total - 15 male/16 female",
    Q3_POLICY:"Not specifically. Students may apply for on-leave status per quarter basis. (see http://www.grad.washington.edu/Acad/gsmemos/gsmemo09.htm for on-leave details).",
    Q4_INSURANCE:"Family may enroll for the graduate student insurance plan (GAIP). The student premiums are covered in full by the University if they are an eligible TA/RA/SA or fellow/trainee. Eligible dependents (spouse, same sex domestic partner, and children) have their premiums partially covered by the University. (see http://www.washington.edu/admin/hr/benefits/insure/gaip/index.html  for more GAIP information).",
    Q5_FRIENDLY:"The UW Astronomy department has a strong commitment to diversity of all kinds, including providing a supportive atmosphere for female astronomers. Our female faculty members conduct cutting-edge research and win national grants while serving as role models and mentors to graduate students, who in turn mentor undergraduates through programs such as Pre-MAP (http://www.astro/washington.edu/premap). UWAWA (UW Association of Women  in Astronomy), in which women in the department have potluck dinners  about once a quarter, has been a tradition for many years and is now threatening to outgrow our dining rooms. Our latest group of entering graduate students consisted of 3 men and 2 women, indicating both that the admissions process does an excellent job of identifying talented female astronomers and that our department comes across as an appealing place for female graduate students. The faculty care about implementing policies that promote the general happiness of all graduate students, and they generally solicit grad student input for major decisions. The UW as a whole is committed to advancing women in sciences through programs like ADVANCE (http://www.engr.washington.edu/advance/), WISE (http://www.engr.washington.edu/wise/) and the faculty/graduate student mentoring program (http://www.engr.washington.edu/cwd/CWDMentoringFacGrad.html). See our department's page on diversity (http://www.astro.washington.edu/diversity.html) for more information.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"21 total - 15 male/6 female",
    UPDATED_ON:"20-SEP-19",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"59",
    FULL_NAME:"Karen Bjorkman",
    EMAIL:"karen@astro.utoledo.edu",
    INSTITUTION:"University of Toledo",
    DEPARTMENT:"Physics & Astronomy",
    Q1_FACULTY:"Female     3 Male       19",
    Q2_STUDENT:"female    10 male      44",
    Q3_POLICY:"There is no official family leave policy for graduate students.  The University of Toledo adheres to the national Family Medical Leave Act.  In our department we make individual arrangements depending upon the circumstances.  ",
    Q4_INSURANCE:"Graduate students appointed on a University-funded assistantship are eligible to receive a subsidy co-payment on the premium paid for the University Student Health Insurance.  Graduate students who qualify for the insurance subsidy would pay an annual premium.   Graduate students who are supported on grant funding (research assistants) often have their health insurance costs paid by the grant.  International students are automatically enrolled in the student health insurance at the time of registration. ",
    Q5_FRIENDLY:"With three women faculty in the department (including, at present, the chair), and a number of female graduate and undergraduate students, our department offers a welcoming environment for women interested in physics and astronomy.  Our department is friendly and supportive, with activities to encourage informal interaction between faculty and students.  On campus we have an active chapter of the Association for Women in Science.  We also have mentoring programs for women in science areas.  We provide opportunities for both graduate and undergraduate students  to work directly with faculty in research efforts  in many different areas, from the development of new solar cells to the workings of lasers, and from the structure of the atom to the formation of planets, stars, and galaxies, and the nature of the universe.  Our laboratory facilities are extensive and include state-of-the-art solar cell deposition equipment, several accelerators, and a 1-meter telescope (the largest in Ohio) with a high-dispersion spectrograph which is used for ongoing research by students and faculty.  Our faculty are world-class researchers in many areas, with particular strengths in materials science and photovoltaics and astronomy & astrophysics.  On the academic side, most of our classes are small and offer significant one-on-one interaction with faculty, several of whom are designated as Master Teachers.  We think of our students as part of the family, and do everything we can to provide the mentoring, training, and opportunities for them to succeed in their chosen area of study.  Our placement record for graduating students in good postdoctoral positions or industry jobs is excellent. ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"female  2 male    10",
    UPDATED_ON:"02-OCT-09",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"60",
    FULL_NAME:"Roger Tobin",
    EMAIL:"roger.tobin@tufts.edu",
    INSTITUTION:"Tufts University",
    DEPARTMENT:"",
    Q1_FACULTY:"15 male 2 female",
    Q2_STUDENT:"20 male, 9 female",
    Q3_POLICY:"There is no official family leave policy, however, our department (Physics and Astronomy) has granted extended leaves in individual cases. The Graduate School is considering adopting a formal policy.",
    Q4_INSURANCE:"The Tufts Graduate School pays 100% of the required student health insurance and 100% of the required health service fee for all doctoral students in their first three years. Family coverage is also available.",
    Q5_FRIENDLY:"As an institution, Tufts University is strongly committed to diversity in all its forms, including increasing the representation of women in science and engineering. The Physics/Astronomy department shares that commitment, as the ratio of female/male students indicates. The modest size of our graduate program means that each student is treated as an individual and evaluated and guided on the basis of his or her abilities and performance. ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"",
    UPDATED_ON:"10-JUN-11",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"62",
    FULL_NAME:"Haiyan Gao",
    EMAIL:"gao@phy.duke.edu",
    INSTITUTION:"Duke University",
    DEPARTMENT:"",
    Q1_FACULTY:"24/5",
    Q2_STUDENT:"59/17",
    Q3_POLICY:"Yes, there is a family leave policy, it may be used for health or personal reasons.",
    Q4_INSURANCE:"Yes, Duke offers a family health insurance plan.  No it is not included in their stipend.",
    Q5_FRIENDLY:"The physics department at Duke University has quite a few females. Interaction among the women of this department is encouraged by having lunch together a few times a year among and other social events. Most feel included and respected in research and classes. Also, recently the department has its first female Chair in its history. I believe this will have a positive impact on the overall female-friendliness of the department.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"25/5",
    UPDATED_ON:"03-SEP-13",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"64",
    FULL_NAME:"Brett D. DePaola",
    EMAIL:"depaola@phys.ksu.edu",
    INSTITUTION:"Kansas State University",
    DEPARTMENT:"",
    Q1_FACULTY:"1 females 25 males ",
    Q2_STUDENT:"16 females 53 males",
    Q3_POLICY:"Yes. https://www.k-state.edu/grad/student-success/graduate-handbook/chapter1.html#Academic%20Accommodation%20and%20Leave%20for%20Pregnant%20and%20Parenting%20Graduate%20Students",
    Q4_INSURANCE:"Yes. There is family health insurance for graduate students. It is not included as part of the student stipend.",
    Q5_FRIENDLY:"The K-State Physics Department recognizes the importance of equity, diversity and inclusion in academia and the STEM disciplines in particular and is committed to working toward these goals. We have a very active Physics Department EDI committee composed of students, faculty and staff members, and a Women in Physics committee of our Physics Graduate Student Council. K-State is consistently ranked very highly in national reviews of student satisfaction and campus climate.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"3 female 25 male",
    UPDATED_ON:"Wed Oct 20 2021",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"26",
    TENURE_WOMEN_NUM:"2",
    GRAD_TOTAL_NUM:"57",
    GRAD_WOMEN_NUM:"18",
    POSTDOC_TOTAL_NUM:"16",
    POSTDOC_WOMEN_NUM:"1",
    WOMEN_GROUP:"Yes",
    PHYSICS_GSA:"Yes",
    OTHER_STUGRP:"https://www.k-state.edu/student-involvement/organizations/",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No. However, we held our own external Physics Department Climate Survey & Site Visit in 2020 with one of its main emphases on women and minorities.",
    CONTACT_INFO:"Kim Coy - graduate@phys.ksu.edu" },
  { ID:"75",
    FULL_NAME:"Hanno Weitering",
    EMAIL:"smedlin@utk.edu",
    INSTITUTION:"University of Tennessee",
    DEPARTMENT:"",
    Q1_FACULTY:"34 tenured and tenure-track faculty members 31 male, 4 female",
    Q2_STUDENT:"123 graduate students 109 male, 14 female",
    Q3_POLICY:"Not per say, but there is a minimum of 1 year and/or a minimum of 1250 hours on a job.  This would qualify you for family medical leave.",
    Q4_INSURANCE:"Yes, there is an option of family health insurance.  It is NOT included in the graduate student stipend.  Insurance is paid only for the graduate student.  Graduate students can purchase family insurance at an additional cost.",
    Q5_FRIENDLY:"A prospective physics student interested in a female-friendly physics department should choose UT because it is a department where the female students are and feel treated with respect and consideration by the faculty and by fellow students. Approximately thirty percent of our undergraduate students and 20% of our graduate students are female. The department currently has four female professors and efforts towards increasing female faculty are being made. Activities to encourage female interaction, such as faculty/students luncheons, are sponsored by the department and weekly pre-colloquium coffees allow for the interaction of students with faculty.  Picnics and get togethers to enjoy the beauty of the nearby Smoky Mountains are also routinely organized. In addition, we provide a strong program with many research opportunities in Condensed Matter, High Energy, Nuclear, Atomic Physics, Astrophysics, Biophysics and Computational Physics not only on campus but also at Oak Ridge National Lab. In short, our department offers a supportive environment to female students as well as a strong scientific program and beautiful surroundings.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"33 post doctoral research associate 25 male, 8 female",
    UPDATED_ON:"17-SEP-19",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"76",
    FULL_NAME:"Mu-Chun Chen",
    EMAIL:"muchunc@uci.edu",
    INSTITUTION:"University of California, Irvine (Physics and Astronomy)",
    DEPARTMENT:"",
    Q1_FACULTY:"42 male, 8 female",
    Q2_STUDENT:"110 male, 24 female",
    Q3_POLICY:"Graduate students are allowed for 4-weeks of paid sick leave and six weeks of paid leave for childbirth. [https://grad.uci.edu/funding/employment/child-care.php] Students can request a Leave of Absence for reasons including family leave, employment, health, etc. They can request up to 3 quarters of leave.",
    Q4_INSURANCE:"The quarterly fees cover the student's health insurance. Family health insurance is not part of the quarterly fees. Students can purchase health insurance for their family [https://shc.uci.edu/insurance/uc-ship-benefits-and-information/voluntary-enrollment] There are childbirth accommodation where graduate students can be reimbursed for qualified childbirth expenses. [https://grad.uci.edu/funding/employment/child-care.php] Further benefits include DepCare FSA allowing students to pay for eligible child/adult dependents on a pretax basis.",
    Q5_FRIENDLY:"UCI had an NSF ADVANCE Institutional Transformation grant to promote gender equity in the hiring and advancement of faculty. As of March 2021, the Department of Physics and Astronomy now  has 12 women faculty (23%), and thus our graduate students have visible women role models. Over the last  few years, we have seen a rapid increase in the number of women graduate students: Women now make up 30% of the graduate students in the Department of Physics & Astronomy. UCI has convenient and affordable on-campus housing for graduate students and their families. Women graduate students can take a leave of absence for family leave for up to three quarters.  Excellent on-campus daycare for infants, toddlers and preschool children of undergraduate and graduate students is subsidized by UCI. Some of the efforts our department has made to make our department more inclusive includes establishing and enforcing the Department code of conduct, the formation of the Department Inclusive Excellence Committee, and the regular Department colloquia and town halls to discuss equity and inclusion. We are part of the APS-IDEA alliances and have hosted and participated in APS CUWiPs. For more information about our efforts towards inclusion, see https://www.physics.uci.edu/inclusion",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"25 male, 8 female",
    UPDATED_ON:"Fri Mar 26 2021",
    IS_ACTIVE:"true",
    PLANS:"Develop and implement a paid maturity leave policy for graduate students. Expand outreach efforts to increase gender diversity of both the undergraduate and graduate populations.",
    TENURE_TOTAL_NUM:"53",
    TENURE_WOMEN_NUM:"12",
    GRAD_TOTAL_NUM:"153",
    GRAD_WOMEN_NUM:"46",
    POSTDOC_TOTAL_NUM:"81",
    POSTDOC_WOMEN_NUM:"17",
    WOMEN_GROUP:"Yes. UCI Womxn in Physics and Astronomy (WiPA).  [https://sites.uci.edu/womeninphysics/]",
    PHYSICS_GSA:"Yes. Physics Graduate Caucus (PGC). [https://sites.uci.edu/physicsgradcaucus/]",
    OTHER_STUGRP:"Physics & Astronomy Community Excellence (PACE) Mentoring Program for Graduate Students. [https://uci-pace.github.io/index.html] Physics and Astronomy Resonance Mentoring Program for Undergraduate Students. [ https://www.physics.uci.edu/resonance ] Diverse Educational Community and Doctoral Experience (DECADE) for graduate students and postdocs [https://www.grad.uci.edu/about-us/diversity/decade/] DECADE PLUS, leadership program for undergraduate students. [https://grad.uci.edu/about-us/diversity/decade/decade-plus.php] Graduate Students are also represented on our Department Committee on Inclusive Excellence. [https://www.physics.uci.edu/inclusion]",
    UNDERGRA_WOMCONF:"Yes. We hosted CUWiP2020 at UCI. [https://sites.uci.edu/cuwip2020/]",
    SITE_VISIT:"Yes. In 2017, we had the APS CSWP Climate Site Visit for Women in Physics for our Department.",
    CONTACT_INFO:"Professor Mu-Chun Chen (muchunc@uci.edu) Vice Chair for Graduate Studies" },
  { ID:"77",
    FULL_NAME:"Joan Perras",
    EMAIL:"perraj@rpi.edu",
    INSTITUTION:"Rensselaer Polytechnic Institute",
    DEPARTMENT:"",
    Q1_FACULTY:"23 total, 19 Male, 4 Female     ",
    Q2_STUDENT:"Total 74 Males 63  Females 11 ",
    Q3_POLICY:"There is personal leave/leave of absence which doesn't stop the clock with regards to years to finish their degree but under this there are exceptions: maternity, miltary and medical which will stop the clock.",
    Q4_INSURANCE:"There is family health insurance available. There are no fees included in stipend.",
    Q5_FRIENDLY:"Our department provides an excellent environment to pursue M.S. and Ph.D. degrees in Physics or Multidisciplinary Science. Our diverse faculty, assisted by our friendly and knowledgeable administrative staff, work hard every day to see our graduate students succeed. We take pride in the academic and professional accomplishments of our students and alumni. The department performs cutting edge research in astronomy, dark matter, particle & fields, condensed matter and optics employing a wide-range of state-of-the-art experimental, theoretical and computational research methods. Our graduates pursue satisfying careers in academia, industrial research & development, sales, consulting and the public sector. Our department stands out among Physics departments in the U.S. because of its large number of women physics faculty. Consequently, our students meet a broad range of role models.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"Total 13, 2 Female",
    UPDATED_ON:"Wed Oct 10 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"16",
    TENURE_WOMEN_NUM:"4",
    GRAD_TOTAL_NUM:"39",
    GRAD_WOMEN_NUM:"4",
    POSTDOC_TOTAL_NUM:"8",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"Yes, https://science.rpi.edu/physics/women-in-physics",
    PHYSICS_GSA:"Not currently. However, the School of Science has a Graduate Student Council, no link is available.",
    OTHER_STUGRP:"The Institute has a number of student groups. Please see: https://union.rpi.edu/clubs.",
    UNDERGRA_WOMCONF:"No.",
    SITE_VISIT:"No.",
    CONTACT_INFO:"Joan Perras, perraj@rpi.edu" },
  { ID:"81",
    FULL_NAME:"Mary Hall Reno",
    EMAIL:"mary-hall-reno@uiowa.edu",
    INSTITUTION:"University of Iowa (Physics and Astronomy)",
    DEPARTMENT:"",
    Q1_FACULTY:"25 male / 4 female",
    Q2_STUDENT:"59 male / 15 female",
    Q3_POLICY:"Graduate students are unionized at the University of Iowa and have sick leave benefits as determined by negotiations between their union and the university.  During the period 2005-2007, graduate students are entitled to 13.5 paid sick days per academic year.  Up to 5 of these sick days per year may be used for care of a family member.  Graduate students employed as teaching or research assistants are also covered by the Family Medical Leave Act.",
    Q4_INSURANCE:"Yes, health insurance is available at additional cost.  Graduate students employed as either teaching or research assistants receive a substantial university contribution toward these costs. ",
    Q5_FRIENDLY:"Our department offers a student-friendly environment for world class research in a broad range of disciplines.  The Iowa City community is culturally and intellectually stimulating, and it is extraordinarily safe.  With women representing more than 10% of our faculty and more than 15% of our graduate student body, new female graduate students have both role models and peers with whom to interact.  We have shown steady gains in the number of female graduate students in our program, and we are committed to further increasing the representation of women among our undergraduate and graduate students, as well as our faculty.  The department maintains an active connection with the campus WISE program, and we have participated in a site visit by the Committee on the Status of Women in Physics. The report of this committee stated in part: ''The Department has shown a strong interest in the welfare of its students.  It has been very supportive of the undergraduate majors, and has recently made great strides in increasing the number and diversity of the graduate student population.''",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"12 male / 4 female",
    UPDATED_ON:"09-JUN-11",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"82",
    FULL_NAME:"Stuart Vogel",
    EMAIL:"vogel@astro.umd.edu",
    INSTITUTION:"University of Maryland (Astronomy)",
    DEPARTMENT:"",
    Q1_FACULTY:"male: 14 female: 1",
    Q2_STUDENT:"male: 22 female: 14",
    Q3_POLICY:"The University allows students to apply for leaves of absence during their graduate career. The department is understanding of family changes and emergencies, and illness which impact a student's progress. We work with students to find individual solutions which address their needs within the long term goal of achieving a high quality education.",
    Q4_INSURANCE:"Graduate students have the University employee health care choices available to themselves and their families.  The costs are included in their stipend.",
    Q5_FRIENDLY:"The UM Astronomy department combines a welcoming environment with a challenging educational program.  We are committed to helping our graduate students succeed and to providing them with a broad range of research opportunities.  We have an active and open social and intellectual atmosphere with over 30 female students and faculty.  Our interest in diversity and female-friendly policies is exemplified by our co-sponsorship and hosting of the 2009 Women in Astronomy and Space Science meeting.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"Postbaccalaureate researchers: 5/5 Postdoctoral associates: 18/7 Research scientists: 10/5",
    UPDATED_ON:"28-SEP-09",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"86",
    FULL_NAME:"Michael Dine",
    EMAIL:"dine@scipp.ucsc.edu",
    INSTITUTION:"University of California, Santa Cruz",
    DEPARTMENT:"",
    Q1_FACULTY:"19/2",
    Q2_STUDENT:"46/13",
    Q3_POLICY:"The graduate division approves unpaid Leaves of Absence. Leaves of Absence will be granted for sound educational purposes, health reasons, financial problems, and family responsibilities. Consistent with the TA union contract, paid leave is provided in many different instances including military leave, medical leave, family leave, jury duty, maternity leave, and bereavement leave.",
    Q4_INSURANCE:"Graduate Student Health Insurance is provided by the department. Family/spouse/dependent health insurance is available, but is not covered by the department; it must be purchased through the student health center.",
    Q5_FRIENDLY:"The Physics Department at the University of California, Santa Cruz, has a long history of successfully mentoring female students.  We foster and achieve excellence in a non-competitive environment.  Our female students have gone on to highly successful careers including positions in academia, industry, and data science.  Our Committee on Diversity and Climate meets weekly and includes both graduate and undergraduate student representatives.  Graduate students also have a voice in the department through the Graduate Experience Development initiative (GEDi) Council.  Our department hosts a Women in Physics club for both graduate and undergraduate students, a mentoring program, and regular coffee chats with female colloquium speakers.  Broader UCSC campus resources include an active Women in Science and Engineering (WiSE) group and a STEM Career-Life Balance Resource Center.  Our Physics faculty and students have organized two Conference for Undergraduate Women in Physics in 2010 and 2015.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"8/1",
    UPDATED_ON:"Wed Oct 10 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"24",
    TENURE_WOMEN_NUM:"3",
    GRAD_TOTAL_NUM:"75",
    GRAD_WOMEN_NUM:"8",
    POSTDOC_TOTAL_NUM:"20",
    POSTDOC_WOMEN_NUM:"5",
    WOMEN_GROUP:"Yes https://ucscwomeninphysics.wixsite.com/ucscwipa \\\\n Contact Carolyn Gee, cagee@ucsc.edu",
    PHYSICS_GSA:"Yes.  Website below.  Contact student:  Katie Hellier, khellier@ucsc.edu https://www.physics.ucsc.edu/academic-programs/grads/grad-student-life/gedi-council.html",
    OTHER_STUGRP:"Women in Science and Engineering https://graddiv.ucsc.edu/current-students/underrepresented-students/wise.html \\\\n STEM Diversity Programs http://stemdiv.ucsc.edu/",
    UNDERGRA_WOMCONF:"Yes.  2010, 2013",
    SITE_VISIT:"Will host Nov., 2018",
    CONTACT_INFO:"Professor Tesla Jeltema, tesla@ucsc.edu" },
  { ID:"87",
    FULL_NAME:"Joseph Shields, Chair",
    EMAIL:"shields@phy.ohiou.edu",
    INSTITUTION:"Ohio University",
    DEPARTMENT:"",
    Q1_FACULTY:"As of Fall 2017, we have 24 male and 4 female tenure-track/tenured faculty.",
    Q2_STUDENT:" As of Fall 2017, we have 58 male and 18 female graduate students.",
    Q3_POLICY:"Starting in the Fall of 2018, graduate students in good standing with the university, holding a current appointment of at least 15 hour/week, having completed two consecutive semesters in any graduate appointment can benefit of family leave.  As part of the policy, the birth mother, or a parent taking on the role of a primary caregiver, will be provided up to six weeks paid leave of absence; a spouse or domestic partner may be provided with up to three weeks leave. More information can be found here: https://www.ohio.edu/compass/stories/17-18/01/Paid-Parental-Leave-Graduate-Students.cfm",
    Q4_INSURANCE:"Family health insurance is available but is not included in the stipend.",
    Q5_FRIENDLY:"Our department is committed to providing opportunities and a supportive environment for all graduate students, and makes special efforts to allow female students to achieve their full potential as scientists.  Women in Physics and Astronomy, WIPHA (www.phy.ohiou.edu/~wipha/), is a local organization that connects female undergraduate and graduate students, postdocs, and faculty in an informal mentoring network.  The department sponsors monthly WIPHA lunches where members can discuss science, career issues and related topics in an informal setting.  The department overall has a relatively young faculty, a high level of research activity, and a strong tradition of collegiality at all levels.  Our institution is committed to fostering diversity in all dimensions of university life.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"The Department has 2 postdocs, all male.",
    UPDATED_ON:"09-FEB-18",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"93",
    FULL_NAME:"Elizabeth Guyton",
    EMAIL:"eko5r@eservices.virginia.edu",
    INSTITUTION:"University of Virginia",
    DEPARTMENT:"",
    Q1_FACULTY:"30 male/4 female",
    Q2_STUDENT:"79 male/18 female",
    Q3_POLICY:"There is no formal policy, however, we work with the students individually to adjust work assignments to accommodate maternity or family leave needs.",
    Q4_INSURANCE:"Yes, family health insurance is available. The insurance is paid for the student and is not part of the stipend. Additional family membership or dental insurance is paid by the student.",
    Q5_FRIENDLY:"Physics is one of the least diverse of the scientific fields. The Physics Department at the University of Virginia is committed to increasing diversity across the board, from undergraduate students to faculty. Yet increasing the number of underrepresented students, and in particular of female students, is only part of the story. First and foremost, we strive to provide a welcoming environment where everyone can feel at home, as such an environment is the key to success in a rigorous physics program. As an example, we provide Women in Physics luncheons regularly during the semester as a networking opportunity for every female member of the department, from undergraduate prospective majors, majors, graduate students, and postdocs, to faculty. At these events, we discuss the issues one might face being a woman in this field, not only explicit biases, but also implicit ones, and the challenges that many of us face such as how to balance work/study and family duties.  We will also host the upcoming 2018 Conference for Undergraduate Women in Physics (CUWiP) at the University of Virginia. Finally, many of our faculty make outreach visits to local public schools regularly to encourage young females to pursue a math and physics-oriented career path. Women in STEM are and may remain a minority for the next few years, but that should not stop our female members from pursuing the career path they love,  physics, and feeling empowered by such a pursuit. ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"12 male/2 female",
    UPDATED_ON:"17-APR-17",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"97",
    FULL_NAME:"Michael Ritzwoller",
    EMAIL:"michael.ritzwoller@colorado.edu",
    INSTITUTION:"University of Colorado, Boulder",
    DEPARTMENT:"",
    Q1_FACULTY:"45/8",
    Q2_STUDENT:"186/39",
    Q3_POLICY:"There is a university-wide parental leave policy for grad students that is described at: \\\\nhttps://www.colorado.edu/graduateschool/university-colorado-boulder-graduate-student-parental-leave-policy",
    Q4_INSURANCE:"The university pays 70% of the premiums for graduate students health benefits for all graduate students on teaching or research assistantship appointments.",
    Q5_FRIENDLY:"It is our goal to recruit and retain students from all backgrounds, and to provide a positive and supportive environment with good communication between faculty and students. We admit only those students who we are confident from experience can succeed in our  program. We make every effort to see that all students  succeed in their career goals. We offer programs designed to motivate and ensure a sense of community in our department. These include a flexible graduate curriculum with many course and program \\\\noptions, attention to students, sensitivity to the need for role models and a critical mass of underrepresented groups, clear  advising, as well as picnics, coffees, FACs,  and other social events designed to create a good work environment for everyone. \\\\nNine of our 54 tenure-track faculty are women, four full professors, three associate professors, and two assistant professors. Three of our fifteen research faculty members are women. Forty-five of our 264 graduate students are women, including 8 of our 52 first-year students. The women faculty, graduate students and undergraduates are fully integrated and influential in the department. The department has not only been successful internally, but has been a campus leader to address issues important to women faculty and students. \\\\nAt present, 100% of our Ph.D. students are supported by teaching and research assistantships.",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"",
    UPDATED_ON:"Mon May 20 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"54",
    TENURE_WOMEN_NUM:"9",
    GRAD_TOTAL_NUM:"264",
    GRAD_WOMEN_NUM:"43",
    POSTDOC_TOTAL_NUM:"67",
    POSTDOC_WOMEN_NUM:"14",
    WOMEN_GROUP:"Yes. Here is the link: https://www.colorado.edu/physics/women-physics",
    PHYSICS_GSA:"No",
    OTHER_STUGRP:"CU-Prime is a student-led, diversity-focused, and community-oriented organization in the Physics Department, with the goal of improving the culture of physics at CU Boulder through equity and inclusion, allyship, and education. Here is the link: https://sites.google.com/a/colorado.edu/cu-prime/home-1",
    UNDERGRA_WOMCONF:"Yes. The Department of Physics at CU-Boulder hosted a conference from Jan 13-15, 2017.",
    SITE_VISIT:"Yes, CU-Boulder Physics hosted a visit in 1997.",
    CONTACT_INFO:"Prof. Patricia Rankin  patricia.rankin@colorado.edu" },
  { ID:"100",
    FULL_NAME:"Lisa Okun",
    EMAIL:"lokun@odu.edu",
    INSTITUTION:"Old Dominion University",
    DEPARTMENT:"",
    Q1_FACULTY:"20/2",
    Q2_STUDENT:"34/13",
    Q3_POLICY:"There is no official University family leave policy for students.  The Department, however, works with both students and faculty to provide accommodation when leave is required.",
    Q4_INSURANCE:"ODU does not provide family health insurance for graduate students at this time. Subsidized health insurance through United HealthCare is available for graduate students who receive a stipend of $5000 or more a semester. Students pay for enrollment each semester and then receive a subsidy (taxable) to help defray the cost of the insurance. For academic year 2015-2016, the subsidy reimburses students approximately 60% of the cost of the insurance.",
    Q5_FRIENDLY:"We believe that we have created a welcoming and supportive environment at ODU for women in Physics. We have 13 female graduate students and two female faculty members (Gail Dodge and Lepsha Vuskovic). Gail and Lepsha host a Women in Physics dinner twice per semester at their homes.  These dinners include undergraduates, graduate students, postdoctoral research associates and faculty.  The dinners are one avenue for enabling female members of the Department to meet, support and mentor each other.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"5/2",
    UPDATED_ON:"12-DEC-15",
    IS_ACTIVE:"false",
    PLANS:"The ODU Physics Department is expanding into new research areas.  Over the next five years, the principal area of expansion will be Accelerator Science. \\\\n We have recently established a Center for Accelerator Science in partnership with Jefferson Lab.  We have hired a Director for that Center and two new faculty in accelerator physics. \\\\n Accelerator science is very interdisciplinary, involving fundamental and applied as well as experimental and theoretical research opportunities and excellent job prospects. An MS degree program in cooperation with the United States Particle Accelerator School (USPAS) is currently being developed.",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"101",
    FULL_NAME:"David J. Helfand",
    EMAIL:"djh@astro.columbia.edu",
    INSTITUTION:"Columbia University (Astronomy and Astrophysics)",
    DEPARTMENT:"",
    Q1_FACULTY:"There are 14 faculty in the Columbia Astronomy Department, 3 of who are women. There are an additional 13 faculty  (4 women) associated with the department either in the Columbia or Barnard Physics department or at the American Museum of Natural History.",
    Q2_STUDENT:"The Department of Astronomy has 16 male students and 14 female students in the PhD program. This year (2009) 3 of the 6 PhD's awarded were to women. Historical statistics and outcomes can be found at http://www.astro.columbia.edu/graduate-program/graduate-stats.html",
    Q3_POLICY:"The University's policy is to provide a twelve-week suspension of all academic responsibilities for new parents. The three students (all women) who have had children in the past ten years have had paid leaves arranged by the Department.",
    Q4_INSURANCE:"The student's health insurance is covered by the Fellowship each student receives; family health coverage is available for an additional sum.",
    Q5_FRIENDLY:"The relatively large number of female faculty and students in the astronomy and astrophysics program at Columbia results from a conscious effort to create a research and teaching environment welcoming to all. The most important consideration, however, is the outcomes our program achieves. In the five years 2014-2018 (inclusive), 14 of the 24 PhDs awarded by our Department of Astronomy were earned by women of whom two are working in the private sector and 12 hold research or faculty positions at Harvard, Princeton, IAS, Hopkins/STScI, NRAO, Arizona, Michigan, Caltech/JPL, Berkeley, the Flatiron Center for Computational Astronomy, and Rutgers and include Miller, Hubble, Einstein, Simons, and NSF Fellows. Our program, which emphasizes closely mentored research from the first semester and requires a variety of research projects over the first two years allows all students to find the mentor and style of research best suited to their needs and interests. See http://www.astro.columbia.edu/graduate-program.html for program details.",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"",
    UPDATED_ON:"Sun Sep 16 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"16",
    TENURE_WOMEN_NUM:"5",
    GRAD_TOTAL_NUM:"27",
    GRAD_WOMEN_NUM:"12",
    POSTDOC_TOTAL_NUM:"6",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"Yes (centered in Physics; Astronomy is a separate department but our members participate): http://physics.columbia.edu/columbia-society-women-physics",
    PHYSICS_GSA:"No, but there is Graduate School committee with one student representative from each department.",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"Yes, in 2018 (this past January).",
    SITE_VISIT:"No.",
    CONTACT_INFO:"David J. Helfand  djh@astro.columbia.edu" },
  { ID:"106",
    FULL_NAME:"Peter M. Koch",
    EMAIL:"Peter.Koch@stonybrook.edu",
    INSTITUTION:"Stony Brook (Physics and Astronomy)",
    DEPARTMENT:"",
    Q1_FACULTY:"Currently 53 male and 4 female.  We are working to raise the percentage of female faculty members.  ",
    Q2_STUDENT:"Approximately 165 male and 30 female. ",
    Q3_POLICY:"The Stony Brook Childbirth Accommodation Policy (SB-CAP), http://www.grad.sunysb.edu/pdf/admissions/SB-CAP.pdf,  will enable pregnant and child-bearing Graduate School students to maintain full-time, registered student status and facilitate their return to full participation in class work, research, teaching and clinical training. SB-CAP includes provisions for academic extensions, relief from regular teaching and research duties and interim financial support from the Graduate School for students that receive stipend support as Teaching Assistants, Graduate Assistants, or Research Assistants. The SB-CAP guidelines encourage open communication between students, their advisors, Graduate Program Directors and additional supervisors of teaching responsibilities with the goal of accommodating the needs of pregnant and child-bearing graduate students in a manner that minimizes the disruption to their graduate training activities and responsibilities. ELIGIBILITY The current policy states that  pregnant graduate students must inform their program directors, advisors and whomever they are working closely with (i.e. professor) that they wish to take leave by the 24th week of pregnancy.  Students must have the knowledge and consent of their advisor, program directors, professors and a doctor's note to be eligible.  International students will also need to consult with International Services.",
    Q4_INSURANCE:"Yes. Graduate Assistants and Teaching Assistants are insured under the SUNY Student Employee Health Plan (SEHP). Under this plan, the State will pay 90% of the cost of individual coverage and 75% of additional premium cost for dependents. Specific information for holders of F and J visas is provided in Enrollment and Eligibility Requirements (http://www.stonybrook.edu/hr/benefits/state/student_enrollment.shtml). For Research Assistants in research groups supported by grants through the Research Foundation (RF), the percentage splits are the same, with the RF taking the place of the State.",
    Q5_FRIENDLY:"Stony Brook University (SBU) has a very diverse student population, as does our Department, which is proud of and well known for its collegiality.  It provides a welcoming, nurturing environment for all and has a standing Committee on the Status of Women for paying close attention to particular concerns and needs.  With Brookhaven National Laboratory (BNL) only a half-hour away by car, there has always been strong research involvement between BNL scientists and members of our department.  The Scharff-Goldhaber Prize of $1,000 is given annually by BNL to recognize substantial research progress and accomplishments by women graduate students who are either enrolled in physics at SBU or doing Ph.D. research at BNL.  SBU has long participated in the Women in Science and Engineering (WISE) Program - http://www.wise.sunysb.edu/.  (Female) graduate students in our department have the opportunity in the WISE Precollege Program to mentor and inspire young women from nearby high schools brought into research programs on campus.  Similar mentoring opportunities are available in the department's own Laser Teaching Center - http://laser.physics.sunysb.edu/.  We are not just friendly to female graduate students; we are committed to their professional growth as scientists.  ",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"",
    UPDATED_ON:"22-MAR-10",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"110",
    FULL_NAME:"Rick Van Kooten",
    EMAIL:"rvankoot@indiana.edu",
    INSTITUTION:"Indiana University",
    DEPARTMENT:"",
    Q1_FACULTY:"32/5",
    Q2_STUDENT:"82/20",
    Q3_POLICY:"No, although if this situation were to arise the department would certainly accomodate the needs of the students through leaves of absence, etc. ",
    Q4_INSURANCE:"Yes, health insurance is provided.  This is not part of the stipend, but is covered either by the College, or through fellowship and/or grant support.",
    Q5_FRIENDLY:"The Indiana University Physics Department strives to provide a collegial, friendly environment for students during their graduate studies. Students are treated as colleagues, in keeping with the vital role they play in the research and academic missions of the department.  Active Women in Science and Women in Physics chapters provide a forum for female students and faculty to discuss issues that women in the sciences continue to face today. Finally, the Indiana University Physics Department has a proven track record in preparing students for successful careers in Physics, with numerous female IU alumni now in place in the scientific ranks.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"17/5",
    UPDATED_ON:"02-JUN-11",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"115",
    FULL_NAME:"Gang Xiao",
    EMAIL:"Gang_Xiao@brown.edu",
    INSTITUTION:"Brown University",
    DEPARTMENT:"Department of Physics",
    Q1_FACULTY:"24 - male  3 - female",
    Q2_STUDENT:"92 - grad students 78 - male 14 - female",
    Q3_POLICY:"Please see the following Graduate School website for a description of Brown University's Family Leave Policy: http://www.brown.edu/academics/gradschool/childbirth-accommodation-and-family-leave",
    Q4_INSURANCE:"Yes. Students' dependents may be enrolled in SHIP at an additional cost. Eligible dependents include a legal spouse or domestic partner, children up to the age of 26, or a newborn infant born while the student is covered by SHIP. A spouse or partner is generally expected to be living with the covered student in order to be eligible for coverage. Students who receive health coverage through their financial support packages from the University will need to cover the cost of adding dependents to the plan. Additional information can be found at: http://www.brown.edu/academics/gradschool/courses-manual/health-insurance",
    Q5_FRIENDLY:"At the Brown Physics department, we are committed to increasing the representation of women and all historically underrepresented groups in Physics.  Each department at Brown has a Departmental Diversity and Inclusion Action Plan (DDIAP), and our committee meets regularly to strategize, discuss and plan events that foster inclusion for all, in the department.  Brown Physics has seen significant growth in female graduate students in the last few years - in AY18-19 the entering PhD cohort was 39% female, our highest percentage to date.  The DDIAP committee, the admissions committee, and the faculty actively seek to encourage all talented female students to consider Brown.  Interacting with the students and serving as role-models, our female faculty represent every sub-discipline of physics researched at Brown.  The department's WiSE (Women in Science and Engineering) creates a community for women in the sciences and connects female students to Brown science faculty as well as supports women in their pursuit of their careers in science.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"11 - Postdoctoral Research Associates 10 - male 1 - female",
    UPDATED_ON:"Wed Sep 19 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"28",
    TENURE_WOMEN_NUM:"4",
    GRAD_TOTAL_NUM:"135",
    GRAD_WOMEN_NUM:"19",
    POSTDOC_TOTAL_NUM:"14",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"WiSE - (Women in Science and Engineering) provides a variety of academic and social activities to aid the academic and professional development of all its members.  The group is for all undergraduates, graduate students (GWiSE) and postdocs and faculty are also invited to events. https://www.brown.edu/academics/college/support/women-in-science-and-engineering/",
    PHYSICS_GSA:"The Physics graduate students recently organized a group (PhOrg) to foster a strong sense of community support among graduate students in Physics.  And to provide resources for career and student development within the department.",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"Yes",
    CONTACT_INFO:"Mary Ellen Woycik - Student Affairs and Programs Manager mew@Brown.edu" },
  { ID:"118",
    FULL_NAME:"Joshua L Cohn",
    EMAIL:"jcohn@miami.edu",
    INSTITUTION:"University of Miami",
    DEPARTMENT:"",
    Q1_FACULTY:"17 male, 1 female",
    Q2_STUDENT:"21 male, 4 female",
    Q3_POLICY:"No family leave policy, though a leave of absence for a semester or two is possible.",
    Q4_INSURANCE:"Yes.  It is not included in the stipend.",
    Q5_FRIENDLY:"We have an excellent, small department.  Because it is small in size there is a sense of comaraderie that is difficult to achieve at larger institutions.  This is a very positive environment for nurturing female scientists.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"",
    UPDATED_ON:"Fri Sep 13 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"20",
    TENURE_WOMEN_NUM:"2",
    GRAD_TOTAL_NUM:"26",
    GRAD_WOMEN_NUM:"2",
    POSTDOC_TOTAL_NUM:"4",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"No.",
    PHYSICS_GSA:"No.",
    OTHER_STUGRP:"Graduate Student Association Society of Physics Students",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No",
    CONTACT_INFO:"Joshua Cohn, jcohn@miami.edu" },
  { ID:"128",
    FULL_NAME:"Sabreen Dodson",
    EMAIL:"physics@wsu.edu",
    INSTITUTION:"Washington State University",
    DEPARTMENT:"",
    Q1_FACULTY:"14 male, 2 female",
    Q2_STUDENT:"54 male, 12 female",
    Q3_POLICY:"Emergency Family/Medical Leave (EFML) is for graduate students who must leave school due to a medical or family emergency that is defined under the federal Family Medical Leave Act.  EFML entitles graduate students in good standing to be away from the university but maintain some benefits and services during their leave period, including faculty and staff counsel, and use of other University offerings.  EFML status also entitles graduate students to maintain their eligibility for student health insurance on a self-pay basis for a period of one semester as approved by Health and Wellness Services. Students need to have been a participant in the student health insurance plan immediately preceding the EFML leave to be eligible. ",
    Q4_INSURANCE:"There is an insurance plan in place for the employee and it is included in the stipend.  Family plans are available at a cost and are not included in the stipend.",
    Q5_FRIENDLY:"Washington State University is situated in the heart of an energetic and teeming community, Pullman, Washington, and is eight miles away from another major university in Moscow, Idaho. Two college communities within close proximity offer a large variety of regional events, intellectual and recreational pursuits, but with a smaller, community atmosphere.  The area offers a child friendly atmosphere with excellent schools and child care, close distances of travel to schools, parks, events, and sports, yet with awareness for safety issues. For instance, Women's Transit at WSU offers rides and provides an escort service directly to one's home on late nights.  Pullman's Community Action Center offers food, shelter, and help to low-income and needy families. Pullman and WSU give students and families the opportunity to enjoy the beauty, peace, and feel of a small community, but with many advantages of a big city.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"2 males",
    UPDATED_ON:"04-AUG-09",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"131",
    FULL_NAME:"Adam Burgasser",
    EMAIL:"aburgasser@ucsd.edu",
    INSTITUTION:"University of California, San Diego",
    DEPARTMENT:"",
    Q1_FACULTY:"As of October 2011, UCSD Physics has 47 tenure-track/tenured faculty: 44 male and 3 female (6.4%).   We also have 3 adjunct faculty: 2 male and 1 female.",
    Q2_STUDENT:"As of October 2011, UCSD Physics has 164 graduate students:  137 male and 27 female (16.5%).",
    Q3_POLICY:"UC San Diego Parenting Leave program covers students (male or female) who have primary responsibility for the care of an infant immediately following birth, or a child under the age of five years, or adoption of a child under age of five years. The student must be in good academic standing, and requests may be made for up to three quarters leave of absence (this is in addition to the three-quarter leave limit that is available to all graduate students).  \\\\n The UCSD campus-wide leave of absence policy can be found at http://ogs.ucsd.edu/academic-affairs/academic-progress-policies/leave-of.html",
    Q4_INSURANCE:"Supplemental coverage for dependents is available for graduate students, but is not included as part of the graduate student stipend.   \\\\n UCSD graduate student health policies are described at http://studenthealth.ucsd.edu/gshiphowtouse.shtml",
    Q5_FRIENDLY:"As part of its mission, the Department of Physics is committed to promoting the training and advancement of a diverse scientific workforce, in particular women and minorities who are underrepresented in Physics.  We achieves this through various departmental, campus-wide and national activities, including:  \\\\n •\\tThe UCSD Graduate Women in Physics group (http://www.physics.ucsd.edu/womeninphysics), which holds monthly lunch talks on career issues, establishes mentorship networks, and generally provides a forum and community for women of the UCSD Physics department;  \\\\n •\\tThe Center for Theoretical Biophysics Diversity Outreach Initiative (https://ctbp.ucsd.edu/ed_highlights.html), which facilitates interactions between UCSD faculty and students at local minority-serving institutions.  \\\\n •\\tParticipation in national societies and meetings addressing diversity issues in Physics, including SACNAS, the National Societies of Black and Hispanic Physicists, and the AAS Committees on the Status of Women and Minorities in Astronomy.  \\\\n •\\tOutreach aimed at encouraging young women and underrepresented minorities to pursue careers in science, including TechTrek(http://www.aauw-techtrek.org/sd) (sponsered by the AAUW) and Reach for Tomorrow (http://www.reachfortomorrow.org) programs. \\\\n Throughout its 50-year history, the UCSD Department of Physics has counted among its faculty leading women physicists, astronomers and space scientists, including Nobel laureate Dr. Maria Goeppert-Mayer, National Medal of Science winner Dr. Margaret Burbridge, and APS fellow and first female astronaut Dr. Sally Ride. Today, leading women physicists continue to be part of the UCSD Physics faculty: \\\\n •\\tDr. Alison Coil, a Sloan Fellow and NSF Career Fellow is an observational astrophysicist who specializes in galaxy formation, and is one of the founders of the Southern California Center for Galaxy Evolution.  \\\\n •\\tDr. Olga Dudko, an NSF Career Fellow, is a theoretical biophysicist who studies the dynamics of single-molecule systems.  \\\\n •\\tDr. Elizabeth Jenkins a Sloan Fellow and NSF Young Investigator Awardee, is a high energy theorist who examines symmetries to understand the interactions of elementary particles.    \\\\n •\\tDr. Tatyana Sharpee, a Sloan Fellow and recipient of the Keck Foundation Research Excellence Award, is a computational neurobiologist who studies the theoretical principles of how the brain processes information.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"As of October 2011, UCSD Physics has 53 postdoctoral researchers: 44 male and 9 female (17.0%).",
    UPDATED_ON:"13-FEB-12",
    IS_ACTIVE:"false",
    PLANS:"UCSD Physics had an APS CWP site visit in 1998, which provided a valuable guide for improving diversity in our department, and led to programs such as Graduate Women in Physics, a significant increase in the fraction of female postdoctoral researchers, greater attention paid to the frequency of female colloquium and seminar speakers, and more informal communication between faculty, students and postdoctoral researchers.   \\\\n Nevertheless, significant work remains to improve the gender balance among our faculty, postdocs and graduate students (specifically among graduate applicants).  Members of the Outreach and Diversity Committee are currently working with the Division of Physical Sciences and the University to identify resources to recruit and hire women faculty, provide greater access to diversity resources, and outreach to potential female graduate applicants.   \\\\n Given that our last site visit was nearly 14 years ago, we would welcome a future site visit to help us identify optimal strategies for improving gender representation at all levels in our department.",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"133",
    FULL_NAME:"Leslie Smith",
    EMAIL:"leslie@fit.edu",
    INSTITUTION:"Florida Institute of Technology (Physics & Space Sciences)",
    DEPARTMENT:"",
    Q1_FACULTY:"1 female, 13male (7% female)",
    Q2_STUDENT:"PART-TIME: 0 female, 1 male (0% female) \\\\n FULL-TIME: 14 female, 23 male (38% female) \\\\n TOTAL: 15 female, 24 male (38% female)",
    Q3_POLICY:"There is no formal leave policy.  However, it is relatively easy to arrange temporary leaves within the department's program with the approval of advisor, graduate committee and head.",
    Q4_INSURANCE:"A student can opt for family insurance provided by the university, but it is not included in the stipend paid by the department.",
    Q5_FRIENDLY:"We are among the largest undergraduate physics and astronomy (space sciences) programs in the U.S. according to AIP graduation statistics--about 150 majors (including dual degree students).  About half of our undergraduate majors in Physics and Space Sciences are women.  More than a third of the graduate students are women.  This suggests we are doing a good job in attracting and keeping female students--especially in view of the fact that FIT is an engineering school.  Such institutions often have a much lower fraction of women than this. \\\\n We clearly need better representation of women on our faculty.  However, this is proving to be a challenge, as only about 1 in 10-20 applicants for our occasional faculty openings have been women.  Hopefully, our enrollment figures portend an increasing number of Ph.D. candidates for faculty positions in coming years.  We are trying to do our part--without discriminating in either direction.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"0 female, 4 male (0% female)",
    UPDATED_ON:"Wed Oct 16 2019",
    IS_ACTIVE:"true",
    PLANS:"We are in the process of filling one permanent faculty position and one visiting faculty position for the 2007-8 academic year.  Survey information will be updated as soon as these searches are completed.",
    TENURE_TOTAL_NUM:"0",
    TENURE_WOMEN_NUM:"0",
    GRAD_TOTAL_NUM:"0",
    GRAD_WOMEN_NUM:"0",
    POSTDOC_TOTAL_NUM:"3",
    POSTDOC_WOMEN_NUM:"1",
    WOMEN_GROUP:"No",
    PHYSICS_GSA:"No",
    OTHER_STUGRP:"No",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No",
    CONTACT_INFO:"Leslie Smith leslie@fit.edu 3216748795" },
  { ID:"150",
    FULL_NAME:"Chun Ning Lau",
    EMAIL:"jeanie.lau@ucr.edu",
    INSTITUTION:"University of California, Riverside",
    DEPARTMENT:"Department of Physics and Astronomy",
    Q1_FACULTY:"6 female, 30 total",
    Q2_STUDENT:"15 female, 102 total",
    Q3_POLICY:"Yes.Graduate students serving as teaching assistants have 4 weeks of paid leave",
    Q4_INSURANCE:"Family health insurance is provided by a group affliated with the university, but not included in the stipend.",
    Q5_FRIENDLY:"The department is expanding, and is expected to continue to grow for the next decade. A number of young, energetic and outstanding faculty members in various disciplines were hired recently, almost half of them female. We have a Women in Physics group that meets regularly (http://physics.ucr.edu/~lau/WIP.htm), with free pizzas provided by the department. This friendly group provides a platform for female faculty members, postdocs and students to interact informally, and to discuss challenges faced by female scientists. ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"19 total; 2 female (by Oct. 2012)",
    UPDATED_ON:"21-AUG-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"155",
    FULL_NAME:"Paul Huffman",
    EMAIL:"paul_huffman@ncsu.edu",
    INSTITUTION:"North Carolina State University",
    DEPARTMENT:"",
    Q1_FACULTY:"27/8",
    Q2_STUDENT:"91/20",
    Q3_POLICY:"Yes, the graduate school has a six week parental leave for graduate students for the birth or care of a newborn, or placement or care of an adopted or foster child.  The student may also utilize a leave-of-absence (LOA) policy that is often used for family leave reasons.  The academic clock stops for a student on LOA until he or she returns to active student status.",
    Q4_INSURANCE:"Graduate students may purchase dependent healthcare at their own expense.",
    Q5_FRIENDLY:"Our department has an extremely high fraction of tenured or tenure-track female faculty for major physics department in the nation, and all of them lead active research groups.  We pride ourselves in providing a supporting environment regardless of each student's gender, race, or nationality. In our recently-renovated building, incoming graduate students share an office space, computer lab, and lounge designed to foster community and collaboration.  Weekly lunchtime discussions of current research topics provide a forum for connecting with faculty in the department.  Campus programs such as WISE (Women in Science and Engineering) provide dormitory space and programming for undergraduate science majors, and many undergraduate women participate in physics research alongside graduate students.  For married graduate students and their families, the university provides a village of apartments specifically designed for them. This complex is directly adjacent to campus and provides a close-knit community which graduate students with young families find particularly hospitable and convenient.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"16/2",
    UPDATED_ON:"Fri Sep 14 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"40",
    TENURE_WOMEN_NUM:"10",
    GRAD_TOTAL_NUM:"138",
    GRAD_WOMEN_NUM:"25",
    POSTDOC_TOTAL_NUM:"13",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"Yes, https://www.physics.ncsu.edu/department/women.php",
    PHYSICS_GSA:"Yes, https://www.facebook.com/ncsugpsa/",
    OTHER_STUGRP:"Society of Physics Students, https://physics.sciences.ncsu.edu/subgroup/graduate-students/  Astronomy Club, https://www.facebook.com/astronomyncsu/ Artificial Intelligence Club, https://www.facebook.com/aiatncsu/",
    UNDERGRA_WOMCONF:"Yes, 2011 and co-hosted in 2015",
    SITE_VISIT:"Yes, 1994 and 2014",
    CONTACT_INFO:"Rhonda Bennett, Graduate and Undergraduate Student Adminstrator, rbennet@ncsu.edu" },
  { ID:"161",
    FULL_NAME:"Kacey Acquilano",
    EMAIL:"klb79@cornell.edu",
    INSTITUTION:"Cornell University",
    DEPARTMENT:"",
    Q1_FACULTY:"40 total, 36 male, 4 female",
    Q2_STUDENT:"197 total, 164 male, 33 female",
    Q3_POLICY:"The University offers graduate students two forms of accommodation for childbirth, newborn care, adoption, foster care, and acute child health care needs. Students may select six-weeks paid accommodation with the option of a two-week extension for birth mothers who deliver by C-section or up to one year of reduced-load registered student status not counting toward time-to-degree limits.",
    Q4_INSURANCE:"Family health insurance is available, but not covered by an assistantship.",
    Q5_FRIENDLY:"Cornell University was founded in 1865 as an institution where ''any person can find instruction in any study'', and commitment to diversity and inclusiveness remains one of our core values. Cornell's Physics Department strives to create and maintain a healthy professional environment, and to ensure that all its members feel valued, respected, and able to work and study free of harassment, bias and discrimination. The department provides a variety of resources and activities to further these goals. For example, Equity Advocates are faculty and staff members who aim to identify and address issues related to diversity and inclusion, and to provide support to students who may be affected by such issues. Women in Physics and Related Fields (WiP+) is an informal group which includes (primarily) women faculty, postdocs and students, dedicated to creating a supportive community for women in STEM fields.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"",
    UPDATED_ON:"Fri Oct 04 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"43",
    TENURE_WOMEN_NUM:"8",
    GRAD_TOTAL_NUM:"180",
    GRAD_WOMEN_NUM:"35",
    POSTDOC_TOTAL_NUM:"42",
    POSTDOC_WOMEN_NUM:"10",
    WOMEN_GROUP:"Yes. https://physics.cornell.edu/women-in-physics",
    PHYSICS_GSA:"Yes",
    OTHER_STUGRP:"Graduate Women in Science (GWIS) Graduate & Professional Women's Network (GPWomeN)",
    UNDERGRA_WOMCONF:"Yes, 2012.",
    SITE_VISIT:"Yes, 2009.",
    CONTACT_INFO:"Professor Maxim Perelstein Director of Graduate Studies physicsdgs@cornell.edu" },
  { ID:"162",
    FULL_NAME:"Evette Ma",
    EMAIL:"em123@nyu.edu",
    INSTITUTION:"New York University",
    DEPARTMENT:"",
    Q1_FACULTY:"35 tenured and tenure-track faculty; 31 male, 4 female.",
    Q2_STUDENT:"81 graduate students: 71 male, 10 female",
    Q3_POLICY:"NYU offers leaves of absence for all graduate students.  This includes parental and family leaves for both male and female graduate students. Time on leave of absence does not count toward time to degree.",
    Q4_INSURANCE:"NYU's Graduate School of Arts and Science provides each graduate student in Physics with comprehensive health insurance.  This health insurance coverage is provided over and above the student's stipend and tuition remission.  Family members can be added to the health insurance plan at additional cost to the student.",
    Q5_FRIENDLY:"NYU was the first department of physics in the US to have a female chair, and the first female PhD student.  More importantly, we are part of one of the most progressive environments in the US. Greenwich Village has been for well over a century at the forefront of progressive social battles. Our department and the university at large shares the values at the core of Greenwich Village's identity.  We are situated in the heart of New York City, one of the most inclusive and family-friendly communities in the world.  New York's vibrant cultural and intellectual environment provides opportunities for graduate students to pursue all of their interests in a world-class setting.  For students raising families, NYU features an affiliated preschool and access to some of the finest public and private K-12 schools in the country.  NYU recently has expanded its child-care offerings for parents with pre-school-age children. NYU's Department of Physics fosters research by female graduate students by providing opportunity grants for exploratory research and also through the support of the Louise Bruhn Travel Grants for Women in Physics. NYU also is actively engaged in recruiting female faculty members into all of the sciences, including Physics.  To foster these activities, NYU has adopted policies that increase and improve the opportunities for women on the Physics faculty.  These policies include automatic tenure-clock stoppage and work relief for new parents, including those who have recently adopted.  The Senior Vice Provost for Research holds a regular program of lunches, meetings and workshops that focus on women's issues in the University. Most recently, these meetings have inspired substantial upgrades to NYU's child care offerings.  The College of Arts and Science also has initiated a Women in Science (WINS) program to increase the number of female undergraduates in our science program, under the directorship of Prof. Lynne Kiorpes.  All of these activities at least indirectly improve the atmosphere and sense of community that female graduate students can expect to find at New York University's Department of Physics.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"33 postdocs: 28 male, 5 female",
    UPDATED_ON:"Fri Oct 05 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"41",
    TENURE_WOMEN_NUM:"5",
    GRAD_TOTAL_NUM:"91",
    GRAD_WOMEN_NUM:"21",
    POSTDOC_TOTAL_NUM:"28",
    POSTDOC_WOMEN_NUM:"3",
    WOMEN_GROUP:"No",
    PHYSICS_GSA:"No",
    OTHER_STUGRP:"Undergraduate Society of Physics Students: http://physics.nyu.edu/~sps/ \\\\n NYU Women in Science: http://cas.nyu.edu/content/nyu-as/cas/wins.html",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No",
    CONTACT_INFO:"Evette Ma - Graduate Program Administrator: evettema@nyu.edu" },
  { ID:"163",
    FULL_NAME:"Rena Zieve",
    EMAIL:"zieve@physics.ucdavis.edu",
    INSTITUTION:"University of California, Davis",
    DEPARTMENT:"",
    Q1_FACULTY:"44 total, 7 women The vice chair for graduate affairs is a woman.",
    Q2_STUDENT:"139 total, 27 women",
    Q3_POLICY:"Students can take a PELP (Planned Educational Leave Program) for up to one year for family issues.  Graduate students employed as teaching assistants are eligible for up to four weeks of paid leave for childbirth (females), while birth fathers and adoptive parents may take up to two weeks of paid leave.  Graduate students employed as researchers are not covered by the policy but can often make leave arrangements with their advisers.",
    Q4_INSURANCE:"Graduate students may include dependents on the group health insurance plan.  There is an option for medical coverage only, or for dental and vision coverage as well.  The student must pay an additional premium of about $6000 per year for an entire family, or $3000 per year to cover either a spouse or children.",
    Q5_FRIENDLY:"UC Davis Physics values its reputation for faculty accessibility.  We provide for our students, both undergraduate and graduate, the opportunity for close faculty interaction and mentoring while doing top-notch research.  Students have access both to on-campus facilities and to off-campus sites including CERN, Lawrence Livermore Labs, the National Observatories at Kitt Peak and Cerro Tololo, Chile, and the Keck Telescope in Hawaii.  With established opportunities for interdisciplinary research across the sciences, the environment and curriculum are well-suited for either men or women interested in pursuing physics or applied physics studies. Several university programs contribute to our female-friendly environment.  Our nationally recognized Breast-Feeding Support Program and a Child Care Support Program assist graduate students with the costs and logistics of raising children, and the Partner Opportunity Program plays an important role in our successful hiring of female faculty. In part because of the large fraction of women faculty, at least one women has been department chair or a vice chair continuously since 2003.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"",
    UPDATED_ON:"Fri Sep 14 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"48",
    TENURE_WOMEN_NUM:"9",
    GRAD_TOTAL_NUM:"170",
    GRAD_WOMEN_NUM:"35",
    POSTDOC_TOTAL_NUM:"28",
    POSTDOC_WOMEN_NUM:"4",
    WOMEN_GROUP:"Not by that name. Our former women's group broadened into Diversity and Inclusion in Physics.",
    PHYSICS_GSA:"Yes: http://gradops.physics.ucdavis.edu/",
    OTHER_STUGRP:"We have a Diversity and Inclusion in Physics group: https://davisdip.wordpress.com/",
    UNDERGRA_WOMCONF:"We are hosting CUWiP in January 2019.",
    SITE_VISIT:"Yes, in 2016.",
    CONTACT_INFO:"Rena Zieve, zieve@physics.ucdavis.edu" },
  { ID:"167",
    FULL_NAME:"Todd Thompson",
    EMAIL:"thompson.1847@osu.edu",
    INSTITUTION:"Ohio State University",
    DEPARTMENT:"Astronomy",
    Q1_FACULTY:"24/4",
    Q2_STUDENT:"58/18",
    Q3_POLICY:"Starting in the Fall of 2018, graduate students in good standing with the university, holding a current appointment of at least 15 hour/week, having completed two consecutive semesters in any graduate appointment can benefit of family leave.  As part of the policy, the birth mother, or a parent taking on the role of a primary caregiver, will be provided up to six weeks paid leave of absence; a spouse or domestic partner may be provided with up to three weeks leave. More info:https://www.ohio.edu/compass/stories/17-18/01/Paid-Parental-Leave-Graduate-Students.cfm ",
    Q4_INSURANCE:"Family health insurance is available but is not included in the stipend.",
    Q5_FRIENDLY:"Our department is committed to providing opportunities and a supportive environment for all graduate students, and makes special efforts to allow female students to achieve their full potential as scientists. Women in Physics and Astronomy, WIPHA (www.phy.ohiou.edu/~wipha/), is a local organization that connects female undergraduate and graduate students, postdocs, and faculty in an informal mentoring network. The department sponsors the monthly WIPHA lunches where members can discuss science, career issues and related topics in an informal setting. The department overall has a relatively young faculty, a high level of research activity, and a strong tradition of collegiality at all levels. Our institution is committed to fostering diversity in all dimensions of university life.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"2/0",
    UPDATED_ON:"08-JUN-21",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"168",
    FULL_NAME:"Rongjai Tao ",
    EMAIL:"rtao@temple.edu",
    INSTITUTION:"Temple University",
    DEPARTMENT:"",
    Q1_FACULTY:"17/4",
    Q2_STUDENT:"34/8",
    Q3_POLICY:"Yes. Temple Graduate Students is unionized. The contract between the graduate student union and Temple University provides a family leave policy for graduate students, including that TA or RA can have some paid leave and unpaid leave. ",
    Q4_INSURANCE:"Yes. The premium is included in the stipend. ",
    Q5_FRIENDLY:"Currently Graduate students at Temple University were unionized. The contract between the union and Temple University creates a much friendly environment for female graduate students, inlcuding health benefits and family leave policy etc. The University is also discussing with the union about providing some child care for femaly graduate students. In additon, in our Department, we have 3 very active femal tenured and tenure-track faculty members. They serve as role model for female graduate students.  ",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"2/1",
    UPDATED_ON:"02-AUG-12",
    IS_ACTIVE:"false",
    PLANS:"The Department plans to recruit more femal faculty members and graduate students in the coming years.",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"170",
    FULL_NAME:"Jim McGuire",
    EMAIL:"mcguire@tulane.edu",
    INSTITUTION:"Tulane University",
    DEPARTMENT:"",
    Q1_FACULTY:"12 male/ 1 female",
    Q2_STUDENT:"13 male/ 7 female",
    Q3_POLICY:"Case by case basis.",
    Q4_INSURANCE:"No.",
    Q5_FRIENDLY:"New Orleans is a culturally rich city.  Tulane has had an expectionally stron interest in women's education for well over 100 years, with the presence of the famous Newcomb College and Institute.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"4 male/0 female",
    UPDATED_ON:"29-SEP-09",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"172",
    FULL_NAME:"Misty Bentz",
    EMAIL:"bentz@astro.gsu.edu",
    INSTITUTION:"Georgia State University",
    DEPARTMENT:"Physics and Astronomy",
    Q1_FACULTY:"Physics: 13 male, 0 female Astronomy: 5 male, 1 female",
    Q2_STUDENT:"Physics: 28 male, 9 female Astronomy: 14 male, 9 female",
    Q3_POLICY:"There is currently no official policy for graduate student family leave.  Arrangements are generally made between the student and his/her PhD advisor and are personalized to match the specific circumstances.",
    Q4_INSURANCE:"Student health insurance is provided at a reduced rate for all full-time graduate students.  Family health insurance is available for eligible dependents, but is not included in the stipend.",
    Q5_FRIENDLY:"Georgia State University, in the heart of downtown Atlanta, is fortunate to have a student population that is extremely diverse and comprised of many members of underrepresented groups.  We have a university-wide focus to celebrate diversity and the unique perspectives that people with different backgrounds and life experiences can bring to the table. Within the Physics and Astronomy Department, we believe that the success of our female graduate students visibly demonstrates the supportive atmosphere and personal attention that our faculty provide.  Among our former female graduate students, we have  National Science Foundation Graduate Fellows, Department of Energy Science Graduate Fellows, and several others with University-sponsored fellowships.  We are always on the lookout for talented women who would like to consider joining our team.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"Physics: 4 male, 0 female Astronomy: 4 male, 0 female",
    UPDATED_ON:"Thu Sep 12 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"22",
    TENURE_WOMEN_NUM:"3",
    GRAD_TOTAL_NUM:"75",
    GRAD_WOMEN_NUM:"28",
    POSTDOC_TOTAL_NUM:"8",
    POSTDOC_WOMEN_NUM:"4",
    WOMEN_GROUP:"Yes: http://www.physics.gsu.edu/wip/",
    PHYSICS_GSA:"Yes: http://www.physics.gsu.edu/pgsa/",
    OTHER_STUGRP:"http://www.astro.gsu.edu/AstroPAL/",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No",
    CONTACT_INFO:"Russel White, Astronomy Graduate Director white@astro.gsu.edu Murad Sarsour, Physics Graduate Director msar@gsu.edu" },
  { ID:"177",
    FULL_NAME:"Beth Stinebring",
    EMAIL:"Beth.Stinebring@uvm.edu",
    INSTITUTION:"University of Vermont",
    DEPARTMENT:"",
    Q1_FACULTY:"10 tenured/tenure-track faculty: 8 male, 2 female",
    Q2_STUDENT:"10 graduate students:  7 male, 3 female",
    Q3_POLICY:"No",
    Q4_INSURANCE:"Yes, it's included in graduate teaching/research fellowships",
    Q5_FRIENDLY:"It's a small friendly department in general.  And with 20% of the faculty being female, the department has a better gender balance than most physics departments.  Additionally there are several university wide mentoring/support programs available for women.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"2 male, 1 female",
    UPDATED_ON:"Wed Nov 20 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"9",
    TENURE_WOMEN_NUM:"1",
    GRAD_TOTAL_NUM:"26",
    GRAD_WOMEN_NUM:"5",
    POSTDOC_TOTAL_NUM:"1",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"Women in STEM",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"Madalina Furis at Madalina.Furis@uvm.edu" },
  { ID:"178",
    FULL_NAME:"Serif Uran",
    EMAIL:"suran@pittstate.edu",
    INSTITUTION:"Pittsburg State University",
    DEPARTMENT:"",
    Q1_FACULTY:"4/1 plus 1 female full time lecturer",
    Q2_STUDENT:"6/1",
    Q3_POLICY:"Not a paid leave, but any student can skip and return with no penalty.",
    Q4_INSURANCE:"Yes. Department pays for half.",
    Q5_FRIENDLY:"The department caters to special student interests in physics or its applications and will structure classes to meet them, even if we do not have an explicit emphasis area in our catalog. All the science and math departments have female faculty, many of whom contribute to an active Women's Studies Certificate program on campus, which includes two courses on women's issues in our undergraduate general education requirements. A majority of our students are non-traditional, including many women returning from the workplace. We are in a relatively low-crime, rural setting with good schools and child care available.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"None",
    UPDATED_ON:"Mon Sep 24 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"4",
    TENURE_WOMEN_NUM:"1",
    GRAD_TOTAL_NUM:"4",
    GRAD_WOMEN_NUM:"1",
    POSTDOC_TOTAL_NUM:"0",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"No",
    PHYSICS_GSA:"No",
    OTHER_STUGRP:"Society of Physics Students (SPS) for our undergraduate program. We have several women SPS members.",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No",
    CONTACT_INFO:"Dr. Serif Uran Email: suran@pittstate.edu" },
  { ID:"184",
    FULL_NAME:"David N. Brown",
    EMAIL:"D.N.Brown@louisville.edu",
    INSTITUTION:"University of Louisville",
    DEPARTMENT:"Physics and Astronomy",
    Q1_FACULTY:"14/2",
    Q2_STUDENT:"17/5",
    Q3_POLICY:"By default, the campus FMLA policy does not cover GTAs or GRAs.  However, departments are able to request exceptions for these students.  The campus FMLA policy is a paid 12-week absence.",
    Q4_INSURANCE:"For TAs and RAs, it is free.  It is limited in access to doctors in the UofL Medical system, but this is a fairly large system. For students not supported as TA or RA, there is a small cost per semester for campus health insurance.",
    Q5_FRIENDLY:"We certainly try to be a female-friendly department. We have created a new organization within the department:  SWIPA - the Society for Women In Physics & Astronomy.  This will provide an opportunity for female students, staff, and faculty to meet socially, to establish mentoring relationships, and to provide input to the department chair. Our chapter of the Society of Physics Students (SPS) welcomes both graduate and undergraduate students and usually has a significant number of women officers.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"4/1",
    UPDATED_ON:"Thu Sep 12 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"17",
    TENURE_WOMEN_NUM:"3",
    GRAD_TOTAL_NUM:"39",
    GRAD_WOMEN_NUM:"14",
    POSTDOC_TOTAL_NUM:"1",
    POSTDOC_WOMEN_NUM:"1",
    WOMEN_GROUP:"Yes:  SWiPA http://www.physics.louisville.edu/index.php?option=com_content&view=article&id=172&Itemid=313",
    PHYSICS_GSA:"Not specifically for graduate students - we encourage the undergraduate and graduate students to meet together.",
    OTHER_STUGRP:"The Society of Physics Students, which works closely with the Society for Women in Physics and Astronomy.",
    UNDERGRA_WOMCONF:"No, but we plan to apply for the next round.",
    SITE_VISIT:"No",
    CONTACT_INFO:"Department Chair:  Dr. Chakram Jayanthi, chakram.jayanthi@louisville.edu Director of Graduate Studies:  Dr. Christopher Davis. christopher.davis@louisville.edu" },
  { ID:"198",
    FULL_NAME:"Dr. Joseph A. Barranco",
    EMAIL:"barranco@sfsu.edu",
    INSTITUTION:"San Francisco State Univ",
    DEPARTMENT:"Physics and Astronomy",
    Q1_FACULTY:"11 total, 7 male/4 female",
    Q2_STUDENT:"41 total, 30 male/11 female",
    Q3_POLICY:"Not specifically. ",
    Q4_INSURANCE:"Not as far as I know.  The university health center is available to all students.",
    Q5_FRIENDLY:"We have a large fraction of female faculty and a very female-friendly environment. As one women scientist said recently, we have enough women in the department that we no longer have to keep justifying ourselves: we are over the hump. ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"3 total,  2 male/1 female",
    UPDATED_ON:"18-SEP-18",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"200",
    FULL_NAME:"David Garrison",
    EMAIL:"garrison@uhcl.edu",
    INSTITUTION:"University of Houston Clear Lake",
    DEPARTMENT:"",
    Q1_FACULTY:"3/2",
    Q2_STUDENT:"34/12",
    Q3_POLICY:"No",
    Q4_INSURANCE:"No",
    Q5_FRIENDLY:"",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"",
    UPDATED_ON:"02-AUG-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"203",
    FULL_NAME:"Bryce Nelson",
    EMAIL:"bryce@physics.utah.edu",
    INSTITUTION:"University of Utah",
    DEPARTMENT:"Department of Physics & Astronomy",
    Q1_FACULTY:"Tenure-track/tenured faculty: 35/4 Career-line faculty (research and lecture professors): 14/3 ",
    Q2_STUDENT:"65/25",
    Q3_POLICY:"Graduate students may apply for a leave of absence.",
    Q4_INSURANCE:"Yes. It is not included in the graduate stipend, but family health insurance is subsidized considerably by the University of Utah.",
    Q5_FRIENDLY:"The faculty consider the student environment critical to the success of the department.  There are now two groups for women in physics and astronomy; one led by undergraduates and one for graduate students, postdocs, and faculty.  The latter group meets monthly, and is financially supported by the department.  These gatherings provide opportunities for informal mentoring across career stages and sharing of resources, and also serve as forums for exchange of information and advice. The Department of Physics and Astronomy at the University of Utah hosted a 2014 APS Conference for Undergraduate Women in Physics, attended by more than 100 undergraduate students.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"21/3",
    UPDATED_ON:"Tue Sep 03 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"37",
    TENURE_WOMEN_NUM:"3",
    GRAD_TOTAL_NUM:"67",
    GRAD_WOMEN_NUM:"20",
    POSTDOC_TOTAL_NUM:"15",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"https://www.physics.utah.edu/~wompa/",
    PHYSICS_GSA:"http://www.physics.utah.edu/gsac/",
    OTHER_STUGRP:"Society of Physics Students",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"Bryce@physics.utah.edu, Graduate Coordinator" },
  { ID:"207",
    FULL_NAME:"Karsten Pohl",
    EMAIL:"karsten.pohl@unh.edu",
    INSTITUTION:"University of New Hampshire",
    DEPARTMENT:"",
    Q1_FACULTY:"23 - 21/2",
    Q2_STUDENT:"50 - 37/13",
    Q3_POLICY:"There is no such policy at UNH.",
    Q4_INSURANCE:"Graduate students receive health insurance with their stipend. A family health plan is offered. However, the graduate students have to purchase the coverage for their family members.",
    Q5_FRIENDLY:"Although in the minority, there are several female scientists (tenure track and research faculty as well as research scientists) in the Department and in the associated research programs, as through the Space Science Center and the Material Science Program. Several of them lead substantial research  projects, such as leading instrument teams on space missions, and thus serve as role models. The Department welcomes women graduate students and treats equal with men. The UNH Graduate School and the Graduate Student Organization are pro-active in making UNH a good place for all graduate students. From the perspective of our female graduate students, they feel welcome here and are positive about the atmosphere for female students in the Department and the College.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"19 - 14/5",
    UPDATED_ON:"13-SEP-19",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"208",
    FULL_NAME:"William Briscoe",
    EMAIL:"briscoe@gwu.edu",
    INSTITUTION:"George Washington University",
    DEPARTMENT:"",
    Q1_FACULTY:"11/1",
    Q2_STUDENT:"17/8",
    Q3_POLICY:"Not that I know of.  No doubt the school's eight-year limit could be extended for this reason.",
    Q4_INSURANCE:"There is a subsidized insurance program available to graduate students.  It is not included in the stipend.",
    Q5_FRIENDLY:"We really are one.  I have not encountered any prejudice in 23 years.  You didn't ask, but several of our non-tenure-track faculty in recent years have been females as well.  Finally, our senior female professor (full) organizes numerous activities for women in physics at all levels.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"5/3",
    UPDATED_ON:"16-SEP-19",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"209",
    FULL_NAME:"Luca Bombelli",
    EMAIL:"bombelli@olemiss.edu",
    INSTITUTION:"University of Mississippi",
    DEPARTMENT:"",
    Q1_FACULTY:"13 tenure/tenure track",
    Q2_STUDENT:"30 graduate students",
    Q3_POLICY:"We do not have a university policy on family leave for faculty or for graduate stuidents, but it is left to the department to decide. University policy is currently being discussed.",
    Q4_INSURANCE:"Yes, there is, but not all of it included in the standard graduate stipend; students pay part of it (about a third).  The Physics Department pays for TAs.  RAs are left to the research directors to decide.",
    Q5_FRIENDLY:"",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"7 post doctoral associates",
    UPDATED_ON:"Mon Jan 21 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"15",
    TENURE_WOMEN_NUM:"1",
    GRAD_TOTAL_NUM:"42",
    GRAD_WOMEN_NUM:"4",
    POSTDOC_TOTAL_NUM:"3",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"Yes, we do. They do not have a website as far as I know, but the email address for the group is wip@phy.olemiss.edu.",
    PHYSICS_GSA:"Yes, we do. The website is at http://dos.orgsync.com/org/pgsa, but it is not up to date.",
    OTHER_STUGRP:"We have a chapter of SPS, the Society for Physics students. Some of the members are graduate students.",
    UNDERGRA_WOMCONF:"Yes, in 2015.",
    SITE_VISIT:"No, we have not.",
    CONTACT_INFO:"Dr. Cecille Labuda <cpembert@olemiss.edu>" },
  { ID:"210",
    FULL_NAME:"Erik Bodegom",
    EMAIL:"bodegom@pdx.edu",
    INSTITUTION:"Portland State",
    DEPARTMENT:"",
    Q1_FACULTY:"Tenure-track: 14 male, 1 female",
    Q2_STUDENT:"30 male, 13 female",
    Q3_POLICY:"We have a general leave policy. Graduate students may take a leave of absence from the program for any personal reason. We work with students to help accommodate any needs they have.",
    Q4_INSURANCE:"Additional insurance is available for dependents.  In addition, there is Oregon Health Plan (OHP) - The Oregon Health Plan (OHP) operates under a waiver from the federal government that allows to serve more low-income people using federal Medicaid money. This is done through an innovative system that prioritizes health care, using a list of hundreds of conditions and their treatments. Higher priority is given to conditions that can be successfully treated, and to avoiding illness through preventive care.  Additionally, students might be eligible for the State's Family Health Insurance Assistance Program (FHIAP) FHIAP pays 50%-95% of the monthly insurance premium for private health insurance. Oregon Prescription Drug Program allows any Oregonian without Rx coverage to enroll and obtain drugs at lower cost.",
    Q5_FRIENDLY:"The department fosters a collegial atmosphere and sponsors faculty-student get-togethers, picnics, and various student club activities.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"5 male",
    UPDATED_ON:"04-AUG-09",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"211",
    FULL_NAME:"Jill Bechtold",
    EMAIL:"jill@as.arizona.edu",
    INSTITUTION:"University of Arizona",
    DEPARTMENT:"Astronomy",
    Q1_FACULTY:"25/5, total of 30",
    Q2_STUDENT:"29/16, total 45",
    Q3_POLICY:"There is no formal policy, although several students, both male and female, have had children while graduate students in the last 10 years.",
    Q4_INSURANCE:"Yes, but it is not included in the stipend.",
    Q5_FRIENDLY:"We have an active community of women astronomers at all levels, from directors of observatories, to undergraduates.  We have an active women's group in the department, in addition to mentoring programs for women science students on campus.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"14/2, total 16",
    UPDATED_ON:"04-AUG-09",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"213",
    FULL_NAME:"Rachel Griffin",
    EMAIL:"regriffi@mtu.edu",
    INSTITUTION:"Michigan Technological University",
    DEPARTMENT:"",
    Q1_FACULTY:"19 total, 18 male/1 female",
    Q2_STUDENT:"43 total, 34 Male/9 Female",
    Q3_POLICY:"Yes. The Graduate Student Parental Accommodation Policy applies to graduate students who: \\\\n have new childcare or related responsibilities due to a recent or upcoming birth or placement of a child under four years of age in the home for the purposes of adoption; \\\\n are the primary caregiver for the child or children new to the home; \\\\n are enrolled full-time at Michigan Tech; \\\\n are in good academic standing; \\\\n have completed at least one full-time semester at Michigan Tech. \\\\n If both parents are enrolled as graduate students, only one will normally be eligible for parental accommodation. Requests for consideration of an accommodation for both parents must be made in writing to the  Graduate School a minimum of six weeks before the planned parental accommodation period. If the request is approved, both parents must then submit a formal application for parental accommodation. \\\\n International graduate students who are attending Michigan Tech full-time with a student visa or exchange visitor visa are encouraged to consult with International Programs and Services about their plans during the parental accommodation period to ensure compliance with immigration regulations.",
    Q4_INSURANCE:"Yes; not in stipend.",
    Q5_FRIENDLY:"Information Unavailable",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"3M who have that title.  There are also 1M/2F who have other titles but similar duties.",
    UPDATED_ON:"Thu Sep 27 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"19",
    TENURE_WOMEN_NUM:"1",
    GRAD_TOTAL_NUM:"49",
    GRAD_WOMEN_NUM:"15",
    POSTDOC_TOTAL_NUM:"10",
    POSTDOC_WOMEN_NUM:"6",
    WOMEN_GROUP:"Information Unavailable",
    PHYSICS_GSA:"Yes we do have a Graduate Student Government. http://gsg.mtu.edu/",
    OTHER_STUGRP:"Society of Physics students. http://sps.students.mtu.edu/ \\\\n Nanotech Innovations. http://nano.enterprise.mtu.edu/advisor/",
    UNDERGRA_WOMCONF:"Yes; 2018",
    SITE_VISIT:"We did host a visit for Women and Minorities in February 2018",
    CONTACT_INFO:"Ravi Pandey Professor and Department Chair pandey@mtu.edu" },
  { ID:"214",
    FULL_NAME:"Mark S. Boley",
    EMAIL:"mfmsb@wiu.edu",
    INSTITUTION:"Western Illinois University",
    DEPARTMENT:"",
    Q1_FACULTY:"8 male, 2 female",
    Q2_STUDENT:"30 graduate students, 21 male, 9 female",
    Q3_POLICY:"We do not have a formal policy as such, but because we are a small program and know all of our graduate students personally, we have allowed leave time on numerous occasions to our students for family and personal issues.",
    Q4_INSURANCE:"Yes, and yes.",
    Q5_FRIENDLY:"All of our graduate students are personally known by the graduate faculty, all of whom are concerned about the personal and individual success of each of our students.  All of our graduate students are considered an integral part of our departmental staff and instructional effort in helping our undergraduate students.  Our graduate students participate in all of our departmental colloquium and public outreach events and know our faculty on a first-name basis.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"no postdoctoral associates",
    UPDATED_ON:"Fri Sep 14 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"7",
    TENURE_WOMEN_NUM:"3",
    GRAD_TOTAL_NUM:"19",
    GRAD_WOMEN_NUM:"7",
    POSTDOC_TOTAL_NUM:"0",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"Yes.   Actually it is a part of WIU Women in Science Group.",
    PHYSICS_GSA:"Yes it is part of our WIU Physics Club.",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"physics@wiu.edu" },
  { ID:"215",
    FULL_NAME:"Ori Ganor",
    EMAIL:"origa@socrates.berkeley.edu",
    INSTITUTION:"University of California, Berkeley",
    DEPARTMENT:"",
    Q1_FACULTY:"67/7",
    Q2_STUDENT:"254/50",
    Q3_POLICY:"Yes. Details on the family leave policy and information on leave programs for student parents can be found at: https://grad.berkeley.edu/financial/families/",
    Q4_INSURANCE:"All eligible registered undergraduate and graduate students at UC Berkeley are automatically enrolled in the Berkeley Student Health Insurance Plan (SHIP; https://uhs.berkeley.edu/ship). Voluntary SHIP plans are available for the dependents of students enrolled in SHIP (https://uhs.berkeley.edu/insurance/insurance-dependents).",
    Q5_FRIENDLY:"The physics department at UC Berkeley has a strong ongoing commitment to diversity. Faculty, staff, and students together are involved in our efforts to increase the representation of women and under-represented minorities. We have several women faculty role models who are renowned leading researchers in their respective fields. We have an active diversity and outreach faculty committee, which works in cooperation with and support from the Chair, the Dean, and campus-wide and university-wide programs. Diversity and the status of women and ethnic minorities at UC Berkeley is overseen by the vice-Chancellor for Equity, Diversity and Inclusion, and a Senate committee devoted to monitoring and improving this aspect of campus-life. Furthermore, the division of Mathematical and Physical Sciences has a dedicated director of Diversity Programs. Students are actively involved in these efforts. In particular, the Society of Women in the Physical Sciences(http://swps.berkeley.edu/) is a student-run organization that has taken the lead in many activities and programs related to diversity and outreach, with emphasis on creating a welcoming climate for women. The UC Berkeley campus has a wide array of student organizations (http://students.berkeley.edu/osl/studentorganizations.asp) with many opportunities to be involved in and to contribute to diversity and representation of women and ethnic minorities. We strive to eliminate any form of discrimination based on gender or sexual identity. In particular, Berkeley has several helpful resources for the Lesbian, Gay, Bisexual and Transgender community (LGBT). UC Berkeley SHIP insurance also provides benefits for transgender students, including hormone therapy and gender confirmation (reassignment) surgery (https://uhs.berkeley.edu/insurance/ship-benefits/insurance-benefits-transgender-students). The Gender Equity Resource Center on campus is a UC Berkeley campus community center committed to fostering an inclusive Cal experience for all, with special services for women, including special services for the Lesbian, Gay, Bisexual and Transgender community. See http://students.berkeley.edu/osl/geneq.asp for more details.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"94/6",
    UPDATED_ON:"Wed Sep 26 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"63",
    TENURE_WOMEN_NUM:"8",
    GRAD_TOTAL_NUM:"263",
    GRAD_WOMEN_NUM:"50",
    POSTDOC_TOTAL_NUM:"90",
    POSTDOC_WOMEN_NUM:"23",
    WOMEN_GROUP:"The Society of Women in the Physical Sciences (SWPS); https://swps.berkeley.edu/",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"IGenSpectrum is a student group at UC Berkeley dedicated to improving the visibility and professional preparation of LGBT physicists. https://igenspectrum.berkeley.edu/",
    UNDERGRA_WOMCONF:"Yes. UC Berkeley hosted the West Coast Conference for Undergraduate Women in Physics (CUWiP) in 2014.",
    SITE_VISIT:"Yes. The physics department at UC Berkeley hosted a gender equity site visit in April 2010.",
    CONTACT_INFO:"Ori Ganor" },
  { ID:"216",
    FULL_NAME:"Ronald Snell",
    EMAIL:"snell@astro.umass.edu",
    INSTITUTION:"University of Massachusetts, Amherst",
    DEPARTMENT:"Astronomy",
    Q1_FACULTY:"14 faculty, 3 female and 11 male",
    Q2_STUDENT:"26 graduate students, 8 female, 18 male",
    Q3_POLICY:"UMass has a Personal Leave Policy that covers all areas - family, health, unexpected circumstances ...",
    Q4_INSURANCE:"Yes, family health insurance is available for  graduate students.  It is not included in the stipend. however, if the student is employed as a TA or RA at least half-time, the student pays only 10% of the cost. ",
    Q5_FRIENDLY:"The Department and University are striving to increase the number of female faculty and graduate students.  The University is part of the Five College Astronomy Department where faculty from the four colleges in the consortium,  ncluding two  women's colleges, are members of the graduate  faculty (thus the graduate faculty consists of 14 male and 5  female faculty).",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"8 postdocs, 2 female and 6 male",
    UPDATED_ON:"14-AUG-09",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"218",
    FULL_NAME:"Jesus Pando",
    EMAIL:"jpando@depaul.edu",
    INSTITUTION:"DePaul University",
    DEPARTMENT:"",
    Q1_FACULTY:"7, 5 Male, 2 Female",
    Q2_STUDENT:"12,  7 Male, 5 Female",
    Q3_POLICY:"While the department is very supportive of graduate students necessity to take a family leave, there is no policy in place.  We only have a small terminal Masters program and we support only 6 students.  The issue has never arisen.",
    Q4_INSURANCE:"DePaul University makes available a student health insurance plan for DePaul students and their eligible dependents.  The plan helps keep health care affordable and gives students the freedom to choose any doctor or other health care provider when they need care and still receive benefits under the Plan. For 2008/2009, the annual premium for Plan I, the Basic Plan was $1,839. The annual premium for Plan II, the Comprehensive Plan, was $2,075. Coverage for spouses and dependents is also available under the plan. The cost is not included in the stipend.",
    Q5_FRIENDLY:"We are a small, student centered department.  The faculty is dedicated first and foremost to the success of the student.  Two of our seven tenure/tenure-track faculty our female and almost half of our graduate students are female.  Our program offers a bridge to the PhD and can be exactly what is needed for female students to get acclimated to the still male dominated world of Physics. While we do not offer a lot of financial support in general, we do provide an environment in which female students are able to thrive.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"0",
    UPDATED_ON:"28-SEP-09",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"219",
    FULL_NAME:"Kenneth Burgi",
    EMAIL:"Kenneth.Burgi@afit.edu",
    INSTITUTION:"Air Force Institute of Technology",
    DEPARTMENT:"Engineering Physics",
    Q1_FACULTY:"17 male/2 female",
    Q2_STUDENT:"63 male/12 female",
    Q3_POLICY:"Yes; federal government benefits apply.",
    Q4_INSURANCE:"Yes, health benefits are provided.",
    Q5_FRIENDLY:"The Engineering Physics Department at the Air Force Institute of Technology offers MS and PhD graduate degrees in Applied Physics, Optical Sciences and Engineering, Materials Science, Nuclear Engineering, and Combating Weapons of Mass Destruction.  Research support is given to all students; class sizes are small; computing and experimental lab facilities are state-of-the-art. For women who want a challenging and rewarding career pursuing research in areas vital to the DoD, there is no better place for graduate study!  Individualized ed plans allow civilian students to tailor their course selections to match research interests.  All faculty engaged in research; pro-family culture.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"5 male/0 female",
    UPDATED_ON:"16-SEP-19",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"220",
    FULL_NAME:"Reinhold Blumel",
    EMAIL:"rblumel@wesleyan.edu",
    INSTITUTION:"Wesleyan University",
    DEPARTMENT:"",
    Q1_FACULTY:"8/2",
    Q2_STUDENT:"9/4",
    Q3_POLICY:"6 weeks of family leave",
    Q4_INSURANCE:"The department pays for health insurance ",
    Q5_FRIENDLY:"Caring environment; small program emphasizes individual research mentoring; liberal arts environment heightens our awareness of diversity. Our women graduates find good jobs. Our two most recent graduates hold post doctoral positions at NIST and Harvard. We have a new physics faulty member as of July 1, 2015 in Biophysics who is seeking graduate students for research opportunities.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"4/1",
    UPDATED_ON:"24-MAR-15",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"221",
    FULL_NAME:"Douglas  Singleton",
    EMAIL:"dougs@mail.fresnostate.edu",
    INSTITUTION:"California State University, Fresno",
    DEPARTMENT:"",
    Q1_FACULTY:"12 total tenure or tenure track.  10 Male and 2 female.",
    Q2_STUDENT:"15 total graduate students. 13 Male and 2 female",
    Q3_POLICY:"There is no family leave policy for graduate students.",
    Q4_INSURANCE:"There is no family health insurance for graduate students.",
    Q5_FRIENDLY:"We are a small but active department with research in condensed matter physics, high energy physics (theory and experimental), medical physics, computational physics, astronomy/astrophysics/cosmology, and physics outreach. The cost of living here relatively cheap.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"1 post doc, male.",
    UPDATED_ON:"Sat Sep 15 2018",
    IS_ACTIVE:"true",
    PLANS:"We plan to send student to the local CUWiP conferences.",
    TENURE_TOTAL_NUM:"11",
    TENURE_WOMEN_NUM:"1",
    GRAD_TOTAL_NUM:"15",
    GRAD_WOMEN_NUM:"4",
    POSTDOC_TOTAL_NUM:"1",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"No",
    PHYSICS_GSA:"No",
    OTHER_STUGRP:"We have a Society of Physics Students chapter.",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No",
    CONTACT_INFO:"dougs@mail.fresnostate.edu" },
  { ID:"222",
    FULL_NAME:"Ken Kelton",
    EMAIL:"kfk@wustl.edu",
    INSTITUTION:"Washington University",
    DEPARTMENT:"Physics & Astronomy",
    Q1_FACULTY:"There are 27 tenured or tenure-track faculty.  One is female.",
    Q2_STUDENT:"The total number of graduate students is 85.  There are 61 men and 24 women.",
    Q3_POLICY:"The Child Leave policy of the Graduate School allows students to receive their normal stipend for 34 working days.  Additional time off without pay for up to eight weeks is normally granted by the Graduate School with permission from the department in which the student is enrolled.  To obtain these benefits, students should maintain full-time student status, either by registering for at least nine credit hours (such as Independent Study) or as Continuing Students.  For longer leave periods students should renew registration as Non-Resident Candidates, but the continuation of Health Insurance coverage must be arranged directly with the University's insurance provider (without a University subsidy) or elsewhere.   All students have access to a child care and elder care referral program, which is supported by Washington University.  Students may also apply for a child care subsidy that is designed to help financially stressed Ph.D students at Washington University.  ",
    Q4_INSURANCE:"Family health insurance is available.  The Graduate School covers 90% of the cost for the student's insurance.  Insurance for the spouse/domestic partner and dependents is available at additional cost.",
    Q5_FRIENDLY:"The percentage of women in our graduate program is 28%, which is above the national average.  Strong faculty mentoring leads to a very high percentage of our student succeeding in the graduate program.  Over the last ten years, 49 women have been admitted to our PhD program; 17 received their PhD, 8 have left and 24 are still in the program.   Of interest to all our students, we feel that our department is very supportive, open and friendly, encouraging interactions between students and faculty from different research groups through activities such as the graduate student seminar and Friday lunch barbeques, both of which are subsidized by departmental funds.  We offer many exciting opportunities to work with an internationally known faculty, two of whom are members of the National Academy of Sciences.  Our faculty and students are engaged in cutting-edge experimental and theoretical research in many areas of condensed matter/materials, biological and high energy/astrophysics.  Finally, the area around Washington University is very pleasant, favorably enhancing the graduate student's experience.  Adjacent on the east side of the university is Forest Park, containing several museums, one of the best zoos in the world, and numerous trails for jogging, biking or walking.  The Loop, located about four blocks north of Washington University, is home to many interesting restaurants, and live music can be heard in restaurants, bars and often on the streets.  ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"Total of 12, 4 females and 8 males",
    UPDATED_ON:"13-OCT-09",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"223",
    FULL_NAME:"Padmaja Guggilla",
    EMAIL:"padmaja.guggilla@aamu.edu",
    INSTITUTION:"Alabama A&M University",
    DEPARTMENT:"",
    Q1_FACULTY:"11 tenure-track or tenured faculty- 8 male and 3 female",
    Q2_STUDENT:"19 graduate students",
    Q3_POLICY:"A first-time leave of absence of one semester only will normally be granted upon request for students who qualify and will not require an application for readmission to the university",
    Q4_INSURANCE:"No.",
    Q5_FRIENDLY:"1. Excellence in education and a scholarly environment in which inquiring and discriminating minds may be nourished. \\\\n 2. Friendly staff and faculty and great campus on the hill. \\\\n 3. A traditional HBCU producing the maximum number of African American graduates. \\\\n 4. Integration of state-of-the-art technology into all aspects of University functions.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"1",
    UPDATED_ON:"Thu Sep 12 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"7",
    TENURE_WOMEN_NUM:"1",
    GRAD_TOTAL_NUM:"18",
    GRAD_WOMEN_NUM:"10",
    POSTDOC_TOTAL_NUM:"0",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"No",
    PHYSICS_GSA:"No",
    OTHER_STUGRP:"SPS (Society for Physics Students)",
    UNDERGRA_WOMCONF:"no",
    SITE_VISIT:"no",
    CONTACT_INFO:"Dr. Padmaja Guggilla Professor and Interim Chair of Physics padmaja.guggilla@aamu.edu" },
  { ID:"224",
    FULL_NAME:"Kristina Cibuzar",
    EMAIL:"cibuz009@umn.edu",
    INSTITUTION:"University of Minnesota Twin Cities",
    DEPARTMENT:"",
    Q1_FACULTY:"Physics 40 faculty, 35 tenured, 5 tenure track.  There aer 38 male faculty and 2 female (tenured)faculty.",
    Q2_STUDENT:"130 graduate students 110 male/20 female",
    Q3_POLICY:"Yes, there is a family leave policy available to graduate students with a 50% time appointment.",
    Q4_INSURANCE:"Family health insurance is available to students with graduate assistantships and fellowships. ",
    Q5_FRIENDLY:"The School of Physics and Astronomy at the University of Minnesota had a Climate for Women in Physics site visit on March 11, 2003.  At the School of Physics and Astronomy, the physics faculty and staff are dedicated to the success of all students  Students have the opportunity for flexible degrees, including combining physics with other research areas.  We actively recruit students from small colleges as well as large universities.  Senior women graduate students have developed a mentorship program.  It's founder having received a university award recognizing its value and impact on women students beginning their academic career.  The College created a Graduate Student Science and Engineering Women's group that sponsors a women's issue seminar series, providing networking between disciplines, as well as sponsoring social activities.  In addition, the activities of the physics women's group is encouraged and financially supported by the department.  ",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"24 post doctoral associates 21 male/3 female",
    UPDATED_ON:"26-SEP-18",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"225",
    FULL_NAME:"Carolyn MacDonald",
    EMAIL:"c.macdonald@albany.edu",
    INSTITUTION:"University at Albany, SUNY",
    DEPARTMENT:"",
    Q1_FACULTY:"12/1",
    Q2_STUDENT:"29/15",
    Q3_POLICY:"Yes, there is family leave, and flexible work assignments",
    Q4_INSURANCE:"Student health insurance is included; family health insurance is extra.",
    Q5_FRIENDLY:"The department only admits students whom it expects to succeed and then works with students to accommodate their needs.  The environment is friendly to all students.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"1/0",
    UPDATED_ON:"Thu Oct 17 2019",
    IS_ACTIVE:"true",
    PLANS:"The UAlbany physics department has a growing women in physics group, and the university has a new scientista chapter.",
    TENURE_TOTAL_NUM:"16",
    TENURE_WOMEN_NUM:"2",
    GRAD_TOTAL_NUM:"42",
    GRAD_WOMEN_NUM:"10",
    POSTDOC_TOTAL_NUM:"5",
    POSTDOC_WOMEN_NUM:"3",
    WOMEN_GROUP:"Yes, https://www.facebook.com/pg/ualbanyphysics/posts/?ref=page_internal",
    PHYSICS_GSA:"yes, as part of the GSO (see below)",
    OTHER_STUGRP:"University graduate student organization",
    UNDERGRA_WOMCONF:"No, but we have workshops for high school women, and a new scientista chapter",
    SITE_VISIT:"No",
    CONTACT_INFO:"Carolyn MacDonald, cmacdonald@albany.edu" },
  { ID:"227",
    FULL_NAME:"Patrick Kenealy",
    EMAIL:"kenealyp@csulb.edu",
    INSTITUTION:"California State University Long Beach",
    DEPARTMENT:"",
    Q1_FACULTY:"10 male , 2 female   T-TT faculty",
    Q2_STUDENT:"44 male/ 4 female",
    Q3_POLICY:"Not with pay",
    Q4_INSURANCE:"Health insurance is included for full time TA/GAs.",
    Q5_FRIENDLY:"Our two current female faculty members are excellent role models and mentors for women, and our programs have had very strong female participation at the both graduate and undergraduate levels. In 2010, we had 9 B.S. degrees and 17 (!) M.S. degrees with research theses, 6 of whom were women. To assess this, please go to  http://www.csulb.edu/depts/physics/news/newsletters/documents/PhysicsNewsletterCSULongBeach6-15-2010.pdf  ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"none",
    UPDATED_ON:"14-OCT-10",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"228",
    FULL_NAME:"Jim Feagin, chair",
    EMAIL:"jfeagin@fullerton.edu",
    INSTITUTION:"California State University Fullerton",
    DEPARTMENT:"",
    Q1_FACULTY:"9 faculty, 2 female",
    Q2_STUDENT:"10 total, 1 female",
    Q3_POLICY:"no",
    Q4_INSURANCE:"no",
    Q5_FRIENDLY:"We are a small and friendly department where faculty, staff, and students know each other well and enjoy interacting and socializing in and out of the classroom and lab. We take pride in mentoring our students toward career paths in the courses we teach and with their involvement in our own research. We offer several awards and scholarships each year derived from the longtime generosity of our friends of the department. Please visit our website for a better and live overview physics.fullerton.edu.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"1 postdoc, male",
    UPDATED_ON:"01-JUN-11",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"229",
    FULL_NAME:"Lok Lewyanvoon",
    EMAIL:"lok.lewyanvoon@wright.edu",
    INSTITUTION:"Wright State University",
    DEPARTMENT:"",
    Q1_FACULTY:"11/4",
    Q2_STUDENT:"14/2",
    Q3_POLICY:"No",
    Q4_INSURANCE:"No",
    Q5_FRIENDLY:"Higher than national average of female vs male faculty. Mentoring of female students.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"1/0",
    UPDATED_ON:"01-JUN-11",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"230",
    FULL_NAME:"George Miller",
    EMAIL:"gpmiller@utulsa.edu",
    INSTITUTION:"The University of Tulsa",
    DEPARTMENT:"Physics & Engineering Physics",
    Q1_FACULTY:"7,7/0",
    Q2_STUDENT:"8, 6/2",
    Q3_POLICY:"yes",
    Q4_INSURANCE:"yes",
    Q5_FRIENDLY:"Small, friendly university and department. Relative new, graduate programs with a history of successfully mentoring undergraduate women students. Previously ranked in the top ten departments  in % of graduating females at the BS.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"2, 1/1",
    UPDATED_ON:"Fri Sep 14 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"7",
    TENURE_WOMEN_NUM:"1",
    GRAD_TOTAL_NUM:"13",
    GRAD_WOMEN_NUM:"1",
    POSTDOC_TOTAL_NUM:"0",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"No",
    PHYSICS_GSA:"https://utulsa.edu/?student-org=graduate-student-association-gsa",
    OTHER_STUGRP:"Student Physics Society (combines both graduate & undergraduates) A list of student groups can be found at https://utulsa.edu/student-organizations/",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No",
    CONTACT_INFO:"George P Miller gpmiller@utulsa.edu" },
  { ID:"231",
    FULL_NAME:"Alec Habig",
    EMAIL:"ahabig@umn.edu",
    INSTITUTION:"University of Minnesota Duluth",
    DEPARTMENT:"",
    Q1_FACULTY:"8 faculty, 7 tenured, all male.",
    Q2_STUDENT:"11 male, 1 female",
    Q3_POLICY:"Yes, there is a family leave policy available to graduate students with a 50% time appointment.",
    Q4_INSURANCE:"Family health insurance is available to students with graduate assistantships and fellowships.  It is not part of the stipend but is very reasonably priced.",
    Q5_FRIENDLY:"We are small enough to be very flexible and accommodating, and would love for someone with this interest to help us shape our future department.  Women have been having success in our program - contact us with specific question, or if you want to compare notes with people who are already here. Something else to note:  We haven't been able to search for a tenure-track position in years, but three of our recent term faculty hires are women, so we're doing what we can on faculty gender equity.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"1 female",
    UPDATED_ON:"Thu Sep 12 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"8",
    TENURE_WOMEN_NUM:"0",
    GRAD_TOTAL_NUM:"16",
    GRAD_WOMEN_NUM:"4",
    POSTDOC_TOTAL_NUM:"0",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"No",
    PHYSICS_GSA:"No,",
    OTHER_STUGRP:"There is a Grad Student Association (not just physics), but no website.  One of our graduating MS students (in 2019) helped form it (she happened to be female). There is an active Physics Club/SPS chapter, which includes grad students: https://sites.google.com/d.umn.edu/physics-club/home",
    UNDERGRA_WOMCONF:"Not here in Duluth, but the UofM system is hosting one in 2020 in Minneapolis.",
    SITE_VISIT:"No.",
    CONTACT_INFO:"Alec Habig (ahabig@umn.edu) is the Director of Graduate Studies for UMD Physics." },
  { ID:"232",
    FULL_NAME:"Alex Weiss",
    EMAIL:"weiss@uta.edu",
    INSTITUTION:"University of Texas at Arlington",
    DEPARTMENT:"",
    Q1_FACULTY:"21 Faculty 1 female 20 male",
    Q2_STUDENT:"49 Graduate Students 14 Female 35 Male",
    Q3_POLICY:"No",
    Q4_INSURANCE:"Yes, there is family health insurance available. No, it is not included in the stipend.",
    Q5_FRIENDLY:"We have outstanding female faculty members and post docs.  We have several pairs of married couples both of whom are in our graduate program. We have a high percentage of female graduate students (>28%).",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"14 Doctoral Associates 9 Male 5 Female",
    UPDATED_ON:"01-JUN-11",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"233",
    FULL_NAME:"Jerrie D. McCurry",
    EMAIL:"jerried@uab.edu",
    INSTITUTION:"University of Alabama at Birmingham",
    DEPARTMENT:"",
    Q1_FACULTY:"Male = 15 Female =2",
    Q2_STUDENT:"Male = 28 Female = 8",
    Q3_POLICY:" Graduate students entitled to the following short-term leaves of absence per calendar year.  Leave requires advance notification and approval by your supervisor. 15 days of paid leave of absence 3 days of paid sick leave Parental leave (with pay) 30 consecutive days per calendar year upon the birth or adoption of a child ",
    Q4_INSURANCE:"Single coverage is paid for by the Department for Graduate assistships.  Family coverage is offered but to be paid for by the student.",
    Q5_FRIENDLY:"NSF- Advance Institution",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"Male = 2 Female = 1",
    UPDATED_ON:"06-JUN-11",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"234",
    FULL_NAME:"Kay Kinoshita",
    EMAIL:"kay.kinoshita@uc.edu",
    INSTITUTION:"University of Cincinnati",
    DEPARTMENT:"",
    Q1_FACULTY:"28/3",
    Q2_STUDENT:"65/17",
    Q3_POLICY:"yes, up to one year break in degree program",
    Q4_INSURANCE:"yes, partially subsidized by stipend",
    Q5_FRIENDLY:"The faculty in the Department of Physics at the University of Cincinnati work hard to provide a congenial environment for all students.  The faculty include two female full professors, one of whom has been the Head.  More than one third of our graduate students are women.  The rate of satisfaction among graduates is high, and the university's ranking by international students is near the top among U.S. institutions.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"13/2",
    UPDATED_ON:"Fri Sep 21 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"21",
    TENURE_WOMEN_NUM:"2",
    GRAD_TOTAL_NUM:"49",
    GRAD_WOMEN_NUM:"18",
    POSTDOC_TOTAL_NUM:"14",
    POSTDOC_WOMEN_NUM:"3",
    WOMEN_GROUP:"Yes",
    PHYSICS_GSA:"Yes",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No",
    CONTACT_INFO:"" },
  { ID:"235",
    FULL_NAME:"Juliette W Ioup",
    EMAIL:"jioup@uno.edu",
    INSTITUTION:"University of New Orleans",
    DEPARTMENT:"",
    Q1_FACULTY:"7 male 2 female",
    Q2_STUDENT:"PhD in Engineering and Applied Science (students home based in Physics): 16 male, 5 female Master's in Applied Physics:  9 male 0 female  current incoming fall 2011: 3 male 1 female",
    Q3_POLICY:"no",
    Q4_INSURANCE:"student insurance",
    Q5_FRIENDLY:"Going back more than 50 years, our Department has a record of being extraordinarily receptive to female students and faculty.  For one period that records were kept, 25% of our Master's degree graduates were women, and women are always well-represented among our undergraduates.  The Department participates in the Engineering and Applied Science PhD Program, in which women are a significant fraction.  The Department has a highly student-friendly and student-supportive attitude for all students, including those who are women and/or underrepresented minorities.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"",
    UPDATED_ON:"Fri Oct 05 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"5",
    TENURE_WOMEN_NUM:"1",
    GRAD_TOTAL_NUM:"30",
    GRAD_WOMEN_NUM:"7",
    POSTDOC_TOTAL_NUM:"0",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"no",
    PHYSICS_GSA:"not specifically for graduate students.  The UNO Physics Club includes undergrads and graduate students with an interest in Physics, from any department.",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"no",
    SITE_VISIT:"no",
    CONTACT_INFO:"Dr. Juliette W. Ioup, jioup@uno.edu" },
  { ID:"236",
    FULL_NAME:"Joy Sircar",
    EMAIL:"jsircar@seas.harvard.edu",
    INSTITUTION:"Harvard University School of Engineering and Applied Sciences (SEAS)",
    DEPARTMENT:"Applied Physics",
    Q1_FACULTY:"39/5",
    Q2_STUDENT:"124/40",
    Q3_POLICY:"Not explicitly. A family leave would come under the Non-Resident Status as a Leave of Absence status. A student registered on a Leave of Absence must contact UHS Member Services to request the BCBS or UHS insurance option. Students would pay for insurance coverage on their own.",
    Q4_INSURANCE:"It is available, but not included in the stipend. ",
    Q5_FRIENDLY:"Strictly speaking, the current organization of SEAS has no departments: Applied Physics is one area of many in SEAS that provides a multi-dimensional, collaborative environment for teaching and learning - and this environment has an important role in making SEAS female-friendly. It is an environment that is conducive to, and encourages students with diverse interests to meet, take classes together and to collaborate on their research. Students also have access to 12 junior and tenured women faculty, one of whom is the Dean of SEAS. Some very important and vibrant organizations, run by women graduate student provide important opportunities for meeting, mentoring, providing career advice: these organizations include HGWISE (Harvard Graduate Women In Science and Engineering) and Women in Physics.",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"88/29",
    UPDATED_ON:"16-JUL-11",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"237",
    FULL_NAME:"Steve Kraemer",
    EMAIL:"kraemer@cua.edu",
    INSTITUTION:"The Catholic University of America",
    DEPARTMENT:"",
    Q1_FACULTY:"10 male, 2 female",
    Q2_STUDENT:"19 male, 13 female",
    Q3_POLICY:"no",
    Q4_INSURANCE:"personal health insurance only. Included for some research assistants. all TA/s (as additional salary).",
    Q5_FRIENDLY:"We strive to make this a harassment-free environment. Our female faculty members in particular have been very open to interfacing with the female graduate students. We can't say that the program doesn't have issues, but with the rising number of female students (4/5 of the first year students are female this Fall), we realize that we have to continue to improve the environment within the department.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"no current figures. We have about 80 PhD level post-docs and staff scientists associated the the dept. Approximately 25% are female.",
    UPDATED_ON:"02-AUG-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"238",
    FULL_NAME:"Volkmar Dierolf",
    EMAIL:"vod2@lehigh.edu",
    INSTITUTION:"Lehigh University",
    DEPARTMENT:"",
    Q1_FACULTY:"16/2",
    Q2_STUDENT:"30/15",
    Q3_POLICY:"Yes, A student (either the mother or the mother's partner) who expects the birth of a child or plans the adoption of a child should consult with her/his adviser and work supervisor (e.g., department chairperson, department manager, research principal investigator) and make appropriate arrangements for the anticipated absence from the assistantship assignment. The University's policy is to not interrupt an assistantship for a parental leave up to 5 weeks, during which time the student is excused from the duties associated with the assistantship.",
    Q4_INSURANCE:"No. Subsidized Heath Insurance Plan is Student-Only",
    Q5_FRIENDLY:"Our Department sees itself as a big family and  provides a friendly atmosphere for all student. We give individualized attention to all student and their specific needs. This personalized care goes beyond the teaching and research related topics. There is great camaraderie among our very diverse graduate student body.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"7/3",
    UPDATED_ON:"Thu Sep 12 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"17",
    TENURE_WOMEN_NUM:"4",
    GRAD_TOTAL_NUM:"40",
    GRAD_WOMEN_NUM:"18",
    POSTDOC_TOTAL_NUM:"3",
    POSTDOC_WOMEN_NUM:"1",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"https://physics.cas2.lehigh.edu/physics-graduate-student-association",
    OTHER_STUGRP:"Advance Program",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No",
    CONTACT_INFO:"Marina Long, mal516@lehigh.edu" },
  { ID:"239",
    FULL_NAME:"Peter M. Frinchaboy III",
    EMAIL:"p.frinchaboy@tcu.edu",
    INSTITUTION:"Texas Christian University",
    DEPARTMENT:"",
    Q1_FACULTY:"9 male/1 female",
    Q2_STUDENT:"9 male/6 female",
    Q3_POLICY:"No",
    Q4_INSURANCE:"Yes there is family health insurance but it is not included in the stipend.",
    Q5_FRIENDLY:"",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"no postdocs",
    UPDATED_ON:"18-SEP-18",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"240",
    FULL_NAME:"Stefan Zollner",
    EMAIL:"zollner@nmsu.edu",
    INSTITUTION:"New Mexico State University",
    DEPARTMENT:"",
    Q1_FACULTY:"The department has 14 tenure-system faculty, one of them female.",
    Q2_STUDENT:"The department has 43 graduate students, of whom 13 are female.",
    Q3_POLICY:"Graduate students may apply for a leave of absence with the NMSU Graduate School. FMLA applies to graduate assistants, if they have worked a sufficient number of hours during the previous year.",
    Q4_INSURANCE:"Health insurance is available from the institution, but not required by the institution and not included in the stipend. Domestic graduate students are referred to current IRS guidelines about the individual mandate (which are in flux) and the state health exchange. International graduate students are required to have health insurance as part of their visa requirements. The institution bills this to their fee accounts.",
    Q5_FRIENDLY:"We have a good percentage of female students in our department and we are actively promoting them in their studies. As a small department, we are able to monitor the progress of all students.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"There is one (male) postdoc. The previous two postdocs were female.",
    UPDATED_ON:"Fri Sep 14 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"13",
    TENURE_WOMEN_NUM:"1",
    GRAD_TOTAL_NUM:"36",
    GRAD_WOMEN_NUM:"7",
    POSTDOC_TOTAL_NUM:"2",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"No.",
    PHYSICS_GSA:"Yes, we have a graduate student association, but they do not have a web site.",
    OTHER_STUGRP:"Society of Physics Students chapter. We also have a society of engineering physics undergraduate students.",
    UNDERGRA_WOMCONF:"No.",
    SITE_VISIT:"We may have had a climate site visit for minorities in physics.",
    CONTACT_INFO:"Stefan Zollner, Department Head, zollner@nmsu.edu." },
  { ID:"242",
    FULL_NAME:"Beth Powell",
    EMAIL:"mepowell@mailbox.sc.edu",
    INSTITUTION:"University of South Carolina",
    DEPARTMENT:"",
    Q1_FACULTY:"Male = 23 Female = 3",
    Q2_STUDENT:"Male = 32 Female = 12",
    Q3_POLICY:"A graduate student who is the primary child-care provider is eligible to take a one major term of family leave from graduate study the major term during or following the event for the birth of a child or adoption of a child less than 6 years old. The graduate student taking family leave will receive a one year extension of all academic responsibilities, including time to degree, removal of incomplete grades, and course in-date time. During family leave the graduate student will be on special enrollment (Z-status) status and must have health coverage. The student may waive out of University-sponsored health insurance if covered by other insurance or may elect to continue enrollment in the University-sponsored student health insurance plan. The student is responsible for submitting required waivers and/or for contacting the student health insurance contactor directly to enroll in the health insurance program and for paying premiums by the deadline. Students should be aware that a graduate assistantship position or other financial support may not be available upon return from family leave.",
    Q4_INSURANCE:"Yes. No.",
    Q5_FRIENDLY:"",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"Male = 7 Female = 1",
    UPDATED_ON:"Thu Sep 20 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"25",
    TENURE_WOMEN_NUM:"3",
    GRAD_TOTAL_NUM:"40",
    GRAD_WOMEN_NUM:"8",
    POSTDOC_TOTAL_NUM:"2",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"No",
    PHYSICS_GSA:"No",
    OTHER_STUGRP:"SPS",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No",
    CONTACT_INFO:"" },
  { ID:"243",
    FULL_NAME:"Natasha Hughes",
    EMAIL:"ndhughes@memphis.edu",
    INSTITUTION:"University of Memphis",
    DEPARTMENT:"",
    Q1_FACULTY:"Male =  4  Female = 3",
    Q2_STUDENT:"Male = 15 Female = 6",
    Q3_POLICY:"",
    Q4_INSURANCE:"",
    Q5_FRIENDLY:"",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"",
    UPDATED_ON:"03-AUG-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"245",
    FULL_NAME:"Jeff Urbach",
    EMAIL:"urbachj@georgetown.edu",
    INSTITUTION:"Georgetown University",
    DEPARTMENT:"",
    Q1_FACULTY:"Total 13, 9 male, 4 female",
    Q2_STUDENT:"26 total, 16 male, 10 female",
    Q3_POLICY:"Yes, there is a parental leave of absence policy: The Graduate School offers support for graduate students who need to take leave in connection with the birth of and/or full time care of a new child during their period of enrollment.  The goal in offering this support is to allow graduate students to continue their studies with as little disruption as possible. Parental leave is intended to enable the graduate student to continue to make progress toward his or her degree.  Consequently it does not grant additional semesters of funding, although under certain circumstances funding may be deferred.  Nor does it change the length of time permitted to complete degree requirements and to graduate.  This policy requires communication and cooperation in good faith between the student seeking the leave, the faculty, and the student's department. There is fairly extensive description of the terms of the policy available on the Graduate School website.",
    Q4_INSURANCE:"Yes, there is family health insurance available. It is not included in the stipend - the graduate school covers the cost of the students indivudal insurance, any additional supplemental coverage must be covered by the students.",
    Q5_FRIENDLY:"The mission of the Department of Physics of Georgetown University is the effective delivery of a rigorous physics curriculum at both the undergraduate and graduate levels and the performance of cutting edge research, with a particular emphasis on close student mentorship. This mentorship is facilitated by a relatively small faculty/student ratio (approximately one senior undergraduate and two graduate students per faculty member) and a Department culture that emphasizes faculty attention to the development of research skills and outlook at all levels. We are a relatively small faculty but with an unusually high fraction of female faculty (4 of 13 Tenure-line faculty), which we believe has been important in the recruitment and retention of an above-average number of female undergraduate and graduate students over the past decade.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"10 total, 7 male, 3 female",
    UPDATED_ON:"Sat Sep 14 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"13",
    TENURE_WOMEN_NUM:"4",
    GRAD_TOTAL_NUM:"31",
    GRAD_WOMEN_NUM:"4",
    POSTDOC_TOTAL_NUM:"9",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"Yes, there are Graduate School Student Groups (https://grad.georgetown.edu/student-life/student-groups) and a Graduate Student Government (https://www.gradgov.com/ )",
    OTHER_STUGRP:"Georgetown Women in Science and Education https://sites.google.com/georgetown.edu/gu-wise/",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No",
    CONTACT_INFO:"Department Chair Jeff Urbach, urbachj@georgetown.edu Director of Graduate Studies Dan Blair, dlb76@georgetown.edu" },
  { ID:"246",
    FULL_NAME:"Omer Blaes",
    EMAIL:"blaes@physics.ucsb.edu",
    INSTITUTION:"University of California, Santa Barbara",
    DEPARTMENT:"",
    Q1_FACULTY:"43/7",
    Q2_STUDENT:"103/22",
    Q3_POLICY:"Yes, there are several categories of leaves, including pregnancy and/or parenting needs during the first 12 months after the child's birth or placement in the home, and emergencies in the immediate family. UCSB requires continued registration of all graduate students until the student completes all degree requirements. In extraordinary circumstances however, students who have registered for and completed at least one quarter and are in good standing may petition for a leave of absence.  Students are only eligible to apply for a leave if they were registered the academic (fall, winter, spring) quarter before the requested leave. Leave is normally granted one quarter at a time, up to a maximum of three quarters during a student's graduate career. Here is a link to additional information: http://www.graddiv.ucsb.edu/forms/acad/pdf/LOA_Petition-Info.pdf. ",
    Q4_INSURANCE:"The Student Health Insurance Plan is available for all registered UCSB students and their dependents. There is a dependent benefit year deductible of $400 per covered dependent. The annual deductible applies to all services except those requiring a set-dollar copayment and services requiring no coinsurance or copayment, such as preventive exams and certain immunizations. Home Health Care is an exception and is subject to the deductible. The deductible does not apply to pharmacy services for students or dependents. Here is a link to additional detailed information: http://studenthealth.sa.ucsb.edu/CMSMedia/Documents/UCSHIP%20Policy%20Brochure.pdf.  The health insurance cost for graduate students themselves is covered in graduate student researcher and teaching assistant positions.",
    Q5_FRIENDLY:"The UCSB Physics Department is committed to excellence in research and education.  We welcome people of all backgrounds and experiences who are interested in pursuing the study and practice of physics at the highest levels. Especially in recent years, the UCSB Physics Department has taken concrete steps to improve the climate for women.  We have a very active Women in Physics group that organizes a variety of events in support of women in the Department, including the recruitment of admitted women graduate students to the program.  The Department also has a very active Diversity Committee of faculty.  More information can be found at http://www.physics.ucsb.edu/resources/diversity",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"21/7",
    UPDATED_ON:"06-AUG-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"247",
    FULL_NAME:"Sonia Paban",
    EMAIL:"paban@physics.utexas.edu",
    INSTITUTION:"The University of Texas at Austin",
    DEPARTMENT:"Physics",
    Q1_FACULTY:"49/5 (54 total)",
    Q2_STUDENT:"212/32 (244 total)",
    Q3_POLICY:"Since graduate students normally only work half time, there is no family leave through the University. However, our department has had several students who have needed leave for either family emergencies or for childbirth and the department has always accommodated their needs. ",
    Q4_INSURANCE:"Students appointed as either TAs or RAs, receive benefits through the University equivalent to classified staff, including the ability to include dependents. The student¿s costs are covered by the University and approximately 60% of the family¿s insurance is covered, depending on individual needs.",
    Q5_FRIENDLY:"",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"46",
    UPDATED_ON:"10-JAN-19",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"248",
    FULL_NAME:"Sujata Davis",
    EMAIL:"sudavis@clarku.edu",
    INSTITUTION:"Clark University",
    DEPARTMENT:"",
    Q1_FACULTY:"Five male faculty.  No female faculty.",
    Q2_STUDENT:"Seven graduate students. 4 male/3 female.",
    Q3_POLICY:"There is no formal family leave policy in place for graduate students currently.",
    Q4_INSURANCE:"Health insurance is available to the graduate student.  It is not included as part of the stipend. Clark University does not offer a family health insurance plan for dependents of students. There are 2 non-Clark University dependent coverage options available.",
    Q5_FRIENDLY:"",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"One male post-doctoral associate.",
    UPDATED_ON:"08-AUG-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"249",
    FULL_NAME:"John Laird",
    EMAIL:"laird@bgsu.edu",
    INSTITUTION:"Bowling Green State University",
    DEPARTMENT:"Physics & Astronomy",
    Q1_FACULTY:"tenured/tenure-track: 8/0 non-tenure-track:  4/2",
    Q2_STUDENT:"11/5",
    Q3_POLICY:"There is no formal family leave policy for graduate students, but the Department would certainly work with a student to arrange a leave or reduced responsibilities.",
    Q4_INSURANCE:"Yes, family coverage is available, but it is not included in the stipend.",
    Q5_FRIENDLY:"We are a small department with a highly collegial atmosphere and informal interaction of faculty and all students is strongly supported. We make every effort to support all individuals. Addressing the needs of women in particular, the University and the Department have been actively involved in increasing the representation of women in STEM fields, with efforts ranging from a Women in Science program for 7-12 grade students to recruiting undergraduate STEM and STEM-teaching students to federally-funded efforts to identify and remove obstacles to the success of female faculty.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"0/1",
    UPDATED_ON:"Fri Sep 14 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"10",
    TENURE_WOMEN_NUM:"1",
    GRAD_TOTAL_NUM:"26",
    GRAD_WOMEN_NUM:"7",
    POSTDOC_TOTAL_NUM:"3",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"We have a new Graduate Student Association in conjunction with Chemistry.",
    OTHER_STUGRP:"We have an undergraduate Society of Physics Students and a new Astronomy Club.",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"John Laird, laird@bgsu.edu" },
  { ID:"250",
    FULL_NAME:"Alfred Shapere",
    EMAIL:"shapere@pa.uky.edu",
    INSTITUTION:"University of Kentucky",
    DEPARTMENT:"Physics and Astronomy",
    Q1_FACULTY:"1 tenure-track female faculty member, 6 male. \\\\n 1 tenured female faculty member, 24 male.",
    Q2_STUDENT:"61 male / 11 female.",
    Q3_POLICY:"No.",
    Q4_INSURANCE:"Family members can be added onto a graduate student's health insurance plan but the additional cost must be paid by the student.",
    Q5_FRIENDLY:"Our department offers a collegial and supportive atmosphere for graduate students, and opportunities for professional development in several different fields of physics and astronomy. We have a good track record in mentoring female graduate students and postdocs, many of whom have gone on to faculty positions at research institutions and four-year colleges. ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"11 male / 1 female.",
    UPDATED_ON:"10-AUG-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"251",
    FULL_NAME:"Germano Iannacchione",
    EMAIL:"gsiannac@wpi.edu",
    INSTITUTION:"Worcester Polytechnic Institute",
    DEPARTMENT:"",
    Q1_FACULTY:"10 male, 2 female",
    Q2_STUDENT:"16 male, 9 female",
    Q3_POLICY:"yes, same as that for faculty though unpaid",
    Q4_INSURANCE:"yes, included as part of stipend",
    Q5_FRIENDLY:"Physics at WPI combines a rigorous research oriented graduate program with the flexibility for students to pursue their passion in their vision of Physics.  Our small size and inclusive nature creates an ideal environment for personal growth and contribution to the calling of science.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"1 male, 0 female",
    UPDATED_ON:"14-AUG-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"252",
    FULL_NAME:"Marilyn Gunner",
    EMAIL:"physdept@sci.ccny.cuny.edu",
    INSTITUTION:"The City College of the City University of New York",
    DEPARTMENT:"",
    Q1_FACULTY:"27 -- 24 male/3 female",
    Q2_STUDENT:"25 -- 20 male/5 female",
    Q3_POLICY:"no",
    Q4_INSURANCE:"Health insurance from the state of New York can be purchased if the student teaches 32.5 hours per semester.",
    Q5_FRIENDLY:"",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"",
    UPDATED_ON:"15-AUG-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"253",
    FULL_NAME:"S. Lance Cooper",
    EMAIL:"slcooper@illinois.edu",
    INSTITUTION:"University of Illinois at Urbana-Champaign",
    DEPARTMENT:"",
    Q1_FACULTY:"63 faculty, 53 male, 10 female (as of Fall 2018)",
    Q2_STUDENT:"290 grad students, 211 male, 79 female (as of Fall 2018)",
    Q3_POLICY:"Yes.  Eligible assistants (i.e., assistants holding an appointment at the time parental leave is taken) are entitled to up to six (6) weeks of parental accommodation immediately following the birth of a child or upon either the initial placement or the legal adoption of a child under 18 years of age.  The parental accommodation period may be comprised of a two-week paid Parental Leave, use of paid sick leave (13 days for each appointment year), and a personal unpaid leave of absence to make up the balance of the six weeks.",
    Q4_INSURANCE:"Yes, health insurance is provided. It is not included in the stipend, but the health insurance fee is covered by either the teaching or research assistantship that supports the student.",
    Q5_FRIENDLY:"The University of Illinois Dept. of Physics has excellent research programs in a wide range of areas (see http://physics.illinois.edu/research/), and we are a highly collegial and interactive department that provides an outstanding environment for academic study and world-class research.  We have strong institutional support for female students and other underrepresented groups, including fellowship support from the College of Engineering, involved faculty, and active Women in Physics and Physics Graduate Student Association (http://uiucpgsa.blogspot.com/) support groups.  In addition to our excellent research programs, we place a strong emphasis on innovative graduate and undergraduate teaching (http://www.aps.org/programs/education/undergrad/faculty/awardees.cfm).  Consequently, Illinois provides an outstanding training ground for graduate teaching assistants to learn advanced physics teaching methods.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"58 postdocs, 48 male, 10 female",
    UPDATED_ON:"Wed Sep 30 2020",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"66",
    TENURE_WOMEN_NUM:"14",
    GRAD_TOTAL_NUM:"321",
    GRAD_WOMEN_NUM:"82",
    POSTDOC_TOTAL_NUM:"58",
    POSTDOC_WOMEN_NUM:"10",
    WOMEN_GROUP:"Yes. Website: https://physics.illinois.edu/people/diversity_equity_inclusion_women",
    PHYSICS_GSA:"Yes. Website: http://uiucpgsa.blogspot.com/",
    OTHER_STUGRP:"We have several other groups: (1) Illinois-GPS: a graduate student mentoring group for undergraduates (https://www.facebook.com/IllinoisGPS); (2) Illinois-GPM; a graduate student peer mentoring group for 1st-year grad students; (3) Illinois Physics Graduate Student Diversity Committee",
    UNDERGRA_WOMCONF:"Yes, in 2012.",
    SITE_VISIT:"Yes.",
    CONTACT_INFO:"Lance Cooper, Associate Head for Graduate Programs; slcooper@illinois.edu" },
  { ID:"254",
    FULL_NAME:"Heidi Schellman",
    EMAIL:"kelly.carter@oregonstate.edu",
    INSTITUTION:"Oregon State University",
    DEPARTMENT:"",
    Q1_FACULTY:"12 male /4 female ",
    Q2_STUDENT:"36 male /10 female ",
    Q3_POLICY:"All eligible Graduate Assistants on a current assistantship may take up to 12 weeks of a continuous block of leave from their appointment as parental leave or (if they have been Assistants for the previous year) to care for their own serious health condition or that of a family member.  OSU will continue to pay for their health insurance during this leave period at the same level it would pay as if they had not taken leave. For parental leave, Graduate Assistants may take advantage of this leave policy once per new child.  For all other leave due to a serious health condition of the eligible Graduate Assistant or his/her family member, only one leave may be granted during their tenure at OSU.",
    Q4_INSURANCE:"Under a collective bargaining agreement with OSU, graduate student employees have access to an individual health insurance plan.  They receive 89% of the cost of the plan in addition to their stipend. The current value is about $745 per term.  Family members may be enrolled in the plan; students are responsible for the small additional cost.  (http://studenthealth.oregonstate.edu/graduate-assistant)",
    Q5_FRIENDLY:"Our department welcomes all students to an exciting research environment that provides opportunities for interdisciplinary collaboration and professional development as you begin your career in science.  The department is collegial and small enough that your talents, ambitions, and special circumstances can be individually nurtured.  We offer graduate research and teaching assistantships; our graduates do cutting-edge research and have found positions in excellent research groups and in competitive industry positions. Our teaching program is vibrant and innovative, providing plenty of opportunity to develop your physics knowledge and deepen your understanding of pedagogy. Our department is young and energetic - half of our tenured/tenure track faculty members were hired within the last 10 years.  We have 5 women faculty members, including the department head, and almost one quarter of the graduate students are female.  Students come from many different parts of the U.S., and about 20-25% are foreign.  It's a nice mix of people and cultures.  It is not uncommon for graduate students to be parents; men and women alike juggle family responsibilities with their careers.  You'll find our department supportive if this is your situation.  We have a Physicists for Inclusion in Science group that meets weekly, and it's connected to other Women in Science groups around campus. Corvallis is a safe, environmentally-conscious town that lies in the middle of the beautiful Willamette Valley.  It’s an easy drive to the ocean and the mountains, and there is lots to do locally.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"3 male /0 female ",
    UPDATED_ON:"Fri Oct 19 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"16",
    TENURE_WOMEN_NUM:"5",
    GRAD_TOTAL_NUM:"40",
    GRAD_WOMEN_NUM:"8",
    POSTDOC_TOTAL_NUM:"3",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"Physicists for Inclusion in Science grew out of the Women in Physics group, https://physics.oregonstate.edu/physicists-inclusion-science.   We support members of underrepresented groups as they pursue their careers. The group meets weekly for discussion and to organize events and activities. The group consists of students, faculty and staff in the Physics department, alumni, and other physicists on campus or in the community.",
    PHYSICS_GSA:"Yes, http://blogs.oregonstate.edu/physicsgradcommittee/",
    OTHER_STUGRP:"OSU Chemistry, http://chemistry.oregonstate.edu/isp/default.htm OSU Engineering, http://wme.engr.oregonstate.edu/",
    UNDERGRA_WOMCONF:"Yes, in 2016.",
    SITE_VISIT:"No.",
    CONTACT_INFO:"Kelly Carter, kelly.carter@oregonstate.edu" },
  { ID:"255",
    FULL_NAME:"Dr. Paul Pancella",
    EMAIL:"paul.pancella@wmich.edu",
    INSTITUTION:"Western Michigan University",
    DEPARTMENT:"",
    Q1_FACULTY:"16/2",
    Q2_STUDENT:"26/13",
    Q3_POLICY:"No.",
    Q4_INSURANCE:"Graduate students can purchase family health insurance, but it is not included in the stipend.",
    Q5_FRIENDLY:"The Department of Physics at Western Michigan University consists of 2 female (Profs. Lisa Paulius and Nora Berrah) and 16 male professors.   Since the department began offering a Ph.D. in 1990, a total of 40 Ph.D. degrees have been granted, of which 6 have been to women (15%).  In addition, a total of 90 Master's degrees have been granted, of which 23 have been to women (25%). Students interested in a female-friendly physics department should apply to WMU because 1) the department offers a variety of programs in Astrophysics, Atomic and Molecular, Condensed Matter, and Nuclear physics. 2) The department has two role models as full physics professors, Profs. Paulius and Berrah who have been in the department since 1993 and 1991, respectively. Both started as Assistant Professors and climbed the ranks to become Full Professors. 3) The department strives successfully to recruit female students. 4) The retention rate of female graduate students funded by the department is nearly 100%. 5) The department has social events such as a holiday potluck dinner and fall and spring picnics to increase the interaction between faculties and students. 6) The department offers a mentoring program to undergraduate students. Graduate students are mentored via their research advisers/thesis committee members. 7) The Chair and a department committee have organized a lounge space (Physics Student Commons) where students can meet to increase networking and work together. 8) We have recently begun a journal club that allows students to meet and discuss research topics outside their research areas to both increase their research experience and also informally socialize. 9) Informal meetings between female students and female faculty have occurred, and we are planning more frequent interactions. 10) One of the female faculty, Prof. Berrah, has experience with gender issues and was a member and chair of the APS Committee on the Status of Women in Physics (CSWP). All the professors are committed to working with students to make their experience at WMU both productive and enjoyable. ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"4/2",
    UPDATED_ON:"18-SEP-18",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"256",
    FULL_NAME:"Jessica Heslin",
    EMAIL:"heslin@princeton.edu",
    INSTITUTION:"Princeton University",
    DEPARTMENT:"",
    Q1_FACULTY:"In the coming academic year, the faculty will consist of 27 tenured and 11 untenured faculty. There are three women, two tenured and one untenured.",
    Q2_STUDENT:"As of this fall, there are 112 graduate students, 21 of whom are women.",
    Q3_POLICY:"This policy has two parts, as it seeks to acknowledge the demands on and accommodate the needs of graduate students who give birth. It also provides relief to graduate students faced with the additional time demands of being the primary caregiver for an infant during that critical first year of life. For graduate students who give birth, 12 weeks of maternity leave are provided during which the birth mother continues to receive financial support, and teaching and other academic obligations are suspended. While applications are required, the benefit is automatic. Also, birth mothers or primary caregivers who are pursuing doctorates will be eligible for an extension of academic deadlines that provides for one additional term of financial support to complete their studies for each child they give birth to or adopt. More information is available on the Childbirth Accommodation and Adoption Policy website .",
    Q4_INSURANCE:"Yes. Dependent health care insurance is available to graduate students at cost.",
    Q5_FRIENDLY:"In the Princeton Physics department, about 20% of the graduate students are female. They experience a very supportive and female-friendly environment and are actively involved with all aspects of departmental life, from the spring recital to the weekly Friday Beer to the Holiday Party. In addition, the University has a range of programs and policies that ensure that graduate students can meet the demands of personal and family life, while pursuing their academic career. Our female students play leadership roles in their research groups, and constitute half of the graduate students in one of the largest ones (experimental cosmology). Princeton female graduate students move onto successful careers in research and academia, with many of them landing faculty jobs at top Universities across the US and abroad.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"Information not available",
    UPDATED_ON:"06-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"257",
    FULL_NAME:"michael naughton",
    EMAIL:"naughton@bc.edu",
    INSTITUTION:"Boston College",
    DEPARTMENT:"",
    Q1_FACULTY:"19/1",
    Q2_STUDENT:"48/5",
    Q3_POLICY:"not to my knowledge",
    Q4_INSURANCE:"yes. yes",
    Q5_FRIENDLY:"we're constantly looking for high quality female graduate students",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"10/1",
    UPDATED_ON:"07-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"258",
    FULL_NAME:"William Hollerman",
    EMAIL:"hollerman@louisiana.edu",
    INSTITUTION:"University of Louisiana at Lafayette",
    DEPARTMENT:"",
    Q1_FACULTY:"Male - 3 \\\\n Female - 4",
    Q2_STUDENT:"Male - 4 \\\\n Female - 1",
    Q3_POLICY:"None",
    Q4_INSURANCE:"None",
    Q5_FRIENDLY:"We have historically always had a good fraction of graduate students in physics with a high ratio of female faculty.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"None",
    UPDATED_ON:"07-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"259",
    FULL_NAME:"Harry Downing",
    EMAIL:"hdowning@sfasu.edu",
    INSTITUTION:"Stephen F. Austin State University",
    DEPARTMENT:"Department of Physics, Engineering and Astronomy",
    Q1_FACULTY:"0",
    Q2_STUDENT:"2",
    Q3_POLICY:"No",
    Q4_INSURANCE:"Yes.  It is not included in the stipend, but the state does pay half on the individual involved.",
    Q5_FRIENDLY:"Exit interviews show that we have a caring, helpful, friendly faculty to all of our students, female and male. We have a welcoming environment for female students.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"0",
    UPDATED_ON:"Fri Sep 14 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"10",
    TENURE_WOMEN_NUM:"0",
    GRAD_TOTAL_NUM:"2",
    GRAD_WOMEN_NUM:"1",
    POSTDOC_TOTAL_NUM:"0",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"No",
    PHYSICS_GSA:"No",
    OTHER_STUGRP:"Sponsored by our department: Society of Physics Students Sigma Pi Sigma Engineering Student Organization",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No",
    CONTACT_INFO:"" },
  { ID:"260",
    FULL_NAME:"Dhiman Chakraborty",
    EMAIL:"dhiman@nicadd.niu.edu",
    INSTITUTION:"Northern Illinois University",
    DEPARTMENT:"",
    Q1_FACULTY:"20 (18 M + 2 F)",
    Q2_STUDENT:"36 (29 M + 7 F)",
    Q3_POLICY:"No, but the department tries to accommodate legitimate requests as sympathetically as possible.",
    Q4_INSURANCE:"Yes. No.",
    Q5_FRIENDLY:"We are a small department with a highly favorable faculty-to-student ratio, where each student can expect to get adequate personal attention. Much of our research work is conducted at nearby national labs - Fermilab and Argonne - where particular attention is paid to gender equality.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"12 (12 M + 0 F)",
    UPDATED_ON:"07-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"261",
    FULL_NAME:"Zia Smith",
    EMAIL:"zasmith@fau.edu",
    INSTITUTION:"Florida Atlantic University",
    DEPARTMENT:"",
    Q1_FACULTY:"8 Male/ 2 Female",
    Q2_STUDENT:" 29 Male/10 Female",
    Q3_POLICY:"No",
    Q4_INSURANCE:"NO",
    Q5_FRIENDLY:"The Physics Department is dedicated to cutting-edge research and teaching emersed within a multidiciplinary science environment.Our active research areas include Classical and Quantum Gravity, Astrophysics, Physics of Materials and Biological Systems, Statistical Mechanics, Neuroscience and Nonlinear Systems. The department actively recruits female candidates and is committed to the success of women in Physics.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"1 Male",
    UPDATED_ON:"07-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"262",
    FULL_NAME:"Daniel Claes",
    EMAIL:"dclaes@unl.edu",
    INSTITUTION:"University of Nebraska",
    DEPARTMENT:"",
    Q1_FACULTY:"23 male /2 female",
    Q2_STUDENT:"56 male /18 female",
    Q3_POLICY:"Graduate students are covered by the Family Medical Leave Act. Up to 12 weeks of unpaid medical leave is guaranteed to all graduate students with at least 1250 hours of work in the previous year. ",
    Q4_INSURANCE:"For individual insurance policies, 79% of the cost is covered by the University (21% or $230 annually is the responsibility of the student). Family coverage is available, purchased by students (currently $3674/spouse and $1816/each child). ",
    Q5_FRIENDLY:"Our department is enjoying an exciting period of growth. Its most recent hires and enormous success in research funding have increased the need for excellent students. This growth has included its selection as a Tier-2 computing center for CMS and the inauguration of the Diocles Extreme Light Laboratory.  Three of our most recent hires have been members of under-respresented groups, including 2 women. All are well-funded (each securing an NSF CAREER or POWRE grant, and all with additional funding from NSF, NIH, DOE, and/or NASA) and have already established strong research programs. During the past 5 years, graduate student enrollment has increased from 46 to 74. Throughout that growth, women have comprised about 25-30% of our incoming graduate students, a culturally diverse group representing 10 different countries. A short distance down the hall from the first floor classroom area, is a new 80 sq. ft. nursing station.  This was successfully lobbied for by a number of both faculty and graduate students with new families.  The new building's location places it near the on-campus daycare facility, which is open to both faculty and students.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"30 male / 4 female",
    UPDATED_ON:"07-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"263",
    FULL_NAME:"Kathleen Johnston",
    EMAIL:"johnston@latech.edu",
    INSTITUTION:"Louisiana Tech University",
    DEPARTMENT:"",
    Q1_FACULTY:"1 Female and 7 male",
    Q2_STUDENT:"12",
    Q3_POLICY:"Yes, but they must pay for it on their own.",
    Q4_INSURANCE:"Yes, but they must pay for it on their own.",
    Q5_FRIENDLY:"Our department and the College of Engineering and Sciences has worked very hard to foster a warm and friendly atmosphere for women who choose to come here.  WE have a very active women's group composed of female faculty, graduate and undergraduate students.  We meet three times every quarter for a lunch and make presentations for the group on topics important to women in the sciences and engineering.  This gives the women a chance to voice their fears, any problems, and to give advice where needed.   I have found this forum to be most helpful for me and my career.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"3",
    UPDATED_ON:"07-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"264",
    FULL_NAME:"Rex Berney",
    EMAIL:"rberney1@udayton.edu",
    INSTITUTION:"University of Dayton",
    DEPARTMENT:"Physics/Electro-Optics",
    Q1_FACULTY:"Physics - Male = 12   Female = 0 \\\\n Electro-Optics - Male = 5    Female = 0",
    Q2_STUDENT:"5 - Female     21 - Male",
    Q3_POLICY:"No",
    Q4_INSURANCE:"Yes, but it is a separate purchase. ",
    Q5_FRIENDLY:"As a Catholic and Marianist University, the students, faculty and administration are all dedicated to being as inclusive as possible.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"0",
    UPDATED_ON:"07-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"265",
    FULL_NAME:"Prabhakar Misra",
    EMAIL:"pmisra@howard.edu",
    INSTITUTION:"Howard University",
    DEPARTMENT:"Physics and Astronomy",
    Q1_FACULTY:"1 Male and 1 Female Tenure-Track \\\\n 14 Tenured Males ",
    Q2_STUDENT:"10 Males and 6 Females  ",
    Q3_POLICY:"No",
    Q4_INSURANCE:"Yes",
    Q5_FRIENDLY:"The Howard University Department of Physics and Astronomy is a relatively small Department where faculty, staff and students all know each other.  The Physics Department is a supportive environment and faculty members work one-on-one with undergraduate and graduate students.  Of the twenty (20) undergraduate Physics majors, eight (8) are female; that is 40% of the total Physics undergraduate population.  We have six (6) female graduate students and that is approximately 36% of the total number of graduate students (16).  The Department is making every effort to recruit female students and, in the future, hopefully more female faculty which will make our environment even more hospitable for females.  ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"1 Male",
    UPDATED_ON:"07-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"266",
    FULL_NAME:"David McIlroy",
    EMAIL:"dmcilroy@uidaho.edu",
    INSTITUTION:"University of Idaho",
    DEPARTMENT:"",
    Q1_FACULTY:"Three",
    Q2_STUDENT:"Ten",
    Q3_POLICY:"No",
    Q4_INSURANCE:"Yes, but not included in the stipend.",
    Q5_FRIENDLY:"The department offers and excellent environment with a larger than average female to male faculty ratio and numerous graduate students have young families. Moscow, ID, is an excellent place to live with a safe environment.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"NA",
    UPDATED_ON:"07-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"267",
    FULL_NAME:"Henk Arnoldus",
    EMAIL:"hfa1@msstate.edu",
    INSTITUTION:"Mississippi State University",
    DEPARTMENT:"Physics and Astronomy",
    Q1_FACULTY:"14/2",
    Q2_STUDENT:"37/7",
    Q3_POLICY:"No.",
    Q4_INSURANCE:"Yes.  For TA's: not included. For RA's: included",
    Q5_FRIENDLY:"The astronomy faculty in the department are 100% female, and they are the only research astronomers in the State of Mississippi.  A number of successfully graduated female students have successfully balanced completing their education with their family responsibilities.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"2/1",
    UPDATED_ON:"Fri Oct 11 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"17",
    TENURE_WOMEN_NUM:"3",
    GRAD_TOTAL_NUM:"45",
    GRAD_WOMEN_NUM:"14",
    POSTDOC_TOTAL_NUM:"3",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"no",
    PHYSICS_GSA:"yes; http://pgsa.org.msstate.edu/index.php/en/",
    OTHER_STUGRP:"Too many to mention",
    UNDERGRA_WOMCONF:"no",
    SITE_VISIT:"no",
    CONTACT_INFO:"Donna Pierce (female, astronomer) dmp149@msstate.edu" },
  { ID:"268",
    FULL_NAME:"Youwen Xu",
    EMAIL:"youwen.xu@mnsu.edu",
    INSTITUTION:"Minnesota State University, Mankato",
    DEPARTMENT:"",
    Q1_FACULTY:"9, 8 male/1 female",
    Q2_STUDENT:"4, all male",
    Q3_POLICY:"no",
    Q4_INSURANCE:"I don't know.  If there is, it is not included in the stipend",
    Q5_FRIENDLY:"We are female friendly in terms of department atmosphere.  We had several female students before, and they all had good experience here.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"0",
    UPDATED_ON:"07-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"269",
    FULL_NAME:"Michael",
    EMAIL:"msummers@gmu.edu",
    INSTITUTION:"George Mason University",
    DEPARTMENT:"",
    Q1_FACULTY:"8 female/21 male",
    Q2_STUDENT:"38 female/110 male",
    Q3_POLICY:"No",
    Q4_INSURANCE:"Yes, but it is not include in the stipend.",
    Q5_FRIENDLY:"The GMU School of Physics, Astronomy and Computational Sciences has a very large number of female faculty members at both senior and junior levels.  This creates an environment friendly and encouraging for female colleagues.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"5 male/2 female",
    UPDATED_ON:"08-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"272",
    FULL_NAME:"Bruce Wilking",
    EMAIL:"bwilking@umsl.edu",
    INSTITUTION:"University of Missouri-St. Louis",
    DEPARTMENT:"Physics and Astronomy",
    Q1_FACULTY:"6 male, 2 female",
    Q2_STUDENT:"14 male, 6 female",
    Q3_POLICY:"no",
    Q4_INSURANCE:"yes but not included",
    Q5_FRIENDLY:"We have two dynamic women scientists in the fields of astrochemistry and biophysics, one of whom is serving as the Department Chairperson",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"none at present",
    UPDATED_ON:"Fri Sep 14 2018",
    IS_ACTIVE:"true",
    PLANS:"As a small Physics Department at a small University in a State that provides little support for high ed., we are struggling to maintain our degree programs in physics.  There are no current plans to replace faculty members who have recently retired.  We continue to be encouraging of women entering the physics field as undergraduates or graduate students.  ",
    TENURE_TOTAL_NUM:"8",
    TENURE_WOMEN_NUM:"2",
    GRAD_TOTAL_NUM:"20",
    GRAD_WOMEN_NUM:"5",
    POSTDOC_TOTAL_NUM:"0",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"no",
    PHYSICS_GSA:"no",
    OTHER_STUGRP:"Physics & Astronomy Club",
    UNDERGRA_WOMCONF:"no",
    SITE_VISIT:"no",
    CONTACT_INFO:"Dr. Erika Gibb, gibbe@umsl.edu" },
  { ID:"273",
    FULL_NAME:"Stephanie Krilov",
    EMAIL:"krilov@physics.ucla.edu",
    INSTITUTION:"University of California, Los Angeles",
    DEPARTMENT:"",
    Q1_FACULTY:"65 tenured/tenure-track faculty.  Of these, 7 are female and 58 are male.",
    Q2_STUDENT:"160 graduate students, 30 female and 130 males.",
    Q3_POLICY:"Yes, we have the UCLA Childbirth Accommodation Fund for graduate student researchers (GSRs) and for fellowship holders. Six weeks of maternity leave funding are automatically granted for expectant mothers holding UCLA Fellowships, Graduate Division Endowed Fellowships or fellowships offered by academic departments and centers at UCLA.  Also, a student holding a TAship is eligible to receive up to six (6) weeks of paid leave for pregnancy, childbirth or related medical conditions for the period prior to, during and after childbirth (refer to Article 17 Leaves of the University of California and the UAW contract). Other Maternity Benefits at UCLA Research doctoral students who are undergoing childbirth or coping with other serious parenting demands are allowed additional time to meet established deadlines for passing preliminary and/or qualifying examinations and completing their dissertations. See page 23 of Standards and Procedures for Graduate Study at UCLA for more details. UCLA also offers a childcare reimbursement program for graduate students. More information can be found here: https://grad.ucla.edu/funding/working-at-ucla/childcare-reimbursement-program/",
    Q4_INSURANCE:"Yes, you can find a link here for dependent care: http://www.studenthealth.ucla.edu/Lists/ChannelContent/CustDispForm.aspx?ID=20&Title=Dependent%20Care&Channel=Insurance Fee remissions only cover health insurance for an individual student. Dependent coverage is separate from student coverage and is not covered by fee remissions and must be purchased separately.",
    Q5_FRIENDLY:"The UCLA Department of Physics and Astronomy is committed to promoting and fostering a diverse and inclusive environment of learners because we believe that diversity promotes innovation. We are dedicated to supporting and engaging faculty and students from a broad array of backgrounds and experiences to tackle some of the biggest questions in astronomy and physics. The Department strives for an environment of respect for all its members, who share the common purpose of the study of physics and astronomy. To pursue our goal of inclusiveness, we have created a Department Diversity Committee composed of faculty, students and staff whose mission is to promote a warm and welcoming culture for everyone. The Graduate Physics and Astronomy Association coordinate a peer-to-peer mentoring program, organize quarterly socials and weekly tea/coffee mingles between faculty and graduate students. We also have a Womxn in Physics and Astronomy (WiPA) group and an Outreach committee that coordinate social and educational events throughout the year. In conjunction with the UCLA Career Center, the department has been offering professional development workshops that include academic and industry career panels. As a teaching assistant, we actively promote the use of inclusive teaching practices in coordination with the Center for the Advancement of Teaching.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"47 Postdoctoral associations, 9 women and 38 men.",
    UPDATED_ON:"Fri Nov 08 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"58",
    TENURE_WOMEN_NUM:"8",
    GRAD_TOTAL_NUM:"191",
    GRAD_WOMEN_NUM:"32",
    POSTDOC_TOTAL_NUM:"47",
    POSTDOC_WOMEN_NUM:"9",
    WOMEN_GROUP:"Yes, it is called Womxn in Physics and Astronomy (WiPA): http://wipa.physics.ucla.edu/",
    PHYSICS_GSA:"Yes, http://www.pa.ucla.edu/content/physics-graduate-council",
    OTHER_STUGRP:"Astronomy Live! http://www.astro.ucla.edu/content/astronomy-live/ Women in the Physical Sciences: http://ugradwomen.pa.ucla.edu/",
    UNDERGRA_WOMCONF:"Yes, it hosted a CUWiP conference in January 2017.",
    SITE_VISIT:"Yes, it hosted an APS climate visit in December 2018.",
    CONTACT_INFO:"Stephanie Krilov - krilov@physics.ucla.edu" },
  { ID:"274",
    FULL_NAME:"Stephen Tegler",
    EMAIL:"Stephen.Tegler@nau.edu",
    INSTITUTION:"Northern Arizona University",
    DEPARTMENT:"",
    Q1_FACULTY:"8male/2female",
    Q2_STUDENT:"12male/12female",
    Q3_POLICY:"",
    Q4_INSURANCE:"",
    Q5_FRIENDLY:"Half of our graduate students are female, and two of five full-professors are female. ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"1male/1female",
    UPDATED_ON:"10-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"275",
    FULL_NAME:"Robynne Lock",
    EMAIL:"Robynne.Lock@tamuc.edu",
    INSTITUTION:"Texas A&M University-Commerce",
    DEPARTMENT:"",
    Q1_FACULTY:"8/0",
    Q2_STUDENT:"7/2",
    Q3_POLICY:"There is no formal leave policy. However, it is relatively easy to arrange temporary leaves within the department's program with the approval of advisor, graduate committee and department head.",
    Q4_INSURANCE:"Yes, if a graduate student had a full-time GA position on campus they are eligible for health insurance.  The department pays for a portion of the benefits and then GA is responsible for the other premiums.  (for example, full cost of the GA insurance is $229.00 the GA employee's portion is $47.87.",
    Q5_FRIENDLY:"We specialize in nuclear astrophysics - dense matter equation of state - and stellar astrophysics of white dwarfs and cataclysmic variables.  In addition we have a faculty member working in the area of surface physics.  ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"3/0",
    UPDATED_ON:"18-SEP-19",
    IS_ACTIVE:"true",
    PLANS:"We are a growing program.  Our plan is to focus on our departmental core strength in the field of astrophysics.  Specifically, nuclear astrophysics - dense matter equation of state - and the astrophysics of white dwarf stars and cataclysmic variables.   We plan to introduce an undergraduate concentration in astrophysics, and believe that option will encourage more female students to enroll in our program, as well as broaden the appeal of the program to female faculty applicants.  Note that well-funded applicants with a strong teaching interest may contact the department head to discuss a possible target of opportunity hire.",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"276",
    FULL_NAME:"Grant Bunker",
    EMAIL:"bunker@iit.edu",
    INSTITUTION:"Illinois Institute of Technology",
    DEPARTMENT:"",
    Q1_FACULTY:"14/1",
    Q2_STUDENT:"100/20",
    Q3_POLICY:"Illinois Tech has a policy for employees but not for graduate students.",
    Q4_INSURANCE:"Family health insurance is available, but is not included as part of the graduate stipend.",
    Q5_FRIENDLY:"We strive to create a caring environment emphasizing individuals.  Our department offers flexibility in crafting a graduate program to meet the needs of students.  All of our students receive personal attention from the tenured faculty, and are advised on a regular basis with the goal of heading-off problems before they arise. One of the three current Senior Lecturers in the department, one is female and is also currently the Associate Chair.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"5/1",
    UPDATED_ON:"Tue Oct 09 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"16",
    TENURE_WOMEN_NUM:"1",
    GRAD_TOTAL_NUM:"88",
    GRAD_WOMEN_NUM:"30",
    POSTDOC_TOTAL_NUM:"8",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"Yes, we do have a Women in Physics group.",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"Dr. Sally A. Laurent-Muehleisen (Senior Lecturer & Associate Chair): slaurent@iit.edu" },
  { ID:"277",
    FULL_NAME:"Herbert Jaeger",
    EMAIL:"jaegerh@MiamiOH.edu",
    INSTITUTION:"Miami University",
    DEPARTMENT:"",
    Q1_FACULTY:"13  (8m/5f)",
    Q2_STUDENT:"20  (18m/2f)",
    Q3_POLICY:"We do not have a family leave policy for graduate students.",
    Q4_INSURANCE:"We require students to carry health insurance and do cover a portion of the cost for it. Departments work with students on a case by case basis to accommodate them in case of family or medical needs.",
    Q5_FRIENDLY:"We are a small department, and our students are a close community.  There are many activities the students initiate (games night, SPS picnic, soccer, volley ball) and in some of these faculty participate as well.  The department is very supportive of our students.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"0",
    UPDATED_ON:"Wed Oct 10 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"11",
    TENURE_WOMEN_NUM:"2",
    GRAD_TOTAL_NUM:"21",
    GRAD_WOMEN_NUM:"2",
    POSTDOC_TOTAL_NUM:"0",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"N/A",
    PHYSICS_GSA:"https://miamioh.edu/graduate-school/about/student-life/groups-and-associations/index.html",
    OTHER_STUGRP:"Society of Physics chapter http://miamioh.edu/cas/academics/departments/physics/about/student-activities/sps/index.html",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"Yes, March 2009",
    CONTACT_INFO:"Jennifer Blue,  bluejm@MiamiOH.edu" },
  { ID:"278",
    FULL_NAME:"Sarath Witanachchi",
    EMAIL:"switanach@usf.edu",
    INSTITUTION:"University of South Florida",
    DEPARTMENT:"",
    Q1_FACULTY:"Male - 19 Female - 3 ",
    Q2_STUDENT:"Male - 69 Female - 16",
    Q3_POLICY:"There is no formal policy for family leave, however graduate students may take a semester off without affecting enrollment status. In addition, paid leave may be arranged on a case by case basis with the approval of the graduate advisor and department.",
    Q4_INSURANCE:"Individual coverage including a yearly Well Woman Exam is provided at no cost to graduate assistants. Coverage is available to immediate family members through the University, but is not included in the stipend.",
    Q5_FRIENDLY:"[This statement was composed independently by a group of six current female graduate students at various stages of their career.] Our department is committed to the success and development of women in physics, and offers research opportunities in the areas of condensed matter, optics, and biophysics, with both experimental and computational expertise in each. The applied physics program's unique industrial practicum requirement grants an equal opportunity for students to gain valuable experience in an industrial or national lab setting prior to graduation. Women make up 23% of our graduate enrollment and are actively involved in the physics community. The faculty, including a female graduate advisor, is readily accessible and easily approachable to any student to provide mentoring, advice, and address questions or concerns. A number of measures build a sense of community in the department including shared office space for graduate assistants that promotes collaboration between research groups, a weekly colloquium with a pre-lecture social time, and several family-friendly departmental gatherings throughout the year.  Among the resources for families provided by the University are family housing and an on-campus preschool available to the children of students, faculty, and staff.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"Male - 7 Female - 2",
    UPDATED_ON:"16-SEP-19",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"279",
    FULL_NAME:"Ken Eack",
    EMAIL:"keack@nmt.edu",
    INSTITUTION:"New Mexico Institute of Mining and Technology",
    DEPARTMENT:"",
    Q1_FACULTY:"Male - 8 Female - 3",
    Q2_STUDENT:"Female - 13 Male - 19",
    Q3_POLICY:"None - usually worked out with individual advisor.",
    Q4_INSURANCE:"Yes - but stipend has built in adjustment for individual insurance costs, but not family rates.",
    Q5_FRIENDLY:"Our department has had good success in and continues to actively recruit women and other minority students and faculty to our department.  We have a number of women faculty in the department that can advise on issues related to both their graduate school program and their future career.   The campus has an active Women's Resource Center which has numerous activities and seminars though the academic year at New Mexico Tech. ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"Male - 1 Female - 0",
    UPDATED_ON:"18-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"280",
    FULL_NAME:"Dr. Arthur Kosowsky",
    EMAIL:"phyast-chair@pitt.edu",
    INSTITUTION:"University of Pittsburgh",
    DEPARTMENT:"",
    Q1_FACULTY:"For 2012-13 we have the following:   Tenured: 24 male/3 female Tenure-Stream:  8 male Secnodary Appt:  1 male/1 female Adjunct Appt.:  1 male/1 female",
    Q2_STUDENT:"For 2012-13 we have a total of 95 graduate students. 78 male/17 female",
    Q3_POLICY:"Yes. Graduate Student Parental Accommodation Guidelines http://www.pitt.edu/~graduate/Grad_Parental_Accommodation_Guidlelines.pdf",
    Q4_INSURANCE:"Currently the University provides individual health insurance to graduate students with eligible academic appointments.  It is not included in the stipend for TAs/TFs/GSAs/GSRs.  Fellows are eligible to enroll and their stipends are typically increased to cover the cost of individual coverage, it is then deducted from their stipend.  For both groups, dental and vision coverage is available for a modest deduction. https://www.asgraduate.pitt.edu/student-life/health-and-wellness",
    Q5_FRIENDLY:"Female graduate students have found our department to be an egalitarian, open environment for studying physics.  Living in Pittsburgh is highly affordable, with excellent public and University transit systems (free for students) and a wide variety of cultural opportunities (music, theatre, museums, etc.)  The University of Pittsburgh Department of Physics and Astronomy has long been at the forefront in the participation of women in science;  Professor Emeritus Elizabeth U. Baranger was co-founder (with Vera Kistiakowsky) of Women in Science and Engineering.  The Department and the University have a variety of fellowship programs targeted towards female students in science, including the Mary E. Warga Predoctoral Fellowship, the Elizabeth U. Baranger Predoctoral Fellowship, The Marna Whittington Predoctoral Fellowship and the Provost's Development Fund.  More information on related activities at Pitt is available at the website of the Provost's Advisory Committee on Women's Concerns, http://www.provost.pitt.edu/pacwc/",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"At the current time, we have 8 males/2 females",
    UPDATED_ON:"Tue Sep 25 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"34",
    TENURE_WOMEN_NUM:"3",
    GRAD_TOTAL_NUM:"117",
    GRAD_WOMEN_NUM:"35",
    POSTDOC_TOTAL_NUM:"26",
    POSTDOC_WOMEN_NUM:"4",
    WOMEN_GROUP:"Not at the present time.",
    PHYSICS_GSA:"Yes, APAGS (Association of Physics and Astronomy Graduate Students. https://www.physicsandastronomy.pitt.edu/graduate/graduate-student-life",
    OTHER_STUGRP:"A&S GSO pre.asgso.pitt.edu Graduate & Professional Student Government (GPSG) gpsg.pitt.edu WISE Women in Science and Engineering",
    UNDERGRA_WOMCONF:"No,",
    SITE_VISIT:"No.",
    CONTACT_INFO:"Dr. Arthur Kosowsky - Chair phyast-chair@pitt.edu Dr. Andrew Zentner - Director of Graduate Studies  padgs@pitt.edu Ms. Leyla Hirschfeld - Graduate Administrator  lmh@pitt.edu" },
  { ID:"281",
    FULL_NAME:"Jim Gleeson",
    EMAIL:"jgleeson@kent.edu",
    INSTITUTION:"Kent State University",
    DEPARTMENT:"",
    Q1_FACULTY:"14 male and 4 female tenured/tenure track Faculty",
    Q2_STUDENT:"51 male graduate students and 21 female graduate students registered in fall 2012",
    Q3_POLICY:"",
    Q4_INSURANCE:"Health insurance for students is offered, and the University will pay approximately 2/3 of the cost of coverage for the student.  Family coverage is an additional cost to the student.",
    Q5_FRIENDLY:"Kent State University has a very diverse student population which is reflected in the Physics Department.  Ours is one of only ten physics departments in the United States where AIP reports that 25% or more of the PhD recipients during 1999-2003 were women.  Of the 35 students admitted during and since the fall 2012 term, 11 are women.  We continue to welcome and encourage women from around the world to apply to our department.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"4 male and 1 female post doctoral associates",
    UPDATED_ON:"25-SEP-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"282",
    FULL_NAME:"Jacob Roberts",
    EMAIL:"jacob.roberts@colostate.edu",
    INSTITUTION:"Colorado State University",
    DEPARTMENT:"",
    Q1_FACULTY:"20 male/3 female",
    Q2_STUDENT:"50 male/4 female",
    Q3_POLICY:"The employee is eligible for family leave if the following criteria are met: \\\\n •The employee has worked for the University for at least 12 months - this time does not need to be consecutive and includes any past employment as a student, GA, non-student hourly, classified, etc. \\\\n •The employee has worked at least 1,040 hours during the 12 months immediately preceding the first day of leave.",
    Q4_INSURANCE:"Family health insurance is not available through the university, but there are options through the county Larimer Health Connect",
    Q5_FRIENDLY:"The Physics Department encourages and supports the advancement of women in physics. We are dedicated to success for all of our students and support them in their efforts.  Many women have taken leadership roles at CSU. We are proud to have a female dean for the college of Natural Sciences, Dean Jan L. Nerger and President of the University, President Joyce McConnell.  The Women in Physics student group is active and includes involvement with graduate students.  In addition to providing a forum for women's needs in the context of getting a BS in Physics, the group is also involved in community service.  We continue to strive for ways to welcome, support, and enhance the professional development of women in physics and all groups that are underrepresented in physics.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"7 male/2 female",
    UPDATED_ON:"Mon Sep 16 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"19",
    TENURE_WOMEN_NUM:"2",
    GRAD_TOTAL_NUM:"69",
    GRAD_WOMEN_NUM:"11",
    POSTDOC_TOTAL_NUM:"6",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"Women in Physics student group: https://www.physics.colostate.edu/undergraduate-students/student-groups/women-in-physics/",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"Yes",
    CONTACT_INFO:"Jacob Roberts, Jacob.Roberts@colostate.edu" },
  { ID:"283",
    FULL_NAME:"Todd Ruskell",
    EMAIL:"truskell@mines.edu",
    INSTITUTION:"Colorado School of Mines",
    DEPARTMENT:"",
    Q1_FACULTY:"19 total, 18 male, 1 female",
    Q2_STUDENT:"76 total, 56 male, 20 female",
    Q3_POLICY:"Graduate students in thesis-based degree programs, who have full-time student status, may be eligible to request up to eight (8) weeks of parental leave. The Parental Leave Policy is designed to assist students who are primary child-care providers immediately following the birth or adoption of a child. The Policy is designed to make it possible for students to maintain full-time status in research-based degree programs while taking a leave from that program to care for their new child, and facilitate planning for continuance of their degree program. A complete description of the policy may be found at: http://bulletin.mines.edu/graduate/registrationandtuitionclassification/leaveofabsence ",
    Q4_INSURANCE:"Yes, health insurance is provided. The health insurance fee is covered by either the teaching or research assistantship that supports the student.",
    Q5_FRIENDLY:"The CSM Physics is a highly collaborative department with strengths in condensed matter, renewable energy, optical and nuclear physics (see http://physics.mines.edu/).  This spirit of collaboration readily extends to the nearby national laboratories (NOAA, NIST, NREL).  Within this environment, we take concrete steps to create an inclusive community that values diversity.  Specific examples include: Our department sponsors the activities of the Graduate Women in Physics (GWiP) club, which includes social events, luncheons and speakers.  Our department has implemented a mentoring program where graduate women are paired with a faculty mentor outside of their group.  Monthly meetings over coffee are used to provide guidance on the pitfalls of graduate study and long-term goals.  We hosted the Rocky Mountain Conference for Undergraduate Women in Physics in January 2013.  The goal of this conference was to help undergraduate women continue in physics by providing them with information about graduate school and professions in physics and access to other women in physics of all ages with whom they shared experiences, advice, and ideas. The Department is active within the campus-wide Diversity committee, the Women in Science, Engineering and Mathematics (WISEM) program, and the Society of Women Engineers (SWE).  CSM has the largest SWE chapter in the U.S. The quality of life in Golden is high and the town is well situated to enjoy both the city and the mountains.  ",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"11 total, 9 male, 2 female",
    UPDATED_ON:"14-SEP-18",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"284",
    FULL_NAME:"Edmund Bertschinger",
    EMAIL:"edbert@mit.edu",
    INSTITUTION:"MIT",
    DEPARTMENT:"",
    Q1_FACULTY:"64/5",
    Q2_STUDENT:"200/42",
    Q3_POLICY:"The MIT Physics Department funds a third month of paid maternity leave for female physics graduate students, an extension of the two months of childbirth accommodation provided for female graduate students Institute-wide.  The policy is described at http://web.mit.edu/physics/policies/dept/maternity_leave.html.",
    Q4_INSURANCE:"Individual health insurance is paid by the MIT Physics Department for RAs, TAs, and Fellows.  This is in addition to the stipend we provide.  Family health insurance is available but the graduate student must pay the difference between individual and family coverage.",
    Q5_FRIENDLY:"At MIT there is a lot of support for female grad students from other woman grad students, from the department and from the Institute. Our active graduate women's group, Graduate Women in Physics (GWIP), meets bi-weekly for dinner in a room that is dedicated for the use of female physics graduate students. The department head attends these dinners at least once a semester to address concerns of the female grad student population. During the year, the group chooses a department colloquium speaker, mentors undergraduate women, and occasionally holds retreats and professional development events. We are lucky enough to have an external donor who supports the graduate physics women through travel grants. The department hosts ongoing 'Physics Diversity and Inclusion' lunch series to foster dialogue not just with women grad students but with other underrepresented groups in the department about how to make MIT physics a welcoming place - and these dialogues set a tone of inclusion and support within the department.  MIT also has a strong graduate women's group, Graduate Women at MIT (GWAMIT), that provides resources for the larger community, hosting annual leadership and empowerment conferences, a mentoring program that pairs female academic and industry leaders with graduate students, and speakers throughout the year.  Additionally, the Dean of Graduate Education sponsors a 'Path of Professorship' workshop for MIT's graduate women, which covers the ins and outs of applying for, and being successful in, academic jobs.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"90/17",
    UPDATED_ON:"19-NOV-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"285",
    FULL_NAME:"Shari Herman",
    EMAIL:"sherman@nd.edu",
    INSTITUTION:"University of Notre Dame",
    DEPARTMENT:"",
    Q1_FACULTY:"33/5",
    Q2_STUDENT:"75/31",
    Q3_POLICY:"Is there a family leave policy for graduate students? If so, describe. The accommodation provides students with a semester (16 weeks) to adjust to new parenthood. It is not a leave of absence; it is an accommodation. Students maintain their standing as students and are eligible for financial support.  Departments are encouraged to work out specific arrangements with students, on a case-by-case basis, within the broad framework of this policy. https://graduateschool.nd.edu/assets/283258/graduate_family_accommodation_policy.pdf",
    Q4_INSURANCE:"If dependent health insurance is desired, dependents of the student have a choice of an optional plan. Only Notre Dame students may use the medical services provided at Saint Liam Hall Health Services; however, dependents may have prescriptions filled at the University Health Services pharmacy according to University policy and their plan benefits. https://uhs.nd.edu/insurance-billing/insurance-plans-rates/",
    Q5_FRIENDLY:"The Physics Department at Notre Dame strives to maintain an open, collaborative environment where students of all identities, backgrounds, and affiliations are accepted and welcomed. We have a long history of supporting female faculty and students, and our percentage of female graduate students typically exceeds the national average. All graduate students in our department benefit from the number and quality of active research groups led by women, and from the range of professional development, family support, and counseling services offered through the Graduate School. Our newly updated physics graduate program requirements include a reduced courseload and a committee mentoring structure that provides greater transparency and accountability in formal advising relationships. Female graduate students take advantage of both informal social and mentoring opportunities within the department and formal mentoring and diversity programming through the Association for Women in Science at Notre Dame (AWIS).",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"13/3",
    UPDATED_ON:"Fri Sep 20 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"44",
    TENURE_WOMEN_NUM:"7",
    GRAD_TOTAL_NUM:"110",
    GRAD_WOMEN_NUM:"45",
    POSTDOC_TOTAL_NUM:"9",
    POSTDOC_WOMEN_NUM:"4",
    WOMEN_GROUP:"No",
    PHYSICS_GSA:"GPS (Graduate Physics Society) - https://gradphysics.nd.edu/",
    OTHER_STUGRP:"AWIS (Association for Women in Physics) https://awis.nd.edu/",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"Yes.  September 2009, Gender Equity",
    CONTACT_INFO:"Shari Herman PhD Program Coordinator sherman@nd.edu" },
  { ID:"286",
    FULL_NAME:"Raymond White",
    EMAIL:"rwhite@ua.edu",
    INSTITUTION:"University of Alabama",
    DEPARTMENT:"",
    Q1_FACULTY:"23/2",
    Q2_STUDENT:"35/8",
    Q3_POLICY:"no",
    Q4_INSURANCE:"yes",
    Q5_FRIENDLY:"Our environment is supportive of women in physics and astronomy at all levels, undergraduate, graduate, postdoctoral, and faculty.  Our female faculty have recently launched a support group, ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"7/2",
    UPDATED_ON:"26-NOV-12",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"288",
    FULL_NAME:"Lauren Tompkins",
    EMAIL:"laurenat@stanford.edu",
    INSTITUTION:"Stanford University",
    DEPARTMENT:"",
    Q1_FACULTY:"Physics:  30 male and 8 female tenure/tenure-track faculty. Applied Physics:  19 male and 2 female tenure/tenure track faculty.",
    Q2_STUDENT:"Physics:  171 grad. students; 136 male and 35 female. Applied Physics:  122 grad. students; 95 male and 27 female.",
    Q3_POLICY:"Yes; please see http://gap.stanford.edu/5-9.html Stanford provides an academic accommodation period for registered and matriculated women graduate students anticipating or experiencing a birth:  http://www.stanford.edu/dept/DoR/GSH/childbirth.html",
    Q4_INSURANCE:"Yes, there is family health insurance for graduate students. Please see  http://vaden.stanford.edu/insurance/dependent.html There are subsidies for health insurance for the graduate student in some cases; please see this website for detailed information:  http://vaden.stanford.edu/insurance/subsidy.html ",
    Q5_FRIENDLY:"The Stanford Physics and Applied Physics Departments offer a rotation system for first-year graduate students, to help students find a research group that matches their interests and in which they can thrive.  Graduate students have an opportunity to work with a different research group each quarter of their first year.  Because rotation does not imply a long-term commitment on the part of the graduate student or the advisor, this system allows students to explore advisors and research areas to find a good match.  This is vitally important for a rewarding graduate experience.  Graduate students can rotate with groups in the Physics and Applied Physics Departments and in the Photon Science and Particle Physics & Astrophysics Departments at the SLAC National Accelerator Laboratory, and with groups conducting physics-related research in other departments.  Many interdisciplinary research opportunities exist at Stanford in fields such as biophysics and energy research. For more details, see the Physics Graduate Student Handbook at https://physics.stanford.edu/physics-graduate-handbook.  For Applied Physics,  see http://www.stanford.edu/dept/app-physics/cgi-bin/admissions or e-mail pperron@stanford.edu. Other resources at Stanford:  The Women's Community Center (http://studentaffairs.stanford.edu/wcc) provides programs and services designed to implement its goals of collaborative learning, community development, and social justice with regard to women's full inclusion and participation in the life of the Stanford University campus.  The Graduate Women's Network (http://www.stanford.edu/group/gwn/about.html) provides academic and social support to graduate women across disciplines at Stanford University. Through organizing programs, roundtable discussions, and other opportunities for socializing, the Graduate Women's Network is an organization committed to meeting needs specific to graduate women. Additional information about student life at Stanford, covering such subjects as health care, peer counseling, child care, employment, dependent and domestic partner benefits, fitness, disabled student services, library services, etc. can be found in the Stanford Graduate Student Handbook (http://gap.stanford.edu) and through the the Office of the Vice Provost of Graduate Education (http://vpge.stanford.edu). The VPGE sponsors career advising programs, such as Academic Chats (http://vpge.stanford.edu/programs/acad_chats.html).",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"Physics:  82 postdoctoral assocs.; 69 male and 13 female. Applied Physics:  29 postdoctoral assocs.; 23 male and 6 female.",
    UPDATED_ON:"13-SEP-19",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"289",
    FULL_NAME:"Mark Leising",
    EMAIL:"lmark@clemson.edu",
    INSTITUTION:"Clemson University",
    DEPARTMENT:"Physics and Astronomy",
    Q1_FACULTY:"20 male, 3 female",
    Q2_STUDENT:"46 male, 21 female",
    Q3_POLICY:"A graduate assistant (female or male) is eligible for up to six weeks of maternity/paternity leave. The request for maternity/paternity leave must be made to the department at least one month in advance, with notification provided by the department chair to the Dean of the Graduate School.",
    Q4_INSURANCE:"there is family health insurance available. It is not included in the stipend.",
    Q5_FRIENDLY:"Women have excellent opportunities in Physics & Astronomy at Clemson. Over the past five years, the fraction of women who have been accepted, been awarded assistantships and fellowships, passed the qualifying exam, earned PhD's, and have moved to tenure track positions have all been at least as high as those for men. We have a monthly meeting of Women in Physics, organized by women faculty, to discuss issues of interest to majors, graduate students, faculty and staff.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"7 male, 1 female",
    UPDATED_ON:"17-SEP-18",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"290",
    FULL_NAME:"Gregg B. Franklin",
    EMAIL:"gbfranklin@cmu.edu",
    INSTITUTION:"Carnegie Mellon",
    DEPARTMENT:"",
    Q1_FACULTY:"27 Male / 5 Female (+ 1 Male / 2 Female in Research Track)",
    Q2_STUDENT:"57 Male / 10 Female",
    Q3_POLICY:"Situations are handled on a case-by-case basis by the department.",
    Q4_INSURANCE:"Multiple levels of insurance are available and additional options include 2-person coverage (spouse, child, or domestic partner) and family coverage.  Insurance is not included in stipend.",
    Q5_FRIENDLY:"Carnegie Mellon's Department of Physics fosters a collegiate atmosphere and strives to help every student succeed.  Semi-weekly happy hours allow graduate students and faculty members to socialize and interactions outside of individual research groups are encouraged.   Informal women-in-physics lunches are supported by the department.  Recent faculty hires include two award-winning female researchers.  As of Spring 2013, we have 35 tenure-track and research-track faculty available to serve as research advisors and mentors; 7 of these (20%) are female.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"20 Male / 4 Female",
    UPDATED_ON:"25-JUN-13",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"291",
    FULL_NAME:"Christopher Tycner",
    EMAIL:"c.tycner@cmich.edu",
    INSTITUTION:"Central Michigan University",
    DEPARTMENT:"",
    Q1_FACULTY:"Female: 2; male: 13",
    Q2_STUDENT:"Female: 4; male: 14",
    Q3_POLICY:"A student can request a leave of absence by submitting a Leave of Absence Request form to the College of Graduate Studies. If approved, continuous registration will be waived during the approved leave period.",
    Q4_INSURANCE:"Health insurance can be purchased at an additional cost.  It is not included in the stipend.",
    Q5_FRIENDLY:"We are located in a small rural area which is safe and inexpensive and hosts several affordable child care facilities. Ours is a small and inclusive department where all students find a friendly and diverse atmosphere. To boost inclusion we encourage social activities that embrace all of our students (male, female, minorities) and provide a venue for graduate and undergraduate students to interact with faculty, get to know each other, and enhance their scholarly activities.  Furthermore, our graduate and undergraduate students, both female and male, have the opportunity to be involved in cutting-edge research from the very beginning.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"Female: 0; male: 2",
    UPDATED_ON:"Mon Oct 01 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"14",
    TENURE_WOMEN_NUM:"1",
    GRAD_TOTAL_NUM:"11",
    GRAD_WOMEN_NUM:"3",
    POSTDOC_TOTAL_NUM:"5",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"Physics graduate students do not have a separate student association, but they fully participate in the society of physics students (that includes both, undergraduate and graduate students).",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"Christopher Tycner, Chair of the Department of Physics c.tycner@cmich.edu" },
  { ID:"292",
    FULL_NAME:"Susan Blessing",
    EMAIL:"sblessing@fsu.edu",
    INSTITUTION:"Florida State University and National High Magnetic Field Laboratory",
    DEPARTMENT:"",
    Q1_FACULTY:"Total - 46 Male - 44 Female- 2 ",
    Q2_STUDENT:"Total - 141 Male - 111 Female- 30 ",
    Q3_POLICY:"Our department works with individual students on a case by case basis to provide paid leave for extended periods.",
    Q4_INSURANCE:"All graduate students must show proof of health insurance. If they purchase the university health insurance (and are on an assistantship), they are eligible to receive a health insurance subsidy.  Family coverage is available through the university.",
    Q5_FRIENDLY:"Our department hosts active experimental and theoretical research programs with strengths in nuclear, high energy, condensed matter, and astrophysics giving all students a broad range of research environments to choose from.  Graduate students are individually mentored by an academic adviser who helps them get adjusted to graduate life followed by a research adviser who helps them through their graduate research career. The Graduate Office staff and faculty Graduate Committee are proactive and carefully monitor the needs and progress of students, in close coordination with the mentors and advisers.  A Physics faculty member, Susan Blessing, directs the Women in Math, Science & Engineering (WIMSE) program (http://wimse.fsu.edu/) for undergraduate students.  Female graduate students carrying out their research with Physics faculty at the National High Magnetic Field Lab are actively involved in outreach and diversity related programs (http://www.magnet.fsu.edu/about/howwework/diversity/).  Florida State University also offers a special graduate fellowship to women in physics.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"Total - 6 Male - 5 Female- 1 ",
    UPDATED_ON:"Mon Oct 29 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"47",
    TENURE_WOMEN_NUM:"5",
    GRAD_TOTAL_NUM:"139",
    GRAD_WOMEN_NUM:"45",
    POSTDOC_TOTAL_NUM:"36",
    POSTDOC_WOMEN_NUM:"8",
    WOMEN_GROUP:"The MagLab has a women faculty group that meets during the year. That group is chaired by Drs. Laura Greene, Amy McKenna, and Dragana Popovic",
    PHYSICS_GSA:"The FSU Physics Graduate Student Association (PGSA) is very active https://fsu.campuslabs.com/engage/organization/pgsa.",
    OTHER_STUGRP:"Black Graduate Student Association: https://nolecentral.dsa.fsu.edu/organization/BGSA DreamOn at Florida State University, group for students from all disciplines. DreamOn aims to address the gender bias in science, technology, engineering, and mathematics (STEM) fields: https://nolecentral.dsa.fsu.edu/organization/DreamOn  Florida - Georgia Louis Stokes Alliance for Minority Participation: https://nolecentral.dsa.fsu.edu/organization/FGLSAMP Graduate Women in Science: https://nolecentral.dsa.fsu.edu/organization/graduatewomeninscience Hispanic Graduate Student Association: https://nolecentral.dsa.fsu.edu/organization/higsa Physics Graduate Student Association: https://nolecentral.dsa.fsu.edu/organization/pgsa",
    UNDERGRA_WOMCONF:"Yes. 2014",
    SITE_VISIT:"The National High Magnetic Field Laboratory hosted a site visit in November 2013.",
    CONTACT_INFO:"Susan Blessing sblessing@fsu.edu." },
  { ID:"293",
    FULL_NAME:"Eric Schiff",
    EMAIL:"easchiff@syr.edu",
    INSTITUTION:"Syracuse University",
    DEPARTMENT:"",
    Q1_FACULTY:"30 faculty are tenured or in tenure-track positions. 5 of these faculty are female.  (5 female + 25 male).",
    Q2_STUDENT:"We have 73 total graduate students. 10 of these students are female.",
    Q3_POLICY:"The Department has provided continued salary support for short to medium term family leave for individual students on an ad hoc basis.",
    Q4_INSURANCE:"There is family health insurance available, but it is not included in the stipend.",
    Q5_FRIENDLY:"The Department of Physics has a larger-than-average fraction of faculty who are female. There is a Women of Physics group that meets regularly; it includes undergraduate and graduate students, postdoctoral researchers, and faculty. The Women in Science and Engineering program enhances the professional development of women faculty and students in the sciences and engineering fields, with regular seminars, networking sessions, and social events. Students from all backgrounds with different levels of preparation are encouraged to succeed, through extra support, mentoring, and sometimes tutoring. The Department is very committed to the success of students from groups that are underrepresented in Physics, including women. The goal is to educate a professional community where all are welcome and recognized for their contributions.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"20 total postdoctoral associates. 5 of these associates are female. (5 female + 15 male).",
    UPDATED_ON:"19-SEP-18",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"294",
    FULL_NAME:"Pablo Laguna",
    EMAIL:"plaguna@gatech.edu",
    INSTITUTION:"Georgia Institute of Technology",
    DEPARTMENT:"",
    Q1_FACULTY:"38 faculty - 33 male / 5 female",
    Q2_STUDENT:"125 graduate students - 114 male / 11 female",
    Q3_POLICY:"There is no family leave policy for graduate students. Cases are handled on an individual basis.",
    Q4_INSURANCE:"All graduate students are required to purchase health insurance (or be covered by their parents). A family option does exist for this insurance. It is not included in the stipend.",
    Q5_FRIENDLY:"1. Our faculty is young (25% under 40) and diverse (17% female) \\\\n 2. Women have comprised over 30% of the incoming graduate student class in the past two years. \\\\n 3. You can study traditional subjects like condensed matter physics, atomic physics, astrophysics, optics, mathematical physics & general relativity \\\\n 4. You can study less traditional subjects like biophysics, non-linear dynamics, soft matter physics, quantum information, experimental particle astrophysics & physics education research \\\\n 5. You can pursue your PhD with professors in several of our top-ten ranked engineering departments \\\\n 6. You live in warm, sunny, and cosmopolitan Atlanta \\\\n 7. You start research in your second semester \\\\n 8. Our faculty is well recognized (ranked 28th according to US News) \\\\n 9. You do not need to submit a Physics GRE score and there is no Qualifying Exam. \\\\n 10. You do not pay tuition and we pay you a salary of $27,060.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"23 postdocs - 18 male / 5 female",
    UPDATED_ON:"Mon Sep 23 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"42",
    TENURE_WOMEN_NUM:"7",
    GRAD_TOTAL_NUM:"125",
    GRAD_WOMEN_NUM:"31",
    POSTDOC_TOTAL_NUM:"10",
    POSTDOC_WOMEN_NUM:"1",
    WOMEN_GROUP:"Yes, the Society for Women in Physics: http://www.wip.gatech.edu/",
    PHYSICS_GSA:"Yes, the Graduate Association of Physicists: http://gap.physics.gatech.edu/",
    OTHER_STUGRP:"We have an active SPS group: http://www.sps.physics.gatech.edu/",
    UNDERGRA_WOMCONF:"Yes, in 2016.",
    SITE_VISIT:"No.",
    CONTACT_INFO:"Prof. David Ballantyne, Associate Chair for Graduate Studies, david.ballantyne@physics.gatech.edu" },
  { ID:"296",
    FULL_NAME:"L. Rea",
    EMAIL:"lrea@lsu.edu",
    INSTITUTION:"Louisiana State University",
    DEPARTMENT:"Physics & Astronomy",
    Q1_FACULTY:"45 tenure-track or tenured faculty 6 Female 39 Male",
    Q2_STUDENT:"Total of 85 graduate students 23 Female 60 Male",
    Q3_POLICY:"",
    Q4_INSURANCE:"All students who are identified by the University as full-time students are required to pay the Student Health Fee, which is included in their tuition and fees. The mission of the Student Health Center is to provide, promote, and support services that integrate individual health, education for health, prevention of disease, clinical treatment for illness, and public health responsibilities consistent with the educational mission of the University.",
    Q5_FRIENDLY:"The Department of Physics & Astronomy at Louisiana State University is committed to embracing an atmosphere of diversity. The Department has a strong tradition of excellence and features eight female tenure-track or tenured faculty, four female instructors, with two post-doctoral associates and thirty-one female graduate students. In 2014, LSU's Department of Physics & Astronomy hosted the South-Central Conference for Undergraduate Women in Physics (CUWiP) The undergraduate female physicists networked and were inspired by both peers and established women scientists, while exploring the breadth of professional opportunities available to physics majors. Our female faculty are actively involved in CUWiP, expanding opportunities for female physicist engagement in all areas of career development. In addition, the LSU College of Science now has its first female dean, Cynthia Peterson, an LSU alumna. Dean Peterson has announced that there will be a diversity advocate on all future faculty search committees. LSU proactively cultivates and sustains a campus environment that values open dialogue, cooperation, shared responsibility, mutual respect, and cultural competence- the driving forces that enrich and enhance cutting edge research, first-rate teaching, and engaging community outreach activities. Through its Commitment to Community, LSU strives to create an inclusive, respectful, intellectually challenging climate that embraces individual difference in race, ethnicity, national origin, gender, sexual orientation, gender identity/expression, age, spirituality, socio-economic status, disability, family status, experiences, opinions, and ideas. All LSU employees are required to take Title IX and Sexual Harassment awareness training.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"Total of 28 post doctoral researchers 7 Female 21 Male",
    UPDATED_ON:"Mon Oct 07 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"49",
    TENURE_WOMEN_NUM:"8",
    GRAD_TOTAL_NUM:"99",
    GRAD_WOMEN_NUM:"31",
    POSTDOC_TOTAL_NUM:"27",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"https://physgradorg.wixsite.com/mysite",
    OTHER_STUGRP:"Society of Physics Students; https://lsu.campuslabs.com/engage/organization/sps",
    UNDERGRA_WOMCONF:"In 2014, LSU's Department of Physics & Astronomy hosted the South-Central Conference for Undergraduate Women in Physics (CUWiP).",
    SITE_VISIT:"",
    CONTACT_INFO:"Associate professor Catherine Deibel; deibel@phys.lsu.edu" },
  { ID:"297",
    FULL_NAME:"Corbin Covault",
    EMAIL:"corbin.covault@case.edu",
    INSTITUTION:"Case Western Reserve University",
    DEPARTMENT:"",
    Q1_FACULTY:"20/1",
    Q2_STUDENT:"52/8",
    Q3_POLICY:"Graduate students are entitled to paid parental leave for the adoption or birth of a child. The primary caregiver is entitled to 6 weeks leave and the other parent or domestic partner is entitled to 3 weeks leave. When both parents are supported graduate students, the leave may be used consecutively, or together. When used consecutively, both parents may be designated as the primary caregiver.",
    Q4_INSURANCE:"Dependent health insurance is available through the university. It is not included in the stipend. However, the university's dependent health insurance is expensive, and less expensive alternatives may be available.",
    Q5_FRIENDLY:"Students interested in graduate research in condensed matter physics, optics, materials physics, cosmology, particle-astrophysics, biophysics or medical imaging will find exciting research programs in those areas, in a mid-size department in which faculty work closely with students. The Physics Graduate Student Association, the Graduate Student Council, and the Women in Doctoral Studies group all foster a sense of community, provide resources for professional development, and address gender-related issues. The College of Arts and Sciences sponsors an international conference travel fellowship specifically for women. The Physics Department supports undergraduate travel to the Conferences for Undergraduate Women in Physics. We are the home of the Physics GRE Flash Cards, which we have made available since 2011, at no cost, to interested students everywhere.",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"2/2",
    UPDATED_ON:"Fri Jun 28 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"22",
    TENURE_WOMEN_NUM:"3",
    GRAD_TOTAL_NUM:"60",
    GRAD_WOMEN_NUM:"8",
    POSTDOC_TOTAL_NUM:"6",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"Yes, formed by students this year. They do not yet have a website.",
    PHYSICS_GSA:"Yes. http://www.phys.cwru.edu/~pgsa/",
    OTHER_STUGRP:"WiSER (Women in Science and Engineering Roundtable).  https://case.edu/centerforwomen/wiser",
    UNDERGRA_WOMCONF:"Yes, in 2011.",
    SITE_VISIT:"Yes.",
    CONTACT_INFO:"Corbin Covault, co-chair, Department of Physics cec8@case.edu" },
  { ID:"299",
    FULL_NAME:"Anna Bezryadina",
    EMAIL:"anna.bezryadina@csun.edu",
    INSTITUTION:"California State University Northridge",
    DEPARTMENT:"",
    Q1_FACULTY:"14/3",
    Q2_STUDENT:"27/14",
    Q3_POLICY:"No.",
    Q4_INSURANCE:"No.",
    Q5_FRIENDLY:"Our percentage of female faculty at 19% is reflective of the average percentage of women who received Ph.D.s in the past years. Our department just recently hired a fourth female faculty. All four of our women faculty are active researchers and very good mentors. One of the woman faculty runs a support group for women majors - both graduates and undergraduates. Also, one-third of post-doctoral associates are women. This year 17% of our graduate students are women, which is less than in the previous couple years. We strongly encourage women to apply to our M.S. program and join the research groups. Thus, women students though still a minority, would not feel too isolated.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"16/0",
    UPDATED_ON:"Fri Sep 13 2019",
    IS_ACTIVE:"true",
    PLANS:"Create a support group for female undergraduate and graduate students and provide information to these students about fellowships and workshops for women in Physics.",
    TENURE_TOTAL_NUM:"21",
    TENURE_WOMEN_NUM:"4",
    GRAD_TOTAL_NUM:"42",
    GRAD_WOMEN_NUM:"7",
    POSTDOC_TOTAL_NUM:"10",
    POSTDOC_WOMEN_NUM:"3",
    WOMEN_GROUP:"No",
    PHYSICS_GSA:"Society of Physics Students (SPS) club http://www.csun.edu/spsphysics/",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"No",
    CONTACT_INFO:"Anna Bezryadina anna.bezryadina@csun.edu" },
  { ID:"300",
    FULL_NAME:"Millicent Minnick",
    EMAIL:"mminnick@physics.upenn.edu",
    INSTITUTION:"University of Pennsylvania",
    DEPARTMENT:"",
    Q1_FACULTY:"37 Faculty total (7 Female) (30 Male) ",
    Q2_STUDENT:"103 Graduate students (28 Female) (75 Male)",
    Q3_POLICY:"FAMILY LEAVE OF ABSENCE POLICY https://provost.upenn.edu/policies/pennbook/2013/02/13/family-friendly-policies-for-phd-students A student in the Ph.D. program at Penn may take an unpaid Family Leave of Absence for the birth or adoption of a child, child care, or care of an immediate family member (spouse, domestic partner, child, or parent) with a serious health condition. 1. Students may take a Family Leave of Absence for one or two semesters. The student is expected to notify the graduate group chair and adviser in writing of his/her plans to take a Family Leave at an early date, so that appropriate arrangements can be made to cover any teaching/research responsibilities. 2. Family Leave",
    Q4_INSURANCE:"Only the graduate student is covered. Family health coverage is available, see: http://www.vpul.upenn.edu/shs/psipinsurance.php",
    Q5_FRIENDLY:"Female students have the opportunity to join a highly ranked graduate program including a diverse student body and close to 30% female students in our incoming classes.  In addition to a rigorous physics curriculum and world class research opportunities across campus, we offer a friendly work atmosphere and many social events throughout the calendar year.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"30 Postdoctoral fellows (5 Female) (25 Male)",
    UPDATED_ON:"Tue Oct 09 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"40",
    TENURE_WOMEN_NUM:"6",
    GRAD_TOTAL_NUM:"103",
    GRAD_WOMEN_NUM:"26",
    POSTDOC_TOTAL_NUM:"59",
    POSTDOC_WOMEN_NUM:"10",
    WOMEN_GROUP:"http://pennwip.weebly.com/",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"Diversity and Inclusion in Physics at Penn (DIP) https://sites.google.com/view/dip-penn/Graduate \\\\n Professional Student Association (GAPSA)  (http://www.gapsa.upenn.edu) \\\\n School of Arts and Sciences Government (SASGov)  (http://www.sasgov.sas.upenn.edu)",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"Millicent Minnick, Graduate Coordinator mminnick@physics.upenn.edu \\\\n Josh Klein, Graduate Chair jrk@hep.upenn.edu" },
  { ID:"301",
    FULL_NAME:"Donna Hammer",
    EMAIL:"dhammer@umd.edu",
    INSTITUTION:"University of Maryland, College Park",
    DEPARTMENT:"",
    Q1_FACULTY:"58/8",
    Q2_STUDENT:"168/34",
    Q3_POLICY:"Yes, there is a Parental Accommodation policy. Full time graduate students are able to request up to 6 weeks of parental accommodation, during which time coursework and attendance will be deferred. The student may also choose to extend their academic deadlines by one semester.  ",
    Q4_INSURANCE:"Graduate students employed as graduate assistants are eligible for state-subsidized health insurance. Graduate students without an assistantship may purchase a plan through the University-sponsored health insurance program with UnitedHealthcare. Coverage is also available for spouses and children.",
    Q5_FRIENDLY:"The University of Maryland boasts one of the largest physics departments in the nation and has numerous partnerships with research facilities around the Washington, DC area. Our faculty members are involved in research in more than 30 areas of physics, including some of today's most cutting edge topics. Our flexible Ph.D. program allows students to tailor their coursework and get involved in research that suits their interests. All of our graduate students are supported through graduate assistantships or grants. \\\\n The University of Maryland's Physics Department values our female faculty, staff, and students and is committed to creating an inclusive environment and recruiting more women. The Department hosted the 2014 CUWiP and attended the 2015 CUWiP to provide information about our graduate program to prospective students. GRAD-MAP (Graduate Resources Advancing Diversity with Maryland Astronomy and Physics) connects minority serving institutions with graduate and faculty researchers at the University of Maryland. \\\\n The Department’s Women in Physics group provides a welcoming environment for female members of the Physics community at the University of Maryland by including undergraduates, graduate students, post-docs, faculty, and staff of all genders. They developed a mentoring program to foster supportive relationships between current and new graduate students, host regular professional development lunches, and organize other professional development, social, and outreach events. \\\\n In addition, the UMD Physics Department has several ongoing initiatives to improve departmental climate for all members of the community, including an active Society of Physics Students, outreach opportunities, and a student-run Graduate Committee. The Graduate Committee runs a mentoring program for first-year graduate students, helps strengthen graduate student advising relationships, and supports TA experiences.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"108/19",
    UPDATED_ON:"23-OCT-15",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"302",
    FULL_NAME:"Frank Krennrich",
    EMAIL:"krennrich@iastate.edu",
    INSTITUTION:"Iowa State University",
    DEPARTMENT:"Physics and Astronomy",
    Q1_FACULTY:"35/5",
    Q2_STUDENT:"89/11",
    Q3_POLICY:"Iowa State University provides graduate assistants and postdocs with short term-funding in connection with the arrival of new children.  Specifically, the academic home college of the graduate assistant and the graduate college provide funding for up to six weeks to temporarily replace the normal mission-oriented funding.  Following this bridge funding period, graduate assistants and postdocs are allowed to return to their original appointment.",
    Q4_INSURANCE:"Graduate assistants with an appointment of one quarter time or more receive self-only health insurance coverage as a benefit of employment.  However, graduate assistants may also enroll their lawful spouse or domestic partner, and unmarried dependent children under age of 26. A portion of of the monthly premium will be paid by the graduate assistant's paycheck.",
    Q5_FRIENDLY:"Iowa State University has a long tradition of being a woman friendly institution of higher education. When Iowa State College opened its doors in 1858 it was open to both men and women: in 1869 over 20% of the students were female. Outstanding alumna include Carrie Lane Chapman Catt, who is recognized as one of the key leaders of the American women's suffrage movement.  Over 140 years later, the Department of Physics and Astronomy offers a welcoming and friendly environment for learning and research for students of different socio-economic, cultural backgrounds and gender.  Departmental research includes condensed matter physics and is closely linked to  a world-class research center, the Ames Laboratory, a Department of Energy national laboratory.  Our research also covers work in astronomy/astrophysics, particle astrophysics, biophysics, high-energy physics and nuclear physics.  Our international faculty from 19 different countries, a large graduate student population and over 30 postdoctoral associates provide a culturally diverse and intellectually stimulating environment.   The Ames — Des Moines metropolitan area offers college town living nearby a larger city. Ames itself combines small-town living with big city recreation, sporting and cultural activities. Ames has hundreds of acres of parks, numerous bike paths, and cultural festivals and celebrations and has been ranked the 9th best places to live in the nation (Money magazine 2010).",
    Q6_SITEVISIT:"Yes",
    Q7_POSTDOC:"27/6",
    UPDATED_ON:"Thu Sep 12 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"37",
    TENURE_WOMEN_NUM:"6",
    GRAD_TOTAL_NUM:"89",
    GRAD_WOMEN_NUM:"14",
    POSTDOC_TOTAL_NUM:"27",
    POSTDOC_WOMEN_NUM:"5",
    WOMEN_GROUP:"ISU Society of Women in Physics and Astronomy Club (SWIPA) https://www.physastro.iastate.edu/ugrad/orgs/women-in-physics-and-astronomy-club",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"Iowa State University Physics and Astronomy Club https://www.physastro.iastate.edu/ugrad/orgs/club",
    UNDERGRA_WOMCONF:"Yes, in 2018.",
    SITE_VISIT:"No.",
    CONTACT_INFO:"Prof. Marzia Rosati mrosati@iastate.edu" },
  { ID:"303",
    FULL_NAME:"Marcel den Nijs",
    EMAIL:"london@uw.edu",
    INSTITUTION:"University of Washington ",
    DEPARTMENT:"Physics",
    Q1_FACULTY:"49 total with 39 male and 6 female",
    Q2_STUDENT:"148 with 113 male and 35 female",
    Q3_POLICY:"For eligible TA/RA/SA see https://www.washington.edu/admin/hr/laborrel/contracts/uaw/contract/a16.html for specifics.",
    Q4_INSURANCE:"Family may enroll for the graduate student insurance plan (GAIP). The student premiums are covered in full by the University if they are an eligible TA/RA/SA's. Eligible dependents (spouse, same sex domestic partner, and children) have their premiums partially covered by the University. (see https://www.washington.edu/admin/hr/benefits/insure/gaip/)",
    Q5_FRIENDLY:"The University of Washington Department of Physics graduate program provides wide ranging opportunities in both experiment and theory.  Particular strengths include a strong combined experimental and theoretical effort in quantum matter, with special expertise in 2-dimensional materials and development of model qubits, a broad experimental program in fundamental symmetries and particles, including searches for dark matter as well as strong ties to CERN, and a long-standing program in physics education research.  The department has strong overlap with the Institute for Nuclear Theory and UW's Department of Astronomy, with whom it shares a building.  The department maintains strong interdisciplinary efforts across campus, including several faculty with joint appointments in engineering as well as adjunct faculty in related departments who supervise physics doctoral students.  The department provides a well-established mentoring program for first-year students and an active physics graduate student council and career development organization.",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"39 with 33 male and 6 female",
    UPDATED_ON:"Fri Oct 04 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"44",
    TENURE_WOMEN_NUM:"5",
    GRAD_TOTAL_NUM:"150",
    GRAD_WOMEN_NUM:"36",
    POSTDOC_TOTAL_NUM:"36",
    POSTDOC_WOMEN_NUM:"11",
    WOMEN_GROUP:"Physicists for Inclusion & Equity https://sites.uw.edu/piequity/",
    PHYSICS_GSA:"PGSC (Physics Graduate Student Council)  https://phys.washington.edu/committees/pgsc",
    OTHER_STUGRP:"Directed Reading in Physics, UWDRiP https://sites.google.com/uw.edu/drip/home",
    UNDERGRA_WOMCONF:"yes in 2012 and 2019",
    SITE_VISIT:"yes in 2019",
    CONTACT_INFO:"prof Marjorie Olmstead  (Olmstead@uw.edu) prof. Marcel den Nijs (london@uw.edu)" },
  { ID:"305",
    FULL_NAME:"Eduardo Mucciolo",
    EMAIL:"mucciolo@ucf.edu",
    INSTITUTION:"University of Central Florida",
    DEPARTMENT:"",
    Q1_FACULTY:"38 tenure-line faculty: 34 male / 4 female",
    Q2_STUDENT:"94 graduate students: 64 male / 30 female",
    Q3_POLICY:"Yes.The Parental Leave program is designed to assist graduate assistants on existing assistantship agreements during pregnancy or immediately after the birth or adoption of their infant child. The mother may choose to use up to six weeks of leave for pregnancy and/or maternity needs. The spouse or partner may choose to use up to six weeks of leave to assist in the care of the newborn child and the child's mother during the postpartum period. Graduate assistants who have assumed parenthood through the adoption of an infant may also use this leave. This includes graduate assistants in a domestic partnership. For this leave policy, a domestic partner is defined as a same sex individual who shares a committed, mutually-dependent relationship. During the approved parental leave, the student will retain student status and all privileges of an enrolled student. Approved parental leave is paid leave for up to six weeks but may be a shorter period, depending on the student’s graduate assistantship agreement(s). The student’s assistantship status will be maintained during the leave, including paid tuition remission and health insurance (if the student accepted this coverage offered by the College of Graduate Studies). Prior to the leave, the student is expected to confer with his/her course instructors to develop plans as necessary to make up any academic work missed during the leave. Any leave for longer than the six-week period must be petitioned as a Medical Withdrawal or a Special Leave of Absence. The College of Graduate Studies will pay the assistantship stipend equal to the rate of the student’s existing assistantship agreement(s) during the approved leave period. Arrangements for this payment will be coordinated with the student’s assistantship sponsor (i.e., hiring department).",
    Q4_INSURANCE:"The College of Graduate Studies provides health insurance coverage for all graduate assistants with appointments totaling 20 hours per week (the typical TA or RA full-time workload). The health insurance can be extended to dependents, but needs paid in separate by the graduate student. It is not included in the stipend. ",
    Q5_FRIENDLY:"The department has traditionally had a larger-than-average participation of women in its graduate and undergraduate programs, current being about 32%. We have recently hired two female assistant professors, doubling the number of female tenure-line faculty. The department hosts a Physics Women Society, entirely run by female graduate students, to promote the interest of women in the department. This society provides a platform for networking, guidance, mentoring, and counseling, and organizes and host events, including talks given by female professionals, mentoring for female undergraduates, and outreach activities. In 2013 the department hosted the Southeast Conference for Undergraduate Women in Physics. UCF provides paid six-week family leaves for graduate students (for both mother and partner). The department maintains a very large and comfortable lactation room with its own restroom. UCF has a number of initiatives to support and promote the career advancement of women and their well being, such as the Center for Success of Women Faculty.  ",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"11 post-docs: 9 male / 2 female",
    UPDATED_ON:"06-APR-17",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"306",
    FULL_NAME:"Michael Hayden",
    EMAIL:"hayden@umbc.edu",
    INSTITUTION:"University of Maryland Baltimore County",
    DEPARTMENT:"",
    Q1_FACULTY:"18 male / 4 female",
    Q2_STUDENT:"39 male / 9 female",
    Q3_POLICY:"Any GA is eligible to receive a Fellowship for:    (1)  the  birth  of  a  child;  (2)  the  recent  adoption  of  a  child  under  the  age  of  six;  or  (3)  the assumption of other parenting responsibilities (e.g., foster parenting, legal guardianship) of a child under the age of six. Except for birth mothers as described below, the period of the Fellowship is six  weeks4.    During  the  Fellowship  period,    the  GA  retains  his  or  her  full  stipend  and  benefits, provides no service to the University, and5maintains enrollment as a full-time ( ≥9 credits) student.The University recognizes the need of birth mothers to respond to or to recover from the effects of  pregnancy  and/or  the  delivery  of  a  child.    If  a  birth  mother  believes  that  she  requires  a Fellowship period of more than six weeks, she must obtain a letter from her physician or other licensed health-care professional that provides (1) the nature of the need; (2) a statement that the GA cannot return to her duties for health reasons arising from the pregnancy and/or delivery; and (3) the duration of required absence beyond the initial six weeks.In all instances, the GA should discuss his or her Fellowship plans with his or her GPD and/or supervisor as soon as possible to allow for maximum collegial support.  All Fellowship requests must be approved by the Associate Dean of the Graduate School andthe GA's supervisor.  Upon request,  the  Graduate  School  will  reimburse  the  cost  of  the  GA’s  stipend  to  the  supporting department.",
    Q4_INSURANCE:"All graduate students, including GAs, are eligible to enroll in the GA health insurance program.  The Department of Physics pays all health insurance premiums for graduate students and their families.  This is a benefit in addition to their stipend.",
    Q5_FRIENDLY:"The Physics Department at UMBC is committed to the success of all admitted graduate students.  We are particularly interested in providing an environment where people from diverse backgrounds can find intellectual stimulation and work towards excellence in their field.  We have excellent health and family benefits and a commitment throughout the faculty to provide individual support and mentorship to each of our graduate students.  In addition to the four tenure track female faculty engaged in cutting edge research, we currently have seven other faculty who have mentored female graduate students through the PhD, demonstrating our broad commitment to successfully engaging and supporting female graduate students.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"",
    UPDATED_ON:"23-JUN-17",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"307",
    FULL_NAME:"Dorina",
    EMAIL:"kosztind@missouri.edu",
    INSTITUTION:"University of Missouri Columbia",
    DEPARTMENT:"Physics and Astronomy",
    Q1_FACULTY:"19/5",
    Q2_STUDENT:"37/11",
    Q3_POLICY:"",
    Q4_INSURANCE:"yes, yes.",
    Q5_FRIENDLY:"",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"",
    UPDATED_ON:"27-JUL-17",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"308",
    FULL_NAME:"Eric McKenzie",
    EMAIL:"eric@astro.umd.edu",
    INSTITUTION:"University of Maryland",
    DEPARTMENT:"Astronomy",
    Q1_FACULTY:"male: 12 female: 3",
    Q2_STUDENT:"male: 18 female: 20",
    Q3_POLICY:"Formal options for graduate students include a Parental Accommodation Policy, a Leave of Absence for childbearing or adoption, and/or a Waiver of Continuous Registration. The Parental Accommodation Policy provides a period of up to 6 weeks during which new parents may postpone completion of academic requirements. Either or both parents are eligible, including domestic partners. Students receive their regular teaching or research assistantship stipends and benefits. Students must develop plans with their instructors/adviser on how work will be completed or made up. The intent of this policy is to permit all students, including international students, to maintain their status as full-time, enrolled students. Deadlines with regard to time to degree, time to candidacy, etc. will be extended one semester per childbirth or adoption upon the request of the student. Graduate students may also take a Leave of Absence for Childbearing, Adoption, Illness or Dependent Care. Either or both parents are eligible, including domestic partners. The leave is for up to two semesters; leaves for a longer period may be approved in exceptional circumstances. Deadlines with regard to time to degree, time to candidacy, etc. will be extended by the duration of the leave. The leave is unpaid; students on leave are not registered at the University and therefore are not eligible for teaching or research assistantships or benefits. Finally, graduate students who have not yet advanced to candidacy are eligible to request a Waiver of Continuous Registration for childbirth or other reasons, allowing them to remain in the program for a semester or a year without enrolling. This time is unpaid and does not stop the time-to-degree clock. The above options may be used in combination with each other. Thus, for example, a student may apply for the benefits of the 6-week Parental Accommodation Policy in the fall, then apply for a Leave of Absence for the following 1-2 semesters. For students who are teaching or research assistants, the Time Away from Duties policy is also relevant. Parental Accommodation Policy: http://apps.gradschool.umd.edu/catalog/academic_record.htm#19 Leave of Absence: http://apps.gradschool.umd.edu/catalog/registration_policies.htm#8 Waiver of Continuous Registration: http://apps.gradschool.umd.edu/catalog/registration_policies.htm#4 Time Away from Duties: http://apps.gradschool.umd.edu/catalog/assistantship_policies.htm#6a",
    Q4_INSURANCE:"Graduate students have the University employee health care choices available to themselves and their families. The costs are included in their stipend.",
    Q5_FRIENDLY:"The UM Astronomy department combines a welcoming environment with a challenging educational program. We are committed to helping our graduate students succeed and to providing them with a broad range of research opportunities. We have an active and open social and intellectual atmosphere with over 30 female graduate students, scientists, and tenure-track faculty. Our interest in diversity and female-friendly policies is exemplified by: \\\\n 1) Our co-sponsorship and hosting of the 2009 Women in Astronomy and Space Science meeting, \\\\n 2) Our student-led Astronomy Gentleladies Network organization for mentoring of female undergraduates, \\\\n 3) Our student-led Graduate Resources Advancing Diversity with Maryland Astronomy and Physics (GRAD-MAP) program in collaboration with mid-Atlantic minority-serving institutions, and \\\\n 4) Our weekly Better Astronomy for a New Generation (BANG) seminar series, which regularly includes talks that are specifically relevant to women in astronomy.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"Postbaccalaureate researchers: 5/2 (9/13) \\\\n Postdoctoral associates: 2/3 (10/6) Research scientists: 16/3 (51/17) The values in parentheses are totals that include scientists who are employed by our department but based at NASA/Goddard.",
    UPDATED_ON:"16-NOV-17",
    IS_ACTIVE:"false",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"309",
    FULL_NAME:"Kathrin Spendier",
    EMAIL:"kspendie@uccs.edu",
    INSTITUTION:"University of Colorado - Colorado Springs",
    DEPARTMENT:"",
    Q1_FACULTY:"8 -- 6/2",
    Q2_STUDENT:"30 -- 21/9",
    Q3_POLICY:"This is treated on a case-by-case basis. Many students have had babies born while in our program.",
    Q4_INSURANCE:"N/A",
    Q5_FRIENDLY:"Our department has a higher ratio of women than many others. We notice this at conferences when we count the women in the room and most of them are from UCCS!Our department is small, dynamic, and highly-collaborative. Students and professors interact daily and work together to achieve common goals. We have world-class research laboratories and exceptional teaching and mentorship. Our students come from diverse backgrounds and are provided with excellent support when family, illness, military deployment, or work commitments affect their studies.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"4 -- 3/1",
    UPDATED_ON:"02-MAR-21",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"310",
    FULL_NAME:"Ronald Gilman",
    EMAIL:"rgilman@physics.rutgers.edu",
    INSTITUTION:"Rutgers University",
    DEPARTMENT:"Physics and Astronomy",
    Q1_FACULTY:"The Graduate Program in Physics and Astronomy includes 71 tenured or tenure-track faculty, 12 women and 59 men. Of these, 56 faculty (9 women and 47 men) are based in the Department of Physics and Astronomy, while 15 faculty (3 women and 12 men) are based in other units of Rutgers.",
    Q2_STUDENT:"During the spring 2018 term, we had 116 graduate students enrolled - 22 women and 94 men.",
    Q3_POLICY:"All TAs/GAs are by contract entitled to parental leave. There is a 6-week paid leave policy for birth mothers, to be taken consecutively at the time of birth. There is an additional 8-week parental leave policy for new parents, including new parents of adopted children. The 8 weeks do not have to be consecutive, and can be taken within 12 months of birth or adoption.",
    Q4_INSURANCE:"All enrolled students are required to have health insurance. There are three different health plans depending on whether the student has a TA/GA appointment, is a Fellow, or has no appointment or Fellowship. The 86 graduate students with TA/GA appointments in AY 17-18 had the same health insurance as other university employees including the faculty. The cost of health insurance is partly covered by the appointment, but all employees are required to cover some portion of their insurance premium. There is an option for family coverage. Fellows have a separate insurance program. Although it has not been contractually guaranteed, the Graduate School has paid the health insurance fees of students with Fellowships in recent years. There were 13 Fellows in AY 17-18. The 17 unsupported students had to pay for their own insurance out of pocket. Unless they can demonstrate other coverage, they have to purchase the University Student Health Insurance.",
    Q5_FRIENDLY:"The Rutgers Physics and Astronomy Department has a long and deep commitment to engaging and fostering the success of women in physics starting with the hiring of Professor Noémie Benczer-Koller in 1960, the first woman hired by Rutgers College in any discipline. Professor Koller received the 2010 APS Dwight Nicholson Medal for Outreach for unselfish commitment to advocating the freedom of scientists around the world and for leadership in fostering equal opportunities for women in science. Today there are 9 women faculty members in the Department, holding ranks from Assistant to Distinguished Professor to endowed Chair, many of whom are joined by their partner who holds a faculty position in the Physics and Astronomy or other departments at Rutgers. Rutgers is the State University of New Jersey, the most diverse state in the US, and therefore our undergraduate students reflect this diversity; about 30% of our undergraduate physics and astronomy majors are female and the department has a vibrant community of women engaging in a number of activities. Rutgers hosted a 2015 Conference for Undergraduate Women in Physics (CUWiP), was a co-host of the 2017 CUWiP at Princeton and participates annually in CUWiPs at other venues. Every month all of the women in the department (from undergraduate students to emerita professors) get together for tea and coffee and every semester for a luncheon hosted by senior women faculty members. Some of our students are founding members of the Women in Mathematical Sciences club, which aims to assist undergraduate women in these areas with activities such as keeping them informed of scholarships and internships, as well as teaching coding to middle school girls. The number of women in the graduate program has been generally increasing in recent years, with women taking leadership roles in the department's Graduate Students Organization. The Department and Graduate Program in Physics and Astronomy continue to enhance our commitment to the success of women in physics and astronomy and realizing a student and family friendly climate.",
    Q6_SITEVISIT:"No",
    Q7_POSTDOC:"Currently there are 51 Postdoctoral associates - 5 women and 46 men.",
    UPDATED_ON:"15-AUG-18",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"",
    TENURE_WOMEN_NUM:"",
    GRAD_TOTAL_NUM:"",
    GRAD_WOMEN_NUM:"",
    POSTDOC_TOTAL_NUM:"",
    POSTDOC_WOMEN_NUM:"",
    WOMEN_GROUP:"",
    PHYSICS_GSA:"",
    OTHER_STUGRP:"",
    UNDERGRA_WOMCONF:"",
    SITE_VISIT:"",
    CONTACT_INFO:"" },
  { ID:"311",
    FULL_NAME:"Ajay Gopinathan",
    EMAIL:"agopinathan@ucmerced.edu",
    INSTITUTION:"University of California, Merced",
    DEPARTMENT:"",
    Q1_FACULTY:"",
    Q2_STUDENT:"",
    Q3_POLICY:"Yes, UC Merced complies with the UC established policies to provide and promote a supportive workplace culture for family and medical leave accommodations (including maternity and disability) for our graduate students. UC Merced also offers a number of accommodations for graduate students with families including child care reimbursements and on-campus child care.",
    Q4_INSURANCE:"Yes. Students are able to purchase low cost dependent plans as add-ons.",
    Q5_FRIENDLY:"UC Merced is a minority-serving institution where the majority of students are Hispanic. Our department makes strong efforts to recruit from a diverse pool of applicants via events like the Society for the Advancement of Chicano/Hispanic and Native Americans in Science (SACNAS) conference and the Conferences for Undergraduate Women in Physics (CUWiP), and our involvement in the Cal-Bridge North program with the California State University system. Incoming students needing extra support can participate in the Graduate Division's Summer Bridge program. We have a particularly high proportion of female faculty and graduate students, who participate in the Women in STEM group on campus. Physics leads or participates in several federally funded centers to promote education, research, and training for underrepresented minorities: the Center for Cellular and Biomolecular Machines (NSF), the Merced nAnomaterials Center for Energy and Sensing (NASA), an NSF Research Traineeship program in Interdisciplinary Computational Graduate Education, and the Consortium for High-Energy Density Science (NNSA).",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"",
    UPDATED_ON:"Sun Jul 05 2020",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"20",
    TENURE_WOMEN_NUM:"7",
    GRAD_TOTAL_NUM:"61",
    GRAD_WOMEN_NUM:"16",
    POSTDOC_TOTAL_NUM:"6",
    POSTDOC_WOMEN_NUM:"1",
    WOMEN_GROUP:"Yes, we have an APS funded Women In Physics group",
    PHYSICS_GSA:"TEST",
    OTHER_STUGRP:"Women in STEM, http://wstem.ucmerced.edu/",
    UNDERGRA_WOMCONF:"We are hosting CuWIP 2022.",
    SITE_VISIT:"No",
    CONTACT_INFO:"Ajay Gopinathan (agopinathan@ucmerced.edu) or Mariah Gonsalez (mgonsalez2@ucmerced.edu)" },
  { ID:"313",
    FULL_NAME:"Stefan Boettcher",
    EMAIL:"stb@physics.emory.edu",
    INSTITUTION:"Emory University",
    DEPARTMENT:"",
    Q1_FACULTY:"",
    Q2_STUDENT:"",
    Q3_POLICY:"A graduate student caregiver designated as having substantial parental responsibility may be relieved of full-time graduate duties and responsibilities for up to 8 weeks after the birth or adoption of a child.  Any matriculated doctoral student in good academic standing is eligible.  Eligible students who are receiving stipend support would continue to receive this support throughout the accommodation period.  Accommodation is not a leave of absence, and students benefitting from accommodation will remain as full-time students.",
    Q4_INSURANCE:"Health insurance for graduate students is paid for. Dependents can be  added to the coverage at the students expense.",
    Q5_FRIENDLY:"(1) small department with a close-knit community where everybody knows each other. \\\\n (2) 40% of PhDs in last 5 years are female.",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"",
    UPDATED_ON:"Mon Sep 17 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"15",
    TENURE_WOMEN_NUM:"2",
    GRAD_TOTAL_NUM:"50",
    GRAD_WOMEN_NUM:"8",
    POSTDOC_TOTAL_NUM:"12",
    POSTDOC_WOMEN_NUM:"4",
    WOMEN_GROUP:"No.",
    PHYSICS_GSA:"http://www.physics.emory.edu/home/academic/graduate/student-club.html",
    OTHER_STUGRP:"NA",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"Currently (Nov. 2018)",
    CONTACT_INFO:"Stefan Boettcher (Professor and Dept. Chair) sboettc@emory.edu" },
  { ID:"314",
    FULL_NAME:"Flera Rizatdinova",
    EMAIL:"flera.rizatdinova@okstate.edu",
    INSTITUTION:"Oklahoma State University",
    DEPARTMENT:"",
    Q1_FACULTY:"",
    Q2_STUDENT:"",
    Q3_POLICY:"Yes.",
    Q4_INSURANCE:"Yes. It is included in the stipend.",
    Q5_FRIENDLY:"Our physics department is actively working to encourage a welcoming environment for women with our women-in-physics program. This program supports activities that can encourage female students to pursue a career in physics, such as inviting outstanding women physicists to give Colloquium talks targeted specifically for an undergraduate audience, monthly social gatherings of women in physics, and providing travel supports for female physics students to attend professional conferences.",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"",
    UPDATED_ON:"Thu Sep 20 2018",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"20",
    TENURE_WOMEN_NUM:"4",
    GRAD_TOTAL_NUM:"39",
    GRAD_WOMEN_NUM:"5",
    POSTDOC_TOTAL_NUM:"8",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"Yes.",
    PHYSICS_GSA:"Yes.",
    OTHER_STUGRP:"SPS (Society of Physics Students)",
    UNDERGRA_WOMCONF:"No.",
    SITE_VISIT:"No.",
    CONTACT_INFO:"Yingmei Liu, email: yingmei.liu@okstate.edu" },
  { ID:"315",
    FULL_NAME:"Mark Alford",
    EMAIL:"alford@physics.wustl.edu",
    INSTITUTION:"Washington University in St Louis",
    DEPARTMENT:"",
    Q1_FACULTY:"",
    Q2_STUDENT:"",
    Q3_POLICY:"Full-time graduate students in Arts & Sciences, including PhD students in Engineering, Business, and Social Work, may request a New Child Leave to assume care for a new child. They should maintain full-time student status. Students on new Child Leave are not expected to participate in mentored teaching or research experience for up to 60 calendar days while they receive their current stipend support. Additional time off without receiving a stipend for up to a full semester will ordinarily be granted by the Graduate School if approved by the student's Department. Unlike the leaves of absence discussed above, new child leave does not affect the student's full-time status and will not appear on the student's transcript. New child leave must be taken within the first year after the child's birth or adoption. Students should contact their department to request a New Child Leave. To whatever extent is possible, a new child leave's beginning and ending dates should coincide with those of the academic term (fall, spring, or summer).  If longer periods of leave are desired, students will be expected to apply for a Leave of Absence.  Students who receive support from external agencies should consult policies and guidelines of the sponsor.",
    Q4_INSURANCE:"All full-time domestic and international graduate students on the Danforth campus at Washington University in St. Louis, are required to have health insurance, and will be automatically enrolled in the United Healthcare (UHC) Student Resources plan through the university. It is not included in the stipend. Students may elect to cover dependents under the health or dental insurance plan.",
    Q5_FRIENDLY:"The department has an active Diversity and Inclusion committee https://physics.wustl.edu/diversity-and-inclusion which works to ensure that we offer a welcoming and inclusive climate and to attract more female and URM students to the PhD and undergraduate programs. The Physics Mentors provide a peer support group for graduate students, as well as organizing social events such as Friday barbecues and seasonal departmental picnics to keep a strong sense of community in the department.",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"",
    UPDATED_ON:"Thu Sep 26 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"24",
    TENURE_WOMEN_NUM:"2",
    GRAD_TOTAL_NUM:"75",
    GRAD_WOMEN_NUM:"19",
    POSTDOC_TOTAL_NUM:"4",
    POSTDOC_WOMEN_NUM:"1",
    WOMEN_GROUP:"There is such a group, with 64 members on the email list. It includes a mentoring program for women in the department to act as mentors to younger women in the department - grad students mentoring upperclassmen and upperclassmen mentoring lowerclassmen for example.",
    PHYSICS_GSA:"The Graduate Student Peer Mentors https://physics.wustl.edu/mentors are a great resource for students at every stage of the Masters and Ph.D. programs.",
    OTHER_STUGRP:"The Society of Physics Students runs events for undergraduates. https://sps.wustl.edu",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"Not yet, but this is under active consideration by the Diversity and Inclusion committee.",
    CONTACT_INFO:"Ralf Wessel, Director of Graduate Studies, dgs@physics.wustl.edu Sarah Akin, Grad Student Secretary, sarahj@physics.wustl.edu" },
  { ID:"316",
    FULL_NAME:"Fredrick  Olness",
    EMAIL:"olness@smu.edu",
    INSTITUTION:"Southern Methodist University",
    DEPARTMENT:"",
    Q1_FACULTY:"",
    Q2_STUDENT:"",
    Q3_POLICY:"There is not a formal family leave policy for graduate students for the College. The Department works to accommodate this on an individual case basis.",
    Q4_INSURANCE:"Health insurance is provided and paid for by the College .",
    Q5_FRIENDLY:"At SMU the physics department is small and specialized in its research focus.  The department in the last two years has been fortunate to make exceptional faculty hires that have included two women faculty members, thereby increasing the diversity of the department as a whole.",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"",
    UPDATED_ON:"Sun Sep 15 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"12",
    TENURE_WOMEN_NUM:"3",
    GRAD_TOTAL_NUM:"15",
    GRAD_WOMEN_NUM:"3",
    POSTDOC_TOTAL_NUM:"5",
    POSTDOC_WOMEN_NUM:"0",
    WOMEN_GROUP:"https://p2.smu.edu/wise/Welcome.html Women in Science & Eingineering",
    PHYSICS_GSA:"Dedman College has a Graduate Student Assembly (GSA) comprised of representatives from each of the departments in Dedman College with a graduate program. The GSA receives a portion of the student fees paid by the graduate students in Dedman College.  These funds are returned to graduate students through small grants to cover certain expenses.  More information available at: https://www.smu.edu/graduate/CurrentStudents/GSA The Department also has an active Society of Physics Students (SPS) Chapter which includes both undergraduate and graduate students.   More information on this organization is available on the web at: http://www.physics.smu.edu/~scalise/SPS/",
    OTHER_STUGRP:"The university has an active SMU Graduate Women's Organization, and more information on this is available at their website at: http://www.smugradwomen.blogspot.com/ \\\\n In addition SMU has a Women's Center.  More information can be found at: https://www.smu.edu/studentaffairs/womenandlgbtcenter",
    UNDERGRA_WOMCONF:"no",
    SITE_VISIT:"no",
    CONTACT_INFO:"http://www.physics.smu.edu/cooley/ \\\\n Jodi Cooley \\\\n <jsekula@smu.edu> \\\\n (214) 768-4687" },
  { ID:"318",
    FULL_NAME:"Vincent Rodgers",
    EMAIL:"vincent-rodgers@uiowa.edu",
    INSTITUTION:"University of IOwa",
    DEPARTMENT:"",
    Q1_FACULTY:"",
    Q2_STUDENT:"",
    Q3_POLICY:"No",
    Q4_INSURANCE:"Yes.  No",
    Q5_FRIENDLY:"Are faculty of 29 have 5 women and 1 african american.",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"",
    UPDATED_ON:"Mon Oct 14 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"29",
    TENURE_WOMEN_NUM:"5",
    GRAD_TOTAL_NUM:"71",
    GRAD_WOMEN_NUM:"11",
    POSTDOC_TOTAL_NUM:"15",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"No",
    PHYSICS_GSA:"No",
    OTHER_STUGRP:"Society of Physics Students COGS",
    UNDERGRA_WOMCONF:"No",
    SITE_VISIT:"Yes",
    CONTACT_INFO:"Vincent Rodgers \\\\n 319-335-1219 \\\\n vincent-rodgers@uiowa.edu" },
  { ID:"319",
    FULL_NAME:"Bryan Dunne",
    EMAIL:"bdunne@illinois.edu",
    INSTITUTION:"University of Illinois at Urbana-Champaign",
    DEPARTMENT:"Astronomy",
    Q1_FACULTY:"",
    Q2_STUDENT:"",
    Q3_POLICY:"Yes. Eligible assistants (i.e., assistants holding an appointment at the time parental leave is taken) are entitled to up to six (6) weeks of parental accommodation immediately following the birth of a child or upon either the initial placement or the legal adoption of a child under 18 years of age. The parental accommodation period may be comprised of a two-week paid Parental Leave, use of paid sick leave (13 days for each appointment year), and a personal unpaid leave of absence to make up the balance of the six weeks.",
    Q4_INSURANCE:"Health, dental, and vision insurance are available for graduate students and their dependents. For students with tuition waiver-generating assistantships or fellowships, most of the cost of the health insurance and all of the cost of the dental and vision insurance for the graduate student are covered. Graduate students may also voluntarily enroll dependents (spouse/domestic partner/child) for coverage.",
    Q5_FRIENDLY:"The Astronomy Department at Illinois, in collaboration with the Physics Department, offers graduate students in astronomy and astrophysics strong training in a wide range of areas related to science and engineering. Students also have ready access to observing and computing facilities for their dissertation research, and are guided by distinguished faculty. We have strong institutional support for female students and other underrepresented groups, including fellowship support from the Graduate College. We have an active community that encourages diversity, through our supportive faculty and the Society for Equity in Astronomy.",
    Q6_SITEVISIT:"",
    Q7_POSTDOC:"",
    UPDATED_ON:"Mon Oct 14 2019",
    IS_ACTIVE:"true",
    PLANS:"",
    TENURE_TOTAL_NUM:"11",
    TENURE_WOMEN_NUM:"1",
    GRAD_TOTAL_NUM:"28",
    GRAD_WOMEN_NUM:"13",
    POSTDOC_TOTAL_NUM:"2",
    POSTDOC_WOMEN_NUM:"2",
    WOMEN_GROUP:"In the University of Illinois Physics Department: https://physics.illinois.edu/people/diversity_equity_inclusion_women",
    PHYSICS_GSA:"In the University of Illinois Physics Department: http://uiucpgsa.blogspot.com/",
    OTHER_STUGRP:"The Society for Equity in Astronomy (SEA) strives to promote equity and inclusion locally in Astronomy and related fields. \\\\n https://publish.illinois.edu/womeninastro/",
    UNDERGRA_WOMCONF:"Yes, in 2012.",
    SITE_VISIT:"Yes, in 1992.",
    CONTACT_INFO:"Tony Wong, Chair of the Graduate Admissions Committee, grad-admissions@lists.astro.illinois.edu" } ];